/*!
 * Generated using the Bootstrap Customizer (https://getbootstrap.com/docs/3.4/customize/)
 */

/*!
 * Bootstrap v3.4.1 (https://getbootstrap.com/)
 * Copyright 2011-2024 Twitter, Inc.
 * Licensed under the MIT license
 */

if (typeof jQuery === 'undefined') {
  throw new Error('Bootstrap\'s JavaScript requires jQuery')
}
+function ($) {
  'use strict';
  var version = $.fn.jquery.split(' ')[0].split('.')
  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {
    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4')
  }
}(jQuery);

/* ========================================================================
 * Bootstrap: alert.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // ALERT CLASS DEFINITION
  // ======================

  var dismiss = '[data-dismiss="alert"]'
  var Alert   = function (el) {
    $(el).on('click', dismiss, this.close)
  }

  Alert.VERSION = '3.4.1'

  Alert.TRANSITION_DURATION = 150

  Alert.prototype.close = function (e) {
    var $this    = $(this)
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    selector    = selector === '#' ? [] : selector
    var $parent = $(document).find(selector)

    if (e) e.preventDefault()

    if (!$parent.length) {
      $parent = $this.closest('.alert')
    }

    $parent.trigger(e = $.Event('close.bs.alert'))

    if (e.isDefaultPrevented()) return

    $parent.removeClass('in')

    function removeElement() {
      // detach from parent, fire event then clean up data
      $parent.detach().trigger('closed.bs.alert').remove()
    }

    $.support.transition && $parent.hasClass('fade') ?
      $parent
        .one('bsTransitionEnd', removeElement)
        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
      removeElement()
  }


  // ALERT PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.alert')

      if (!data) $this.data('bs.alert', (data = new Alert(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.alert

  $.fn.alert             = Plugin
  $.fn.alert.Constructor = Alert


  // ALERT NO CONFLICT
  // =================

  $.fn.alert.noConflict = function () {
    $.fn.alert = old
    return this
  }


  // ALERT DATA-API
  // ==============

  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)

}(jQuery);

/* ========================================================================
 * Bootstrap: dropdown.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop'
  var toggle   = '[data-toggle="dropdown"]'
  var Dropdown = function (element) {
    $(element).on('click.bs.dropdown', this.toggle)
  }

  Dropdown.VERSION = '3.4.1'

  function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = selector !== '#' ? $(document).find(selector) : null

    return $parent && $parent.length ? $parent : $this.parent()
  }

  function clearMenus(e) {
    if (e && e.which === 3) return
    $(backdrop).remove()
    $(toggle).each(function () {
      var $this         = $(this)
      var $parent       = getParent($this)
      var relatedTarget = { relatedTarget: this }

      if (!$parent.hasClass('open')) return

      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return

      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this.attr('aria-expanded', 'false')
      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
    })
  }

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this)

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    clearMenus()

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $(document.createElement('div'))
          .addClass('dropdown-backdrop')
          .insertAfter($(this))
          .on('click', clearMenus)
      }

      var relatedTarget = { relatedTarget: this }
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this
        .trigger('focus')
        .attr('aria-expanded', 'true')

      $parent
        .toggleClass('open')
        .trigger($.Event('shown.bs.dropdown', relatedTarget))
    }

    return false
  }

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return

    var $this = $(this)

    e.preventDefault()
    e.stopPropagation()

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    if (!isActive && e.which != 27 || isActive && e.which == 27) {
      if (e.which == 27) $parent.find(toggle).trigger('focus')
      return $this.trigger('click')
    }

    var desc = ' li:not(.disabled):visible a'
    var $items = $parent.find('.dropdown-menu' + desc)

    if (!$items.length) return

    var index = $items.index(e.target)

    if (e.which == 38 && index > 0)                 index--         // up
    if (e.which == 40 && index < $items.length - 1) index++         // down
    if (!~index)                                    index = 0

    $items.eq(index).trigger('focus')
  }


  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.dropdown')

      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.dropdown

  $.fn.dropdown             = Plugin
  $.fn.dropdown.Constructor = Dropdown


  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on('click.bs.dropdown.data-api', clearMenus)
    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)

}(jQuery);

/* ========================================================================
 * Bootstrap: modal.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#modals
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options = options
    this.$body = $(document.body)
    this.$element = $(element)
    this.$dialog = this.$element.find('.modal-dialog')
    this.$backdrop = null
    this.isShown = null
    this.originalBodyPad = null
    this.scrollbarWidth = 0
    this.ignoreBackdropClick = false
    this.fixedContent = '.navbar-fixed-top, .navbar-fixed-bottom'

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION = '3.4.1'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element.addClass('in')

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (document !== e.target &&
          this.$element[0] !== e.target &&
          !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $(document.createElement('div'))
        .addClass('modal-backdrop ' + animate)
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    var scrollbarWidth = this.scrollbarWidth
    if (this.bodyIsOverflowing) {
      this.$body.css('padding-right', bodyPad + scrollbarWidth)
      $(this.fixedContent).each(function (index, element) {
        var actualPadding = element.style.paddingRight
        var calculatedPadding = $(element).css('padding-right')
        $(element)
          .data('padding-right', actualPadding)
          .css('padding-right', parseFloat(calculatedPadding) + scrollbarWidth + 'px')
      })
    }
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
    $(this.fixedContent).each(function (index, element) {
      var padding = $(element).data('padding-right')
      $(element).removeData('padding-right')
      element.style.paddingRight = padding ? padding : ''
    })
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this = $(this)
      var data = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this = $(this)
    var href = $this.attr('href')
    var target = $this.attr('data-target') ||
      (href && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7

    var $target = $(document).find(target)
    var option = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: tooltip.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict';

  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn']

  var uriAttrs = [
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
  ]

  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i

  var DefaultWhitelist = {
    // Global attributes allowed on any supplied element below.
    '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
    a: ['target', 'href', 'title', 'rel'],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: ['src', 'alt', 'title', 'width', 'height'],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
  }

  /**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */
  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi

  /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */
  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i

  function allowedAttribute(attr, allowedAttributeList) {
    var attrName = attr.nodeName.toLowerCase()

    if ($.inArray(attrName, allowedAttributeList) !== -1) {
      if ($.inArray(attrName, uriAttrs) !== -1) {
        return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN))
      }

      return true
    }

    var regExp = $(allowedAttributeList).filter(function (index, value) {
      return value instanceof RegExp
    })

    // Check if a regular expression validates the attribute.
    for (var i = 0, l = regExp.length; i < l; i++) {
      if (attrName.match(regExp[i])) {
        return true
      }
    }

    return false
  }

  function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
    if (unsafeHtml.length === 0) {
      return unsafeHtml
    }

    if (sanitizeFn && typeof sanitizeFn === 'function') {
      return sanitizeFn(unsafeHtml)
    }

    // IE 8 and below don't support createHTMLDocument
    if (!document.implementation || !document.implementation.createHTMLDocument) {
      return unsafeHtml
    }

    var createdDocument = document.implementation.createHTMLDocument('sanitization')
    createdDocument.body.innerHTML = unsafeHtml

    var whitelistKeys = $.map(whiteList, function (el, i) { return i })
    var elements = $(createdDocument.body).find('*')

    for (var i = 0, len = elements.length; i < len; i++) {
      var el = elements[i]
      var elName = el.nodeName.toLowerCase()

      if ($.inArray(elName, whitelistKeys) === -1) {
        el.parentNode.removeChild(el)

        continue
      }

      var attributeList = $.map(el.attributes, function (el) { return el })
      var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || [])

      for (var j = 0, len2 = attributeList.length; j < len2; j++) {
        if (!allowedAttribute(attributeList[j], whitelistedAttributes)) {
          el.removeAttribute(attributeList[j].nodeName)
        }
      }
    }

    return createdDocument.body.innerHTML
  }

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       = null
    this.options    = null
    this.enabled    = null
    this.timeout    = null
    this.hoverState = null
    this.$element   = null
    this.inState    = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.4.1'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    },
    sanitize : true,
    sanitizeFn : null,
    whiteList : DefaultWhitelist
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $(document).find($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
    this.inState   = { click: false, hover: false, focus: false }

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
    }

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    var dataAttributes = this.$element.data()

    for (var dataAttr in dataAttributes) {
      if (dataAttributes.hasOwnProperty(dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) {
        delete dataAttributes[dataAttr]
      }
    }

    options = $.extend({}, this.getDefaults(), dataAttributes, options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    if (options.sanitize) {
      options.template = sanitizeHtml(options.template, options.whiteList, options.sanitizeFn)
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in'
      return
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true
    }

    return false
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
    }

    if (self.isInStateTrue()) return

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)
        .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo($(document).find(this.options.container)) : $tip.insertAfter(this.$element)
      this.$element.trigger('inserted.bs.' + this.type)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var viewportDim = this.getPosition(this.$viewport)

        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one('bsTransitionEnd', complete)
          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  += marginTop
    offset.left += marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow()
      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
      .css(isVertical ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    if (this.options.html) {
      if (this.options.sanitize) {
        title = sanitizeHtml(title, this.options.whiteList, this.options.sanitizeFn)
      }

      $tip.find('.tooltip-inner').html(title)
    } else {
      $tip.find('.tooltip-inner').text(title)
    }

    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = $(this.$tip)
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
        that.$element
          .removeAttr('aria-describedby')
          .trigger('hidden.bs.' + that.type)
      }
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && $tip.hasClass('fade') ?
      $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var isSvg = window.SVGElement && el instanceof window.SVGElement
    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280
    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template)
      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
      }
    }
    return this.$tip
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    if (e) {
      self.inState.click = !self.inState.click
      if (self.isInStateTrue()) self.enter(self)
      else self.leave(self)
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
    }
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
      if (that.$tip) {
        that.$tip.detach()
      }
      that.$tip = null
      that.$arrow = null
      that.$viewport = null
      that.$element = null
    })
  }

  Tooltip.prototype.sanitizeHtml = function (unsafeHtml) {
    return sanitizeHtml(unsafeHtml, this.options.whiteList, this.options.sanitizeFn)
  }

  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jQuery);

/* ========================================================================
 * Bootstrap: popover.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

  Popover.VERSION  = '3.4.1'

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

  Popover.prototype.constructor = Popover

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS
  }

  Popover.prototype.setContent = function () {
    var $tip    = this.tip()
    var title   = this.getTitle()
    var content = this.getContent()

    if (this.options.html) {
      var typeContent = typeof content

      if (this.options.sanitize) {
        title = this.sanitizeHtml(title)

        if (typeContent === 'string') {
          content = this.sanitizeHtml(content)
        }
      }

      $tip.find('.popover-title').html(title)
      $tip.find('.popover-content').children().detach().end()[
        typeContent === 'string' ? 'html' : 'append'
      ](content)
    } else {
      $tip.find('.popover-title').text(title)
      $tip.find('.popover-content').children().detach().end().text(content)
    }

    $tip.removeClass('fade top bottom left right in')

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
  }

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }

  Popover.prototype.getContent = function () {
    var $e = this.$element
    var o  = this.options

    return $e.attr('data-content')
      || (typeof o.content == 'function' ?
        o.content.call($e[0]) :
        o.content)
  }

  Popover.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }


  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.popover')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.popover

  $.fn.popover             = Plugin
  $.fn.popover.Constructor = Popover


  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(jQuery);

/* ========================================================================
 * Bootstrap: tab.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    // jscs:disable requireDollarBeforejQueryAssignment
    this.element = $(element)
    // jscs:enable requireDollarBeforejQueryAssignment
  }

  Tab.VERSION = '3.4.1'

  Tab.TRANSITION_DURATION = 150

  Tab.prototype.show = function () {
    var $this    = this.element
    var $ul      = $this.closest('ul:not(.dropdown-menu)')
    var selector = $this.data('target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return

    var $previous = $ul.find('.active:last a')
    var hideEvent = $.Event('hide.bs.tab', {
      relatedTarget: $this[0]
    })
    var showEvent = $.Event('show.bs.tab', {
      relatedTarget: $previous[0]
    })

    $previous.trigger(hideEvent)
    $this.trigger(showEvent)

    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

    var $target = $(document).find(selector)

    this.activate($this.closest('li'), $ul)
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.tab',
        relatedTarget: $this[0]
      })
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: $previous[0]
      })
    })
  }

  Tab.prototype.activate = function (element, container, callback) {
    var $active    = container.find('> .active')
    var transition = callback
      && $.support.transition
      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)

    function next() {
      $active
        .removeClass('active')
        .find('> .dropdown-menu > .active')
        .removeClass('active')
        .end()
        .find('[data-toggle="tab"]')
        .attr('aria-expanded', false)

      element
        .addClass('active')
        .find('[data-toggle="tab"]')
        .attr('aria-expanded', true)

      if (transition) {
        element[0].offsetWidth // reflow for transition
        element.addClass('in')
      } else {
        element.removeClass('fade')
      }

      if (element.parent('.dropdown-menu').length) {
        element
          .closest('li.dropdown')
          .addClass('active')
          .end()
          .find('[data-toggle="tab"]')
          .attr('aria-expanded', true)
      }

      callback && callback()
    }

    $active.length && transition ?
      $active
        .one('bsTransitionEnd', next)
        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
      next()

    $active.removeClass('in')
  }


  // TAB PLUGIN DEFINITION
  // =====================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.tab')

      if (!data) $this.data('bs.tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tab

  $.fn.tab             = Plugin
  $.fn.tab.Constructor = Tab


  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


  // TAB DATA-API
  // ============

  var clickHandler = function (e) {
    e.preventDefault()
    Plugin.call($(this), 'show')
  }

  $(document)
    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)

}(jQuery);

/* ========================================================================
 * Bootstrap: affix.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#affix
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function (element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options)

    var target = this.options.target === Affix.DEFAULTS.target ? $(this.options.target) : $(document).find(this.options.target)

    this.$target = target
      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))

    this.$element     = $(element)
    this.affixed      = null
    this.unpin        = null
    this.pinnedOffset = null

    this.checkPosition()
  }

  Affix.VERSION  = '3.4.1'

  Affix.RESET    = 'affix affix-top affix-bottom'

  Affix.DEFAULTS = {
    offset: 0,
    target: window
  }

  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
    var scrollTop    = this.$target.scrollTop()
    var position     = this.$element.offset()
    var targetHeight = this.$target.height()

    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false

    if (this.affixed == 'bottom') {
      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
    }

    var initializing   = this.affixed == null
    var colliderTop    = initializing ? scrollTop : position.top
    var colliderHeight = initializing ? targetHeight : height

    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'

    return false
  }

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset
    this.$element.removeClass(Affix.RESET).addClass('affix')
    var scrollTop = this.$target.scrollTop()
    var position  = this.$element.offset()
    return (this.pinnedOffset = position.top - scrollTop)
  }

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1)
  }

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return

    var height       = this.$element.height()
    var offset       = this.options.offset
    var offsetTop    = offset.top
    var offsetBottom = offset.bottom
    var scrollHeight = Math.max($(document).height(), $(document.body).height())

    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)

    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)

    if (this.affixed != affix) {
      if (this.unpin != null) this.$element.css('top', '')

      var affixType = 'affix' + (affix ? '-' + affix : '')
      var e         = $.Event(affixType + '.bs.affix')

      this.$element.trigger(e)

      if (e.isDefaultPrevented()) return

      this.affixed = affix
      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null

      this.$element
        .removeClass(Affix.RESET)
        .addClass(affixType)
        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
    }

    if (affix == 'bottom') {
      this.$element.offset({
        top: scrollHeight - height - offsetBottom
      })
    }
  }


  // AFFIX PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.affix')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.affix

  $.fn.affix             = Plugin
  $.fn.affix.Constructor = Affix


  // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old
    return this
  }


  // AFFIX DATA-API
  // ==============

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this)
      var data = $spy.data()

      data.offset = data.offset || {}

      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
      if (data.offsetTop    != null) data.offset.top    = data.offsetTop

      Plugin.call($spy, data)
    })
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: collapse.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* jshint latedef: false */

+function ($) {
  'use strict';

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element      = $(element)
    this.options       = $.extend({}, Collapse.DEFAULTS, options)
    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
    this.transitioning = null

    if (this.options.parent) {
      this.$parent = this.getParent()
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
    }

    if (this.options.toggle) this.toggle()
  }

  Collapse.VERSION  = '3.4.1'

  Collapse.TRANSITION_DURATION = 350

  Collapse.DEFAULTS = {
    toggle: true
  }

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width')
    return hasWidth ? 'width' : 'height'
  }

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return

    var activesData
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse')
      if (activesData && activesData.transitioning) return
    }

    var startEvent = $.Event('show.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    if (actives && actives.length) {
      Plugin.call(actives, 'hide')
      activesData || actives.data('bs.collapse', null)
    }

    var dimension = this.dimension()

    this.$element
      .removeClass('collapse')
      .addClass('collapsing')[dimension](0)
      .attr('aria-expanded', true)

    this.$trigger
      .removeClass('collapsed')
      .attr('aria-expanded', true)

    this.transitioning = 1

    var complete = function () {
      this.$element
        .removeClass('collapsing')
        .addClass('collapse in')[dimension]('')
      this.transitioning = 0
      this.$element
        .trigger('shown.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    var scrollSize = $.camelCase(['scroll', dimension].join('-'))

    this.$element
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
  }

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return

    var startEvent = $.Event('hide.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var dimension = this.dimension()

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight

    this.$element
      .addClass('collapsing')
      .removeClass('collapse in')
      .attr('aria-expanded', false)

    this.$trigger
      .addClass('collapsed')
      .attr('aria-expanded', false)

    this.transitioning = 1

    var complete = function () {
      this.transitioning = 0
      this.$element
        .removeClass('collapsing')
        .addClass('collapse')
        .trigger('hidden.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    this.$element
      [dimension](0)
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
  }

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']()
  }

  Collapse.prototype.getParent = function () {
    return $(document).find(this.options.parent)
      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
      .each($.proxy(function (i, element) {
        var $element = $(element)
        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
      }, this))
      .end()
  }

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in')

    $element.attr('aria-expanded', isOpen)
    $trigger
      .toggleClass('collapsed', !isOpen)
      .attr('aria-expanded', isOpen)
  }

  function getTargetFromTrigger($trigger) {
    var href
    var target = $trigger.attr('data-target')
      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7

    return $(document).find(target)
  }


  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.collapse')
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.collapse

  $.fn.collapse             = Plugin
  $.fn.collapse.Constructor = Collapse


  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old
    return this
  }


  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this   = $(this)

    if (!$this.attr('data-target')) e.preventDefault()

    var $target = getTargetFromTrigger($this)
    var data    = $target.data('bs.collapse')
    var option  = data ? 'toggle' : $this.data()

    Plugin.call($target, option)
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: scrollspy.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // SCROLLSPY CLASS DEFINITION
  // ==========================

  function ScrollSpy(element, options) {
    this.$body          = $(document.body)
    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
    this.selector       = (this.options.target || '') + ' .nav li > a'
    this.offsets        = []
    this.targets        = []
    this.activeTarget   = null
    this.scrollHeight   = 0

    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
    this.refresh()
    this.process()
  }

  ScrollSpy.VERSION  = '3.4.1'

  ScrollSpy.DEFAULTS = {
    offset: 10
  }

  ScrollSpy.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
  }

  ScrollSpy.prototype.refresh = function () {
    var that          = this
    var offsetMethod  = 'offset'
    var offsetBase    = 0

    this.offsets      = []
    this.targets      = []
    this.scrollHeight = this.getScrollHeight()

    if (!$.isWindow(this.$scrollElement[0])) {
      offsetMethod = 'position'
      offsetBase   = this.$scrollElement.scrollTop()
    }

    this.$body
      .find(this.selector)
      .map(function () {
        var $el   = $(this)
        var href  = $el.data('target') || $el.attr('href')
        var $href = /^#./.test(href) && $(href)

        return ($href
          && $href.length
          && $href.is(':visible')
          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
      })
      .sort(function (a, b) { return a[0] - b[0] })
      .each(function () {
        that.offsets.push(this[0])
        that.targets.push(this[1])
      })
  }

  ScrollSpy.prototype.process = function () {
    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
    var scrollHeight = this.getScrollHeight()
    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
    var offsets      = this.offsets
    var targets      = this.targets
    var activeTarget = this.activeTarget
    var i

    if (this.scrollHeight != scrollHeight) {
      this.refresh()
    }

    if (scrollTop >= maxScroll) {
      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
    }

    if (activeTarget && scrollTop < offsets[0]) {
      this.activeTarget = null
      return this.clear()
    }

    for (i = offsets.length; i--;) {
      activeTarget != targets[i]
        && scrollTop >= offsets[i]
        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
        && this.activate(targets[i])
    }
  }

  ScrollSpy.prototype.activate = function (target) {
    this.activeTarget = target

    this.clear()

    var selector = this.selector +
      '[data-target="' + target + '"],' +
      this.selector + '[href="' + target + '"]'

    var active = $(selector)
      .parents('li')
      .addClass('active')

    if (active.parent('.dropdown-menu').length) {
      active = active
        .closest('li.dropdown')
        .addClass('active')
    }

    active.trigger('activate.bs.scrollspy')
  }

  ScrollSpy.prototype.clear = function () {
    $(this.selector)
      .parentsUntil(this.options.target, '.active')
      .removeClass('active')
  }


  // SCROLLSPY PLUGIN DEFINITION
  // ===========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.scrollspy')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.scrollspy

  $.fn.scrollspy             = Plugin
  $.fn.scrollspy.Constructor = ScrollSpy


  // SCROLLSPY NO CONFLICT
  // =====================

  $.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old
    return this
  }


  // SCROLLSPY DATA-API
  // ==================

  $(window).on('load.bs.scrollspy.data-api', function () {
    $('[data-spy="scroll"]').each(function () {
      var $spy = $(this)
      Plugin.call($spy, $spy.data())
    })
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: transition.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: https://modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap')

    var transEndEventNames = {
      WebkitTransition : 'webkitTransitionEnd',
      MozTransition    : 'transitionend',
      OTransition      : 'oTransitionEnd otransitionend',
      transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // https://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false
    var $el = this
    $(this).one('bsTransitionEnd', function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()

    if (!$.support.transition) return

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
      }
    }
  })

}(jQuery);
;
/**
 * Autocomplete/Typeahead.
 * exports a function that initializes and returns an autocomplete object.
 * @deprecated Prefer the class in tools/SuiAutocomplete.js
 */

(function(root) {

    const autocomplete = {
        /**
         * @prop {HTMLElement} input Text input.
         */
        input: null,
        /**
         * @prop {HTMLElement} list Autocomplete list.
         */
        list: null,
        /**
         * @prop {String} listLabel Aria description for the list.
         */
        listLabel: 'Suggested results',
        /**
         * @prop {HTMLElement} instructions Screen reader instructions.
         */
        instructions: null,
        /**
         * @prop {Function} throttle Timeout function for throttling requests
         */
        throttle: null,
        /**
         * @prop {Object} xhrSearch Current search request object.
         */
        xhrSearch: null,
        /**
         * @prop {String} queryName Name of the query param from this.input['name']
         */
        queryName: '',
        /**
         * @prop {Function} queryProcessor Escapes or otherwise transforms typed data for query.
         */
        queryProcessor: null,
        /**
         * @prop {Function} dataProcessor Transforms returned data.
         */
        dataProcessor: null,
        /**
         * @prop {Function} selectCallback When an option is selected, this will run with the selected option as its arg.
         */
        selectCallback: null,
        /**
         * @prop {String} typedQuery The query as typed.
         */
        typedQuery: '',
        /**
         * @prop {Number} resultLimit Number of items to show.
         */
        resultLimit: 10,
        /**
         * @prop {Object} queryData Data to send with the query. Could be strings OR HTML input to retrieve values from.
         */
        queryData: {},
        /**
         * @prop {Array} staticData Data to use instead of querying a url.
         */
        staticData: [],
        /**
         * @prop {Boolean} preventSubmit Should we prevent form submission on "enter" in input.
         */
        preventSubmit: false,
        /**
         * @prop {String} instructionsText Text for screen reader instructions.
         */
        instructionsText: '{{count}} options available. Use up and down arrows to browse available options and enter to select one.',
        /**
         * @prop {Boolean} showAllOnFocus When focused the autocomplete will show the list for "all" (i.e. a blank search)
         */
        showAllOnFocus: false,
        /**
         * @prop {Boolean} allowEmptySearch Is a blank/empty search allowed (i.e. show all).
         */
        allowEmptySearch: false,
        /**
         * Select the next list item.
         */
        selectNext: function() {
            const current = this.list.querySelector('li[aria-selected=true]');
            let selected = null;
            if (current === null) {
                selected = this.list.querySelector('li:first-of-type');
                if (selected === null) {
                    return;
                }
            } else {
                selected = current.nextElementSibling;
                if (selected === null) {
                    return;
                }
                current.setAttribute('aria-selected', false);
            }

            selected.setAttribute('aria-selected', true);
            this.input.value = selected.textContent;
        },
        /**
         * Select the previous list item
         */
        selectPrevious: function() {
            const current = this.list.querySelector('li[aria-selected=true]');
            if (current === null) {
                return;
            }
            const selected = current.previousElementSibling;
            if (selected === null) {
                this.input.value = this.typedQuery;
            } else {
                selected.setAttribute('aria-selected', true);
                this.input.value = selected.textContent;
            }
            current.setAttribute('aria-selected', false);
        },
        /**
         * Select an item via clicking on it.
         * @param {HTMLElement} selected Option in list.
         */
        selectByClick: function(selected) {
            const prevSelected = this.list.querySelector('li[aria-selected=true]');
            if (prevSelected !== null) {
                prevSelected.setAttribute('aria-selected', false);
            }
            selected.setAttribute('aria-selected', true);
            this.selectOption();
            if (!this.showAllOnFocus) {
                this.input.focus();
            }
        },
        /**
         * Escape query for use in regex.
         * Taken from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
         * Should be in some kind of utility module probably, but there is not one of those at this time.
         * @param {String} string String to escape.
         * @return {String}
         */
        escapeRegExp: function(string) {
            return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
        },
        /**
         * Format data object into HTMLElement
         * @param {Object} object Data object.
         * @return {HTMLElement|null}
         */
        formatOption: function(object) {
            let display = '';
            if (object.display) {
                display = object.display;
            } else {
                const regex = new RegExp(`(${this.escapeRegExp(this.typedQuery)})`, 'ig');
                display = object.label.replace(regex, '<strong>$1</strong>');
            }
            if (!display) {
                return null;
            }

            const option = document.createElement('li');
            option.setAttribute('aria-selected', false);
            option.setAttribute('role', 'option');
            Object.keys(object).forEach((prop) => {
                if (prop === 'label' || prop === 'display') {
                    return;
                }
                option.dataset[prop] = object[prop];
            });
            option.innerHTML = display;
            return option;
        },
        /**
         * Display results.
         * @param {Array} data Array of data objects.
         */
        displayResults: function(data) {
            if (data.length === 0) {
                this.closeList();
                return;
            }

            let options = data.map(this.formatOption, this);
            if (options.length > this.resultLimit && !this.allowEmptySearch) {
                options = options.slice(0, this.resultLimit);
            }
            this.list.innerHTML = '';

            const fragment = document.createDocumentFragment();
            options.forEach((element) => {
                if (!element) {
                    return;
                }
                fragment.appendChild(element);
            });

            this.list.appendChild(fragment);
            this.updateInstructions(options.length);
            this.openList();
        },
        /**
         * Is the list open
         * @return {Boolean}
         */
        isListOpen: function() {
            return !this.list.classList.contains('hidden');
        },
        /**
         * Is one of the options selected.
         * @return {Boolean}
         */
        isOptionSelected: function() {
            return this.list.querySelector('li[aria-selected=true]') !== null;
        },
        /**
         * Open the list.
         */
        openList: function() {
            this.list.style.left = `${this.input.offsetLeft}px`;
            this.list.style.top = `${this.input.offsetTop + this.input.offsetHeight}px`;
            this.list.style.minWidth = `${this.input.offsetWidth}px`;
            this.list.classList.remove('hidden');
            this.input.setAttribute('aria-expanded', true);
        },
        /**
         * Close the list
         */
        closeList: function() {
            this.list.classList.add('hidden');
            this.list.innerHTML = '';
            this.input.setAttribute('aria-expanded', false);
            this.updateInstructions(0);
        },
        /**
         * Select one of the list options.
         */
        selectOption: function() {
            const option = this.list.querySelector('li[aria-selected=true]');
            this.input.dataset.oldvalue = this.input.value;
            this.input.value = option.textContent;
            if (this.selectCallback !== null) {
                this.selectCallback(option);
            }
            this.closeList();
        },
        /**
         * Process the results if necessary.
         * Should have:
         * label text value of the item
         * display (optional) display html for the list
         * @param {Object|Array} data Data from the server.
         * @return {Array}
         */
        processData: function(data) {
            if (this.dataProcessor !== null) {
                return this.dataProcessor(data);
            }
            return data;
        },
        /**
         * Build a query string.
         * @return {String}
         */
        buildQueryString: function() {
            const rawTyped = this.input.value;
            const query = (this.queryProcessor !== null) ? this.queryProcessor(rawTyped) : rawTyped;
            const params = new URLSearchParams();
            params.append(this.queryName, query);
            params.append('limit', this.resultLimit);

            const props = Object.keys(this.queryData);
            props.forEach(function(prop) {
                const value = this.queryData[prop];
                if (typeof value === 'function') {
                    // dynamic param
                    params.append(prop, value());
                    return;
                }
                params.append(prop, value);
            }, this);
            return `?${params.toString()}`;
        },
        /**
         * On load for ajax request.
         */
        xhrOnLoad: function() {
            if (this.xhrSearch.status >= 200 && this.xhrSearch.status < 400) {
                // Success!
                const data = JSON.parse(this.xhrSearch.responseText);
                const formattedData = this.processData(data);
                this.displayResults(formattedData);
            } else {
                // We reached our target server, but it returned an error
                console.log(this.xhrSearch.statusText);
            }
        },
        /**
         * xhr error.
         */
        xhrOnError: function() {
            // There was a connection error of some sort
            console.log(this.xhrSearch.statusText);
        },
        /**
         * The ajax request.
         */
        makeRequest: function() {
            const queryString = this.buildQueryString();

            this.xhrSearch = new XMLHttpRequest();
            this.xhrSearch.open('GET', this.queryUrl + queryString, true);
            this.xhrSearch.setRequestHeader('Accept', 'application/json');
            this.xhrSearch.onload = this.xhrOnLoad.bind(this);
            this.xhrSearch.onerror = this.xhrOnError.bind(this);
            this.xhrSearch.send();
        },
        /**
         * Search the static data.
         */
        searchData: function() {
            const rawTyped = this.input.value;
            if (rawTyped === '' && !this.allowEmptySearch) {
                this.closeList();
                return;
            }
            let query = (this.queryProcessor !== null) ? this.queryProcessor(rawTyped) : rawTyped;
            query = query.toLowerCase();
            if (query === '') {
                this.displayResults(this.staticData);
                return;
            }
            const results = this.staticData.filter((option) => {
                return option.label.toLowerCase().indexOf(query) !== -1;
            });
            this.displayResults(results);
        },
        /**
         * Get exact match.
         * For when submitted without choosing the dropdown.
         * Only works with when staticData is set.
         * @returns {Object|null}
         */
        getExactMatch: function() {
            const rawTyped = this.input.value.trim().toLowerCase();
            if (rawTyped === '') {
                return null;
            }
            const result = this.staticData.find((option) => {
                return option.label.toLowerCase() === rawTyped;
            });
            if (!result) {
                return null;
            }
            return result;
        },
        /**
         * Inititiate a search.
         */
        query: function() {
            if (this.staticData.length > 0) {
                this.searchData();
                return;
            }
            if (this.throttle) {
                clearTimeout(this.throttle);
            }
            if (this.xhrSearch) {
                this.xhrSearch.abort();
            }
            if (this.input.value === '' && !this.allowEmptySearch) {
                this.closeList();
                return;
            }
            this.throttle = setTimeout(this.makeRequest.bind(this), 500);
        },
        /**
         * Destroy. Remove events, etc.
         */
        disable: function() {
            this.list.parentNode.removeChild(this.list);
            // this.input reset attributes, remove listeners
        },
        /**
         * Create the list to hold the results
         */
        createList: function() {
            this.list = document.createElement('ul');
            this.list.id = this.getListId();
            this.list.setAttribute('role', 'listbox');
            this.list.setAttribute('aria-label', this.listLabel);
            this.list.classList.add('s-ui-autocomplete-list');
            this.list.classList.add('hidden');
            // insert list after input
            this.input.parentNode.insertBefore(this.list, this.input.nextSibling);
        },
        /**
         * The list id based on the input id.
         * @return {String}
         */
        getListId: function() {
            return `${this.input.id}_list`;
        },
        /**
         * The instruction id based on the input id.
         * @return {String}
         */
        getInstructionsId: function() {
            return `${this.input.id}_instructions`;
        },
        /**
         * Add appropriate attributes to the input.
         */
        formatInput: function() {
            this.input.setAttribute('role', 'combobox');
            this.input.setAttribute('aria-autocomplete', 'list');
            this.input.setAttribute('aria-expanded', 'false');
            this.input.setAttribute('aria-controls', this.getListId());
            this.input.setAttribute('aria-describedby', this.getInstructionsId());
            this.input.setAttribute('autocomplete', 'off');
            this.queryName = this.input.getAttribute('name');
        },
        /**
         * Update instructions with number of options found.
         * @param {Number} count Number of options.
         */
        updateInstructions: function(count) {
            this.instructions.innerHTML = this.instructionsText.replace('{{count}}', count);
        },
        /**
         * Handler: Key down typing in the input, handles special commands.
         * @param {Event} ev Keyup event.
         */
        handleTypingDown: function(ev) {
            const open = this.isListOpen();
            switch (ev.key) {
                case 'Escape':
                    // if list is open, close it.
                    if (open) {
                        this.closeList();
                    }
                    break;
                case 'ArrowDown':
                    // if list is open, navigate to/select first entry.
                    if (open) {
                        ev.preventDefault();
                        this.selectNext();
                    } else if (this.showAllOnFocus && this.input.value === '') {
                        this.query();
                    }
                    break;
                case 'ArrowUp':
                    // if list is open, navigate to/select first entry.
                    if (open) {
                        ev.preventDefault();
                        this.selectPrevious();
                    }
                    break;

                case 'Enter':
                    if (open && this.isOptionSelected()) {
                        ev.preventDefault();
                        this.selectOption();
                    } else if (this.preventSubmit) {
                        ev.preventDefault();
                    }
                    break;
                case 'Tab':
                    if (open && this.isOptionSelected()) {
                        this.selectOption();
                    } else if (open) {
                        this.closeList();
                    }
                    // default action
                    break;
            }
        },
        /**
         * Handler: Key up typing in the input. Does the search
         * @param {Event} ev Keyup event.
         */
        handleTypingUp: function(ev) {
            switch (ev.key) {
                case 'Escape':
                case 'ArrowDown':
                case 'ArrowUp':
                case 'ArrowLeft':
                case 'ArrowRight':
                case 'Enter':
                case 'Tab':
                    // ignore
                    break;
                default:
                    this.typedQuery = this.input.value;
                    this.query();
                    break;
            }
        },
        /**
         * Click events on the list of results.
         * @param {Event} ev Click event.
         */
        handleClick: function(ev) {
            const li = ev.target.closest('li[aria-selected=false]');
            if (li === null) {
                return;
            }
            this.selectByClick(li);
            return;
        },
        /**
         * Clicks on the document will close the list if outside the list or input itself.
         * @param {Event} ev Click event.
         */
        handleOutsideClick: function(ev) {
            const target = ev.target;
            if (target.closest(`#${this.list.id}`) === null && target.closest(`#${this.input.id}`) === null) {
                // click target is outside autocomplete
                this.closeList();
                return;
            }
        },
        /**
         * Attach events.
         */
        attachEvents: function() {
            this.input.addEventListener('keydown', this.handleTypingDown.bind(this));
            this.input.addEventListener('keyup', this.handleTypingUp.bind(this));
            this.list.addEventListener('click', this.handleClick.bind(this));

            // Warning: This handler will not get removed if the autocomplate is removed from the page
            // Ideally we should remove it, but that would require a MutationObserver that basically watches the whole page
            // Since the parent of the autoomplete isn't always the one that is explicitly removed (and thus wouldn't trigger the observer).
            document.body.addEventListener('click', this.handleOutsideClick.bind(this));

            if (this.showAllOnFocus) {
                this.input.addEventListener('focus', () => {
                    if (this.input.value === '') {
                        this.query();
                    }
                });
            }
        },
        /**
         * Add instructions div.
         */
        addInstructions: function() {
            this.instructions = document.createElement('div');
            this.instructions.id = this.getInstructionsId();
            this.instructions.setAttribute('aria-live', 'polite');
            this.instructions.classList.add('sr-only');
            this.instructions.innerHTML = this.instructionsText.replace('{{count}}', 0);

            this.list.parentNode.insertBefore(this.instructions, this.list.nextSibling);
        },
        /**
         * Validate the config option.
         * @param {Object} config Config object.
         */
        validateConfig: function(config) {
            if (!config.inputSelector) {
                throw new Error('Must set inputSelector.');
            }
            if (this.input === null) {
                throw new Error(`${config.inputSelector} not found in the DOM.`);
            }
            if (!this.queryUrl && this.staticData.length === 0) {
                throw new Error('Must set queryUrl or staticData.');
            }
        },
        /**
         * Set config.
         * @param {Object} config Config object.
         */
        setConfig: function(config) {
            this.input = document.querySelector(config.inputSelector);

            const validConfigs = [
                'queryUrl',
                'staticData',
                'queryProcessor',
                'dataProcessor',
                'selectCallback',
                'resultLimit',
                'queryData',
                'instructionsText',
                'preventSubmit',
                'listLabel',
                'showAllOnFocus',
                'allowEmptySearch'
            ];

            const props = Object.keys(config);
            props.forEach(function(prop) {
                if (validConfigs.indexOf(prop) === -1) {
                    return;
                }
                this[prop] = config[prop];
            }, this);

            if (this.showAllOnFocus) {
                this.allowEmptySearch = true;
            }
        },
        /**
         * Initialize
         * @param {Object} config Config object.
         * @param {String} inputSelector For the input to add autocomplete to.
         * @param {String} queryUrl Url to send ajax requests to
         * @param {Array} staticData Data for autocomplete in lieu of an ajax request.
         * @param {String} instructionsText Translation of instructions for screen readers.
         * @param {Number} [resultLimit] Max results to retrieve/show. Sent with query.
         * @param {Function} [queryProcessor] Function that accepts typed query and returns it transformed for search.
         * @param {Function} [dataProcessor] Function that accepts return data array and formats it.
         * @param {Function} [selectCallback] Function for when a option is selected.
         * @param {Boolean} [queryData] Data to send with the query
         * @param {Boolean} [preventSubmit] Prevent form submit.
         * @param {Boolean} [showAllOnFocus] Show the list on first focus.
         * @param {Boolean} [allowEmptySearch] Allow empty/blank search.
         */
        init: function(config) {
            this.setConfig(config);
            this.validateConfig(config);
            this.formatInput();
            this.createList();
            this.addInstructions();
            this.attachEvents();
        }
    };

    /**
     * Initialize a new autocomplete.
     * @param {Object} config Config object passed to autocomplete.init
     * @return {autocomplete}
     */
    const initAutocomplete = function(config) {
        const a = Object.create(autocomplete);
        a.init(config);
        return a;
    };

    root.springSpace = root.springSpace || {};
    root.springSpace.sui = root.springSpace.sui || {};
    root.springSpace.sui.initAutocomplete = root.springSpace.sui.initAutocomplete || initAutocomplete;
})(this);
;
/**
  * Centered floating alerts
  */
// This is in block scope because it gets concatenated into LA Widgets, so we need the class def to be non-global in case it gets loaded twice
// Once we move to all imports/modules/builds we could remove that.
{
    class Notify {
        #parent = null;
        #defaultParentId = 's-ui-notifyarea';
        #defaultAlertId = 's-ui-notify';
        #defaultClassname = 's-ui-notify';
        #workingConfig = {
            msg: '<i class="fa fa-spinner fa-pulse mg-right" aria-hidden="true"></i> <span>Working...</span>',
            className: 's-ui-notify-working'
        };
        #successConfig = {
            msg: 'Success.',
            className: 's-ui-notify-success'
        };
        #errorConfig = {
            msg: 'Error: Please try again.',
            className: 's-ui-notify-error'
        };

        #idCount = 0;
        #boundKeyboardEvents = null;

        constructor({
            parent_id = null
        }) {
            // Its best for screenreaders if the parent is already in the DOM.
            if (parent_id) {
                this.#defaultParentId = parent_id;
            }
        }

        #setUpParent() {
            let parent = document.getElementById(this.#defaultParentId);
            if (!parent) {
                parent = document.createElement('DIV');
                parent.id = this.#defaultParentId;
                parent.setAttribute('role', 'alert');
                parent.setAttribute('aria-atomic', 'true');
                document.body.appendChild(parent);
            }
            return parent;
        }
        /**
         * @returns {HTMLElement}
         */
        #getParent() {
            if (!this.#parent) {
                this.#parent = this.#setUpParent();
            }
            return this.#parent;
        }
        /**
          * A default error alert
          * @param {String} [msg] Custom error message
          * @param {String} [id] Alert id to replace, else new alert created.
          */
        error(msg = '', id = null) {
            const config = { ...this.#errorConfig };
            if (msg) {
                config.msg = msg;
            }
            config.msg = `<i class="fa fa-exclamation-triangle mg-right" aria-hidden="true"></i> ${config.msg}`;
            config.id = id;
            this.show(config);
        }
        /**
          * A default success alert
          * @param {String} [msg] Custom success message
          * @param {String} [id] Alert id to replace, else new alert created.
          * @param {Number} [ms] Timeout in milliseconds
          */
        success(msg = '', id = null, ms = 0) {
            const config = { ...this.#successConfig };
            if (msg) {
                config.msg = msg;
            }
            if (ms > 0) {
                config.ms = ms;
            }
            config.msg = `<i class="fa fa-check-circle mg-right" aria-hidden="true"></i> ${config.msg}`;
            config.id = id;
            this.show(config);
        }
        /**
          * default "working" alert
          * @param {String} [msg] custom message
          * @param {String} [id] Alert id to replace, else new alert created.
          */
        working(msg = '', id = null) {
            const config = { ...this.#workingConfig };
            if (msg) {
                config.msg = msg;
            }
            config.id = id;
            this.show(config);
        }
        /**
          * Creates/displays an alert
          * @param {Object} settings Alert config
          * @param {String} settings.msg message to display
          * @param {String} [settings.className=s-ui-notification] custom class to attach to alert (for styling)
          * @param {String} [settings.id] Id for alert
          * @param {Number} [settings.ms] Timeout in ms
          * @returns {String} alert id
          */
        show({
            msg = '',
            className = null,
            id = null,
            ms = 0
        }) {
            if (!msg) {
                return null;
            }
            let el = null;
            if (!id) {
                this.#idCount++;
                id = `${this.#defaultAlertId}-${this.#idCount}`;
            } else {
                el = document.getElementById(id);
                if (el) {
                    el.remove();
                }
            }
            el = document.createElement('DIV');
            el.id = id;
            el.classList.add(this.#defaultClassname);
            if (className) {
                el.classList.add(className);
            }
            el.innerHTML = `<div class="s-ui-notification-message">${msg}</div><button class="btn" aria-label="${window?.springyText?.modal?.close || 'Close'}">&times;</button>`;

            const parent = this.#getParent();
            parent.appendChild(el);
            el.addEventListener('click', (ev) => {
                ev.preventDefault();
                this.hide(ev.currentTarget);
            });
            if (ms > 0) {
                setTimeout(() => {
                    this.hide(el);
                }, ms);
            }
            // add a close keyboard action
            if (this.#boundKeyboardEvents === null) {
                this.#boundKeyboardEvents = this.keyboardEvents.bind(this);
                document.addEventListener('keydown', this.#boundKeyboardEvents, true);
            }
            return id;
        }
        /**
          * Hide a notification or all notifications
          * @param {HTMLElement|null} [alert=null] Alert to hide (else all)
          */
        hide(alert = null) {
            if (alert) {
                alert.remove();
            } else if (this.#parent) {
                this.#parent.innerHTML = '';
            }
            this.#removeKeyboardEvents();
        }
        /**
         * Hide any working alerts.
         */
        hideWorking() {
            if (!this.#parent) {
                return;
            }
            this.#parent.querySelectorAll(`.${this.#workingConfig.className}`).forEach((el) => {
                el.remove();
            });
            this.#removeKeyboardEvents();
        }
        /**
         * If there are no more alerts, turn off the keyboard close event
         */
        #removeKeyboardEvents() {
            if (this.#boundKeyboardEvents === null
                || !this.#parent
                || this.#parent.children.length > 0) {
                return;
            }
            document.removeEventListener('keydown', this.#boundKeyboardEvents, true);
            this.#boundKeyboardEvents = null;
        }
        /**
         * Handler: Keyboard event to:
         * - Close on Esc
         * @param {KeyboardEvent} ev Keydown event
         */
        keyboardEvents(ev) {
            if (ev.key !== 'Escape') {
                return;
            }
            // close the first/oldest alert first
            const firstAlert = this.#parent.querySelector(`.${this.#defaultClassname}`);
            if (firstAlert) {
                firstAlert.remove();
            }
            this.#removeKeyboardEvents();
        }
    }

    window.suiNotify = new Notify({});
}
;
/**
 * UI element: modals
 * requires: jquery, bootstrap
 */

(function(root) {
    /**
     * Modal object
     * @param {Object} config all of the config properties are optional, but you at least need to set config.content or config.url
     * @param {String} [config.id=s-sui-modal] optional modal ID (you only need this for opening multiple modals at the same time)
     * @param {String} [config.title] text for header of modal (if absent header will not be displayed)
     * @param {String|HTMLElement} [config.content] html content for modal (inserted into .modal-body) Accepts html string or whole element. (alternately use config.url to load content)
     * @param {String} [config.url] content will be loaded into .modal-content from this url if present (format returned data as json object with properties: title, content, buttons (same as config.title, config.content, and config.buttons)
     * @param {Bool} [config.fade] should the modal use the "fade in/out" effect
     * @param {Function} [config.callback] a function called when the modal is shown, the modal object is passed as the first parameter.
     * @param {Function} [config.closeCallback] a function called when the modal is closed, the modal object is passed as the first parameter.
     * @param {Boolean} [config.footer=false] display footer (buttons) or not, overridden if you set config.buttons
     * @param {String} [config.size] only accepts 'large' to apply the modal-lg class (wider modal than normal)
     * @param {Object[]} [config.buttons] button settings for use in footer
     * @param {Object} [config.buttons[]]
     * @param {String} [config.buttons[].bclass] class(es) to add to the button (like btn-primary) defaults to btn-default
     * @param {String} [config.buttons[].label] text of the button
     * @param {Function} [config.buttons[].callback] callback applied when button is clicked, the modal object will be found in e.data.modal of the click event
     * @param {Boolean} [config.returnfocus=true] return focus to the element that was active when the modal opened (usually that should be the button that triggered the modal)
     * @param {Boolean|String} [config.backdrop=true] Bootstrap modal backdrop option (only string option is "static")
     * @param {Boolean} [config.keyboard=true] Bootstrap modal keyboard option
     * @param (Object) [config.textTrans] Translatated text for default button and message text.
     */
    var modal = function(config) {
        if (typeof config === 'undefined') {
            config = {};
        }

        /**
         * (re)set the config properties (used on instantiation and in this.redraw())
         * @param {Object} config same as above
         */
        this.setConfig = function(config) {
            this.id = (config.id) ? config.id : 's-sui-modal';
            this.title = (config.title) ? config.title : '';
            this.content = (config.content) ? config.content : '';
            this.url = (config.url) ? config.url : null;
            this.fade = (config.fade) ? true : false;
            this.callback = (config.callback) ? config.callback : null;
            this.closeCallback = (config.closeCallback) ? config.closeCallback : null;
            this.footer = (config.footer === true) ? config.footer : false;
            this.size = (config.size) ? config.size : '';
            this.modal_buttons = (config.buttons) ? config.buttons : [];
            this.returnfocus = (config.returnfocus === false) ? false : true;
            this.opener = document.activeElement;
            this.btn_callbacks = {};
            this.backdrop = (typeof config.backdrop === 'undefined')
                ? true
                : (config.backdrop === 'static' ? 'static' : !!config.backdrop);
            this.keyboard = (config.keyboard === false) ? false : true;
            var transDefined = (typeof config.transText !== 'undefined');
            this.transText = {
                close: (transDefined && config.transText.close) ? config.transText.close : 'Close',
                error: (transDefined && config.transText.error) ? config.transText.error : 'Error',
                unknown: (transDefined && config.transText.unknown) ? config.transText.unknown : 'Unknown',
                invalidResponse: (transDefined && config.transText.invalidResponse) ? config.transText.invalidResponse : 'Invalid response received',
                toggle:(transDefined && config.transText.toggle) ? config.transText.toggle : 'Toggle Dropdown'
            };
        };

        this.setConfig(config);

        /**
         * Create the div if necessary and add it to the body
         */
        this.$el = jQuery('#' + this.id);
        if (jQuery('#' + this.id).length === 0) {
            this.$el = jQuery('<div class="modal ' + (this.fade ? 'fade' : '') + '" tabindex="-1" role="dialog" aria-labelledby="s-sui-modal-header"></div>')
                .attr('id', this.id)
                .html('<div class="modal-dialog"><div class="modal-content"></div></div>');
            /**
             * Put modal at top of page so there is something to focus on when tabbing out of modal (allowing us to then focus back on the modal)
             */
            if (this.id === 's-sui-modal') {
                jQuery('body').prepend( this.$el );
            } else {
                //put non-default modals AFTER any other modals
                var modals = jQuery('div.modal');
                if (modals.length > 0) {
                    modals.filter(':last').after( this.$el );
                } else {
                    jQuery('body').prepend( this.$el );
                }
            }
        }

        if (this.size === 'large') {
            this.$el.find('.modal-dialog').addClass('modal-lg');
        }

        /**
         * Callback: Modal content retrieval.
         * @param {Object} data Response payload.
         */
        this.retrieveSuccess = function(data) {
            if (data.title) {
                this.title = data.title;
            }
            if (data.content) {
                this.content = data.content;
            }
            if (data.buttons) {
                this.modal_buttons = data.buttons;
            }
            this.footer = (data.footer && data.footer === true) ? true : false;

            this.draw();
        };
        /**
         * Callback: Modal content retrieval. Failed.
         * @param {Object} jqXhr JQuery response object.
         */
        this.retrieveFail = function(jqXhr) {
            var error = this.transText.unknown;
            if (jqXhr.responseText) {
                try {
                    var response = JSON.parse(jqXhr.responseText);
                    if (response.error) {
                        error = response.error;
                    }
                } catch (e) {
                    error = this.transText.invalidResponse;
                }
            }
            this.content = this.transText.error + ': ' + error;
            this.footer = true;
            this.draw();
        };

        /**
         * retrieve content
         */
        this.retrieve = function() {
            jQuery.ajax({
                url: this.url,
                cache: false,
                method: 'GET',
                dataType: 'json'
            })
                .done(this.retrieveSuccess.bind(this))
                .fail(this.retrieveFail.bind(this));
        };
        /**
         * Handler: Bootstrap modal show event.
         */
        this.handleShowEvent = function() {
            if (this.callback !== null) {
                this.callback(this);
            }
        };
        /**
         * Handler: Bootstrap modal hide event.
         */
        this.handleHideEvent = function() {
            // return focus to opener (button/link)
            if (this.returnfocus && typeof this.opener !== 'undefined' && this.opener !== null) {
                this.opener.focus();
            }

            // call close callback with modal as first argument.
            if (this.closeCallback !== null) {
                this.closeCallback(this);
            }
            // clean up events and html (for DOM element reuse)
            this.$el.off().removeData('bs.modal').find('.modal-content').html('');
            jQuery('#' + this.id + ' .modal-dialog').removeClass('modal-lg');
            // make sure callbacks are cleared, else they can end up firing multiple times.
            this.callback = null;
            this.closeCallback = null;
        };
        /**
         * Format the modal content and apply appropriate callbacks and handlers and such
         * this will also show the modal
         */
        this.draw = function() {
            //@todo might be better if we used a template (then you could even pass in the template if you wanted)
            var template = '<div class="modal-content">';
            if (this.title !== '') {
                template += '<div class="modal-header"><button id="s-sui-modal-close" type="button" class="close" data-dismiss="modal" aria-label="&times; ' + this.transText.close + '">&times;</button><h2 class="modal-title" id="s-sui-modal-header">' + this.title + '</h2></div>';
            }
            var contentHtml = '';
            if (typeof this.content === 'string') {
                contentHtml = this.content;
            }
            template += '<div class="modal-body">' + contentHtml + '</div>';
            if (this.footer || this.modal_buttons.length > 0) {
                this.btn_callbacks = {}; //reset here just in case
                template += '<div class="modal-footer">';
                if (this.modal_buttons.length === 0) {
                    template += '<button type="button" class="btn btn-default" data-dismiss="modal">' + this.transText.close + '</button>';
                } else {
                    this.modal_buttons.forEach(function(v, k) {
                        if (v.links && v.links.length > 0) {
                            // Button dropdown
                            v.gclass = v.gclass ? v.gclass : '';
                            template += '<div class="btn-group ' + v.gclass + '">';

                            // Main button of the group
                            v.bclass = (v.bclass) ? v.bclass : 'btn-default';
                            v.label = (v.label) ? v.label : '';
                            if (v.label !== '') {
                                template += '<button type="button" class="btn ' + v.bclass + ' btn-modal-' + k + '" >' + v.label + '</button>';
                                if (v.callback) {
                                    this.btn_callbacks['btn-modal-' + k] = v.callback;
                                }
                            }

                            template += '<button type="button" class="btn ' + v.bclass + ' dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span class="caret"></span><span class="sr-only">' + this.transText.toggle + '</span></button>';
                            template += '<ul class="dropdown-menu">';

                            v.links.forEach(function(x, y) {
                                x.label = (x.label) ? x.label : '';
                                if (x.label !== '') {
                                    var href = (x.url) ? x.url : '#';
                                    template += '<li><a href="' + href + '" class="link-modal-' + y + '">' + x.label + '</a></li>';
                                    if (x.callback) {
                                        this.btn_callbacks['link-modal-' + y] = x.callback;
                                    }
                                }
                            }, this);

                            template += '</ul>';
                            template += '</div>';
                        } else {
                            // Normal button
                            v.bclass = (v.bclass) ? v.bclass : 'btn-default';
                            v.label = (v.label) ? v.label : '';
                            if (v.label !== '') {
                                template += '<button type="button" class="btn ' + v.bclass + ' btn-modal-' + k + '" >' + v.label + '</button>';
                                if (v.callback) {
                                    this.btn_callbacks['btn-modal-' + k] = v.callback;
                                }
                            }
                        }
                    }, this);
                }
                template += '</div>';
            }
            template += '</div>';

            var html = jQuery(template);
            // if this.content is a HTMLElement we need to append it
            // this let's us keep any events on the content.
            if (typeof this.content !== 'string') {
                html.find('.modal-body').html(this.content);
            }

            this.$el.find('.modal-content').replaceWith(html);

            /**
             * Apply button callbacks
             */
            if (this.modal_buttons.length > 0) {
                for (var b in this.btn_callbacks) {
                    if (this.btn_callbacks.hasOwnProperty(b)) {
                        if (typeof this.btn_callbacks[b] === 'function' ) {
                            this.$el.find('.' + b).on('click', { modal: this }, this.btn_callbacks[b]);
                        }
                    }
                }
            }

            /**
             * Apply any callbacks to the show event (this happens before the viewer sees the modal
             */
            this.$el.on('show.bs.modal', this.handleShowEvent.bind(this));

            /**
             * show the modal
             */
            this.$el.modal({ backdrop: this.backdrop, keyboard: this.keyboard }, 'show');

            /**
             * clean up modal on close, making sure to empty the html and unbind events
             */
            this.$el.on('hidden.bs.modal', this.handleHideEvent.bind(this));
        };
        /**
         * Close the modal, which triggers the hidden.bs.modal event handler above
         */
        this.close = function() {
            jQuery('#' + this.id).modal('hide');
        };
        /**
         * Change the content/workings of an existing/open modal
         * @param {Object} newConfig Reconfig a new config option, any included properties will overwrite the current object properties
         */
        this.redraw = function(newConfig) {
            //unbind the show/hide handlers we create in this.draw()
            this.$el.unbind('show.bs.modal').unbind('hidden.bs.modal');
            //reconfig
            this.setConfig(newConfig);

            if (this.url !== null) {
                this.retrieve();
            } else {
                this.draw();
            }
        };


        /**
         * The action starts here
         */
        if (this.url !== null) {
            this.retrieve();
        } else {
            this.draw();
        }
    };

    // support export as module (like in node)
    // or else just attach to the window.springSpace object
    if (typeof module !== 'undefined') {
        module.exports = modal;
    } else {
        root.springSpace = root.springSpace || {};
        root.springSpace.sui = root.springSpace.sui || {};
        root.springSpace.sui.modal = root.springSpace.sui.modal || modal;
    }

})(this);

/*
    Example usage:

    Basic modal with title and content already available
    var modal = new springSpace.sui.modal({ title: 'A Modal', content: '<p>Hello, modal.</p>' });

    Basic modal with callback (this in the callback will refer to the modal object)
    var modal = new springSpace.sui.modal({ title: 'A Modal', content: '<p>Hello, modal.</p>', callback: function(){ this.$el.find('p').css('color', 'pink'); } });

    Basic ajax loaded modal
    var modal = new springSpace.sui.modal({ url: '/process_public.php?m=qform' });

    On the server side, the ajax request should return a JSON encoded object with:
    title (optional, title of modal)
    content (html content of modal)
    footer (boolean, defaults to false, just show a basic footer with a close button)
    buttons (array of buttons for footer of modal, as an alternate to the footer boolean)
        -each button is an assoc array (or object) with: label, bclass (optional), links (optional), and gclass (optional class for button group div if links is set).
        -Use the links property to create a button dropdown. Links is an array of objects with: label, callback (optional), and url (optional, defaults to '#')

    Ajax with callback (first argument to the callback will refer to the modal object)
    var modal = new springSpace.sui.modal({ url: '/process_public.php?m=qform', callback: function(modal){ console.log(modal); } });

    Button callbacks are passed the modal object in e.data
    var modal = new springSpace.sui.modal({ title: 'A Modal', content: '<p>Hello, modal.</p>', footer: true, buttons: [{bclass: 'btn-primary btn-lg', label:'test close', callback: function(e){ e.data.modal.close(); } }] });

    Close the modal manually:
    modal.close();
    (You can also use the normal data-dismiss="modal" attribute on buttons, that will still trigger an event handler to clean-up the modal)

    Trigger function on close:
    config.closeCallback = function(modal) {
        // do something here.
    };
    // most likely you'll want to bind the function to another object for anything complicated.

    Replace the modal content without closing/reopening it:
    modal.redraw({ title: 'New modal title', content: '<p>This is all new content</p>' });
    modal.redraw({ url: '/process_public.php?m=qform' });

    Custom "confirm" modal
    var confirm = new springSpace.sui.modal({
        content: 'Are you sure you want to proceed?',
        buttons: [
            { label: 'No', callback: function(e){ e.data.modal.close(); } },
            { label: 'Yes', bclass: 'btn-primary', callback: function(e){ doSomething(); e.data.modal.close(); } }
        ]
    });

    Translate default modal button/message text into other languages:
    Set config.transText to an object with the following fields
        close (text that displays on default button to close the modal window - Default value is "Close")
        error (default text preceeding error message for failed callback - Default value is "Error")
        unknown (default error text for a failed callback - Default value is "Unknown")
        invalidResponse (default error text for invalid response for a failed callback - Default is "Invalid response received")
        toggle (default screen reader text for dropdown puttons - Default is "Toggle Dropdown")
    Example translating to French:
    var modal = new springSpace.sui.modal({
        transText: {
            close: 'Fermer',
            error: 'Erreur',
            unknown: 'Inconnu',
            invalidResponse: 'Réponse\u0020invalide.',
            toggle: 'Basculer\u0020la\u0020liste\u0020déroulante'
        }
    });

*/
;
/**
 * UI element: Help text popovers/tooltips
 * requires: jquery, bootstrap popover
 */
var springSpace = springSpace || {};
springSpace.sui = springSpace.sui || {};


/**
 * Help popover/tooltip
 * @param {Object} config
 * @param {String} [parent] a selector within which one will activate popovers (good for dynamically loaded content)
 * @param {String} [selector=button.btn-help-popover] selector for the help button
 * @param {String} [placement=bottom'] Which direction tooltip should go (top, bottom, right, left)
 */
springSpace.sui.helptip = function(config) {
	if ( typeof(config) == 'undefined' ) {
		config = {};
	}
	
	var placement_opts = ['bottom', 'top', 'right', 'left'];
	
	//set the config values
	this.parent = (config.parent) ? config.parent : '';
	this.selector = (config.selector) ? config.selector : 'button.btn-help-popover';
	if (this.selector == '') { return; }
	this.placement = (config.placement) ? config.placement : 'bottom';
	if ( placement_opts.indexOf(this.placement) == -1) { this.placement = 'bottom'; }
	
	//find the buttons we want to initialize as popovers
	this.$el = null;
	if (this.parent !== '') {
		this.$el = jQuery(this.parent+' '+this.selector);
	} else {
		this.$el = jQuery(this.selector);
	}
	this.ajcontent = {};  //save ajax loaded content here (by url) so we only have to request it once.
	
	var self = this;
	
	//Initialize the Bootstrap Popovers...
	this.$el.popover({
		placement: this.placement,
		html: true,
		content: function(){
			//'this' is the button
			//if a url is set load the content...
			var url = $(this).attr('data-ajload');
			if (url) {
				var loaded = $(this).attr('data-loaded');
				// check if we've already made the ajax request (for subsequent checks by bs to getContent())
				if (typeof loaded === 'undefined') {
					$(this).attr('data-loaded', 'true');
					var popover = this;
					jQuery.ajax({
	                    url: url,
	                    type: 'get',
	                    dataType: 'json',
	                    async: false,
	                    success: function(d) {
		                    if (d.data && d.data.content) {
		                    	self.ajcontent[url] = d.data.content;
		                    } else if (d.content) {
			                    self.ajcontent[url] = d.content;
		                    }
	                    }
	                }).fail(function(){
		                 self.ajcontent[url] = 'Sorry, an error occurred.';
	                });
	                return self.ajcontent[url];
	            } else {
		            return self.ajcontent[url];
	            }				
			} else {
				//Either get the content from the button's data-popover-text attribute or from the div reference by data-popover-id
				var html = ( $(this).attr('data-popover-text') ) ? '<p>'+ $(this).attr('data-popover-text') + '</p>' : $('#'+$(this).attr('data-popover-id')).html();
				//add a close button
				html += '<button type="button" class="btn btn-xs btn-link btn-close pull-right">close</button>';
				return html;
			}
		},
		title: function() {
			//If there is a data-title attribute, add the close button and return it
			//'this' is the button
			var title = $(this).attr('data-title');
			if (title) {
				title += '<button type="button" class="btn btn-link btn-close pull-right" aria-label="Close"><i class="fa fa-close"></i></button>';
				return title;
			}
			return '';
		}
	}).on('shown.bs.popover', function(e){
		//when the popover opens, add event handlers for any close buttons
		//also add an aria-controls attribute
		//also "esc" will close the popover if you are focused in it
		//'this' is the button
		var popover = jQuery(this);
		jQuery(this).attr('aria-pressed', true).parent().find('div.popover button.btn-close').on('click keydown', function(e){
			if (e.type === 'click' || (e.type === 'keydown' && e.which === 27)) {
				popover.popover('hide');
			}
		}).attr('aria-controls',  popover.parent().find('div.popover').attr('id') );
	}).on('hidden.bs.popover', function (e) {
		//this fixes a bootstrap box where you had to click twice to reopen a closed popover.
		//see https://github.com/twbs/bootstrap/issues/16732
		if (typeof $(e.target).data("bs.popover").inState !== 'undefined') {
			$(e.target).data("bs.popover").inState.click = false;
		}
    	jQuery(this).attr('aria-pressed', false);
	}).on('keydown.dismiss.bs.popover', function (e) {
		//esc key closes the popover if you are focused on the button
		e.which == 27 && jQuery(this).popover('hide');
	});

}


/*
	
	Example usage:
	
	Basic popovers for buttons with class btn-help-popover that will show below the button
	var helptips = new springSpace.sui.helptip();
	
	Same as above but only activating the buttons inside a specific form
	(This is useful if you dynamically loaded some content and just want to initialize the new popovers)
	var helptips = new springSpace.sui.helptip({ parent: 'form#addUserForm' });
	
	Buttons with class btn-help-popup get popovers that go above the button
	var helptips = new springSpace.sui.helptip({ selector: 'button.btn-help-popup', position: 'top' });
	
	If you need to further manipulate the popovers you can access them via the $el property:
	var helptips = new springSpace.sui.helptip();
	helptips.$el.popover('show'); //opens all the tooltips
	helptips.$el.last().popover('show'); //opens last tooltip in group
	helptips.$el.filter('#help-button-2').popover('show'); //opens the tooltip with the id of 2 (that's the id passed to the HelpTip inastance in php
	
	
*/;
/**
 * UI element: Drag and drop file upload inteface
 * requires: jquery, s-ui-filedrop css file
 */
var springSpace = springSpace || {};
springSpace.sui = springSpace.sui || {};

/**
 * Constructor
 * @param {Object} config Configuration object
 * @param {String} config.selector Selector for the form that contains the filedrop
 * @param {Function} config.callback Success callback for the form submission
 * @param {Function} [config.error_callback] Error callback for the form submission
 * @param {Function} [config.validate] Validation to be called on form submission
 * @param {Number} [config.max_files=0] maximum number of uploads allowed 0=unlimited
 * @param {Number} [config.max_upload_size=0] maximum bytes you can upload to the server at once (probably set in nginx or php or both) 0=unlimited (i.e. don't check)
 * @param {Number} [config.max_file_size=0] maximum bytes for a single file 0=unlimited (i.e. don't check)
 * @param {Boolean} [config.batch_files=false] should files be batched and uploaded in groups if they exceed the max_upload_size
 * @param {Boolean} [config.autoupload=true] automatically submit the form when a file is dropped/added
 * @param {Object} [config.translations] Language values for various messages.
 * @param {Array} [config.allowedMimeTypes] Mime types of files that are allowed. Empty/unset means any.
 * @param {Array} [config.allowedFileExtensions] File extensions that are allowed. Empty/unset means any.
 * @return {Object}
 */
springSpace.sui.filedrop = function(config) {
    if (typeof config === 'undefined') { return false; }
    if (!config.selector || config.selector === '') { return false; }

    let defaultTranslations = {
        max_file_size: 'Maximum file size',
        invalidExtension: 'File is not an allowed file type: ',
    };

    this.callback = (config.callback) ? config.callback : function() {};
    this.error_callback = (config.error_callback) ? config.error_callback : function() {};
    this.validate = (config.validate) ? config.validate : function() { return true; };
    this.max_files = (config.max_files) ? parseInt(config.max_files, 10) : 0;
    this.max_upload_size = (config.max_upload_size) ? parseInt(config.max_upload_size, 10) : 0;
    this.max_file_size = (config.max_file_size) ? parseInt(config.max_file_size, 10) : 0;
    this.batch_files = (typeof config.batch_files !== 'undefined') ? !!config.batch_files : false;
    this.autoupload = (typeof config.autoupload !== 'undefined') ? !!config.autoupload : true;
    this.translations = (config.translations) ? Object.assign(defaultTranslations, config.translations) : defaultTranslations;
    this.allowedMimeTypes = (config.allowedMimeTypes) ? config.allowedMimeTypes : [];
    this.allowedFileExtensions = (config.allowedFileExtensions) ? config.allowedFileExtensions : [];

    /**
     * Can we use the advanced features
     * This will mostly just exclude IE9< I think or people with super archaic FF/Chrome/Safari
     * self invoking function
     * @prop {bool}
     */
    this.isAdvancedUpload = function() {
        var div = document.createElement('div');
        return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div))
            && 'FormData' in window
            && 'FileReader' in window;
    }();

    /**
     * Get the form
     */
    this.$form = jQuery(config.selector);
    if (this.$form.length === 0) { return false; }

    /**
     * This is a div containing the label and input[type=file]
     */
    this.$droparea = this.$form.find('.s-ui-filedrop');

    /**
     * Tracking files that have been dropped to be uploaded
     */
    this.droppedFiles = [];
    /**
     * Files batched into groups so they dont go over the max_upload_size
     */
    this.batchedFiles = [];
    /**
     * Tracking batch progress
     */
    this.batch = { current: 0, total: 0 };

    /**
     * For binding this in events until we can finally use arrow functions
     */
    var self = this;

    /**
     * The actual file input
     */
    this.$input = this.$droparea.find('input[type="file"]');
    /**
     * The label for the file input
     */
    this.$label = this.$droparea.find('label');
    /**
     * Form submit button
     */
    this.$submitbutton = this.$form.find('button[type="submit"]');
    /**
     * Progress bar
     */
    this.$progress = null;

    /**
     * Update the label to show file names
     */
    this.showFiles = function() {
        if (this.$input.length === 0) { return; }

        var fileArea = this.$droparea[0].querySelector('.s-ui-filedrop-filenames');
        var fileList = fileArea.querySelector('ul');

        if (this.isAdvancedUpload) {
            var fileItems = [];
            var total_size = 0;
            this.droppedFiles.forEach(function(file) {
                var item = document.createElement('li');
                item.innerText = file.name;
                fileItems.push(item);
                total_size += file.size;
            });

            fileList.innerHTML = '';
            if (fileItems.length === 0) {
                fileArea.classList.add('hidden');
            } else {
                fileArea.classList.remove('hidden');
                fileItems.forEach(function(li) {
                    fileList.appendChild(li);
                });
            }
            if (this.max_files > 0 && fileItems.length > this.max_files) {
                this.showError(self.max_files + ' file uploads maximum.');
            }
            if (this.batch_files === false && this.max_upload_size > 0 && total_size > this.max_upload_size) {
                this.showError('Files total ' + self.bytesToMB(total_size)
                    + ' MB which exceeds the maximum of ' + self.bytesToMB(this.max_upload_size) + ' MB at a time.');
            }
        } else {
            // only 1 file would be allowed in older browsers
            if (this.$input.val() === '') {
                fileArea.classList.add('hidden');
                fileList.innerHTML = '';
                return;
            }
            fileArea.classList.remove('hidden');
            var item = document.createElement('li');
            item.innerText = this.$input.val().split('\\').slice(-1).pop();
            fileList.appendChild(item);
            this.$label.find('.filetext').addClass('hidden');
        }
    };
    /**
     * Resets the form and files and errors
     */
    this.reset = function() {
        self.$form[0].reset();
        self.removeError();
        self.droppedFiles = [];
        self.batch.current = 0;
        self.batch.total = 0;
        self.stopProgress();
        self.showFiles();
        self.$input.removeClass('has-focus');
    };
    /**
     * Clear the files only
     */
    this.clearFiles = function() {
        self.resetFileInput();
        self.droppedFiles = [];
        self.batch.current = 0;
        self.batch.total = 0;
        self.showFiles();
    };
    /**
     * Reset the input[type=file]
     * the only way to clear a input[type=file] is to reset the whole form or remove/clone the input.
     * For this we will remove/clone, FF won't remove the value/files with a straight clone so we are cloning to a temp form,
     * resetting it, then moving the cloned input to the real form.
     */
    this.resetFileInput = function() {
        if (this.$input.length === 0) { return; }
        var $temp_form = jQuery('<form>');
        var $newinput = this.$input.clone(true).appendTo($temp_form);
        $temp_form[0].reset();
        this.$input.replaceWith($newinput);
        this.$input = $newinput;
    };
    /**
     * Show an error alert inside the drop area (good for file related errors)
     * @param {String} msg An error message
     */
    this.showError = function(msg) {
        if (this.$droparea.length === 0) { return; }
        var msgEl = document.createElement('p');
        msgEl.innerText = msg;
        if (this.$form.find('div.s-ui-filedrop-error').length > 0) {
            this.$form.find('div.s-ui-filedrop-error').append( msgEl );
            return;
        }
        var alert = document.createElement('div');
        alert.classList.add('alert');
        alert.classList.add('alert-danger');
        alert.classList.add('s-ui-filedrop-error');
        alert.setAttribute('role', 'alert');
        alert.appendChild(msgEl);
        this.$droparea.prepend(alert);
    };
    /**
     * Empty the error div, which because of the css will cause it to disappear
     */
    this.removeError = function() {
        this.$form.find('div.s-ui-filedrop-error').empty();
    };
    /**
     * Count how many files have been added to widget
     * @return {Number}
     */
    this.countFiles = function() {
        if (this.$input.length === 0) {
            return 0;
        }
        if (!this.isAdvancedUpload) {
            return (this.$input.val() !== '') ? 1 : 0;
        }
        return this.droppedFiles.length;
    };
    /**
     * Rev up the progress bar so we can start updating it
     */
    this.startProgress = function() {
        if (this.$progress === null || (this.$progress.length === 1 && this.$progress.html() === '')) {
            var existing = true;
            this.$progress = this.$form.find('div.s-ui-filedrop-progress');
            if (this.$progress.length === 0) {
                existing = false;
                this.$progress = jQuery('<div></div>').addClass('s-ui-filedrop-progress');
            }
            var $label = jQuery('<div></div>').attr({ id: 's-ui-filedrop-progresslabel' }).text('Uploading files');
            var $bar = jQuery('<div></div>')
                .addClass('s-ui-filedrop-progbar')
                .attr({
                    role: 'progressbar',
                    'aria-valuenow': '0',
                    'aria-valuemin': '0',
                    'aria-valuemax': '100',
                    'aria-labelledby': 's-ui-filedrop-progresslabel'
                });
            $bar.append( document.createElement('span') );
            this.$progress.append([$label, $bar]);
            // if the progress bar was not already in the page, we should inject it into the drop area
            if (!existing) {
                this.$droparea.prepend( this.$progress );
            }
        }
    };
    /**
     * Update the progress bar, if there is none, add it.
     * @param {number} loaded bytes uploaded
     * @param {number} total total bytes to upload
     */
    this.updateProgress = function(loaded, total) {
        var val = Math.round(loaded / total * 100);
        this.$progress.find('span:first').css('width', val + '%');
        this.$progress.find('.s-ui-filedrop-progbar').attr('aria-valuenow', val);
        if (this.batch.total > 1 && val < 50) {
            var $label = this.$progress.find('div:first');
            $label.html('Uploading file batch (' + this.batch.current + '/' + this.batch.total + ')');
        }
    };
    /**
     * Stop the progress bar (i.e. close/hide it)
     */
    this.stopProgress = function() {
        if (this.$progress !== null) {
            this.$progress.empty();
        }
    };
    /**
     * Convert bytes to MB
     * @param {Number} bytes File in bytes.
     * @return {Number} MB
     */
    this.bytesToMB = function(bytes) {
        return (parseInt(bytes, 10) / (1024 * 1024)).toFixed(1);
    };
    /**
     * Add files from a FileList to the droppedFiles array
     * checking size limitations in the process
     * @param {FileList} filelist A FileList object (Array-like)
     * @return {Boolean}
     */
    this.addFiles = function(filelist) {
        if (self.max_files > 0 && (self.countFiles() + filelist.length) > self.max_files) {
            self.showError(self.max_files + ' file uploads maximum.');
            return false;
        }
        var total_size = 0;
        self.droppedFiles.forEach(function(f) {
            total_size += f.size;
        });

        var invalid_file_indexes = [];
        for (var i = 0; i < filelist.length; i++) {
            var file = filelist[i];

            if (self.droppedFiles.length > 0) {
                //check for dupes by filename
                var dupe = false;
                self.droppedFiles.forEach(function(f) {
                    if (f.name === file.name) {
                        dupe = true;
                    }
                });
                if (dupe) {
                    invalid_file_indexes.push(i);
                    continue;
                }
            }

            if (this.allowedFileExtensions.length > 0) {
                let extension = file.name.split('.').pop();

                if (this.allowedFileExtensions.indexOf(extension) === -1) {
                    self.showError(this.translations.invalidExtension + file.name);
                    invalid_file_indexes.push(i);
                    continue;
                }
            }

            // check for mime-type constraints
            if (this.allowedMimeTypes.length > 0
                && this.allowedMimeTypes.indexOf(file.type) === -1) {
                self.showError('File: ' + file.name + ' is not an allowed file type.');
                invalid_file_indexes.push(i);
                continue;
            }

            if (self.max_file_size > 0 && file.size > self.max_file_size) {
                self.showError('File: ' + file.name + ' is greater than allowed file size of '
                    + self.bytesToMB(self.max_file_size) + ' MB.');
                invalid_file_indexes.push(i); //can't edit filelist so we just have to track which files to ignore later
            } else if (self.batch_files === false && total_size + file.size > self.max_upload_size) {
                self.showError('File: ' + file.name + ' causes files to go over maximum upload size of '
                    + self.bytesToMB(self.max_upload_size) + ' MB at a time.');
                invalid_file_indexes.push(i);
            } else {
                total_size += file.size;
            }
        }
        if (self.batch_files === false && self.max_upload_size > 0 && total_size > self.max_upload_size) {
            self.showError('Files total ' + total_size + ' bytes which exceeds the maximum of '
                + self.bytesToMB(self.max_upload_size) + ' MB at a time.');
            return false;
        }

        for (var x = 0; x < filelist.length; x++) {
            if (invalid_file_indexes.indexOf(x) !== -1) { continue; }
            self.droppedFiles.push( filelist[x] );
        }
        if (self.droppedFiles.length === 0) {
            return false;
        }
        return true;
    };
    /**
     * Create an array of batched files
     * @return {Array}
     */
    this.batchFiles = function() {
        var b = [];
        var sizes = [];

        if (!this.batch_files) {
            b.push(this.droppedFiles);
            return b;
            //???
        }
        var batches = 1;
        b.push([]);
        sizes.push(0);
        this.droppedFiles.forEach(function(file) {
            var added = false;
            sizes.forEach(function(s, i) {
                if (!added && (s + file.size) < self.max_upload_size) {
                    sizes[i] = s + file.size;
                    b[i].push(file);
                    added = true;
                }
            });
            if (!added) {
                sizes.push(0);
                batches++;
                b.push([]);
                var i = batches - 1;
                sizes[i] = file.size;
                b[i].push(file);
            }
        });
        return b;
    };
    /**
     * Are we on the last batch
     * @return {Boolean}
     */
    this.isLastBatch = function() {
        return this.batch.current >= this.batch.total;
    };
    /**
     * Ajax upload event
     * For batches of files this will get called for each batch
     */
    this.ajaxUpload = function() {
        // set current batch number (so processing scripts can deal appropriately)
        self.$form.find('input[name="batch_current"]').val(self.batch.current);

        var ajaxData = new FormData(self.$form[0]);
        // Clear out empty form input... Safari hates the empty one.
        // Make sure delete is supported (it is in at least the latest Safari where we need it.)
        if (typeof ajaxData.delete === 'function') {
            ajaxData.delete(self.$input.attr('name'));
        }
        // add the current batch of files to the formdata (if no batches this is just all the files)
        self.batchedFiles[self.batch.current - 1].forEach(function(file) {
            ajaxData.append( self.$input.attr('name'), file );
        });

        jQuery.ajax({
            url: self.$form.attr('action'),
            type: self.$form.attr('method'),
            data: ajaxData,
            dataType: 'json',
            cache: false,
            crossDomain: true,
            contentType: false,
            processData: false,
            beforeSend: function() {
                // only if we have files!
                if (self.countFiles() > 0) {
                    self.startProgress();
                }
            },
            complete: function() {
                if (self.isLastBatch()) {
                    self.$form.removeClass('is-uploading');
                    self.$submitbutton.prop('disabled', false);
                    self.stopProgress();
                } else {
                    self.batch.current++;
                    // @todo update file list to show which were uploaded in the batch
                    self.ajaxUpload();
                }
            },
            success: function(data) {
                self.callback(data, self);
            },
            xhr: function() {
                // get the native XmlHttpRequest object
                var xhr = jQuery.ajaxSettings.xhr();
                if (self.countFiles() > 0) {
                    // doing this causes CORS requests to preflight
                    xhr.upload.onprogress = function(e) {
                        self.updateProgress(e.loaded, e.total);
                    };
                }
                return xhr;
            }
        }).fail(function(jqxhr) {
            self.error_callback(jqxhr, self);
        });
    };

    /**
     * If available add the drag/drop event handlers
     */
    if (this.isAdvancedUpload && this.$input.length > 0) {
        this.$droparea.addClass('has-advanced-upload');

        // inject inputs for batch file data if appropriate
        if (this.batch_files) {
            var $input1 = jQuery('<input />').attr({
                type: 'hidden',
                name: 'batch_current'
            }).val('0');
            var $input2 = jQuery('<input />').attr({
                type: 'hidden',
                name: 'batch_total'
            }).val('0');
            this.$form.prepend([$input1, $input2]);
        }

        this.$droparea.on('drag dragstart dragend dragover dragenter dragleave drop', function(e) {
            e.preventDefault();
            e.stopPropagation();
        })
            .on('dragover dragenter', function() {
                self.$droparea.addClass('is-dragover');
            })
            .on('dragleave dragend drop', function() {
                self.$droparea.removeClass('is-dragover');
            })
            .on('drop', function(e) {
                var adding = self.addFiles(e.originalEvent.dataTransfer.files);
                self.showFiles();
                if (adding === true && self.autoupload) {
                    self.$form.submit();
                }

            }).on('click', function(e) {
                // delegate for various functions
                var tags = ['A', 'I', 'SPAN', 'B', 'STRONG', 'BUTTON'];
                var tag = e.target.tagName;
                //links and possible children of links
                if (tags.indexOf(tag) !== -1) {
                    var $link = jQuery(e.target).closest('a, button');
                    if ($link.hasClass('s-ui-filedrop-clear')) {
                        // clear files button
                        self.clearFiles();
                        self.removeError();
                    }
                }
            });
    }

    if (!this.isAdvancedUpload) {
        this.$input.remove();
        this.$droparea.remove();
    }

    /**
     * For when files are added using the normal input
     * also a class to help with focus management for keyboard users
     */
    if (this.$input.length > 0) {
        this.$input.on('change', function(e) {
            if (e.target.files) {
                if (self.isAdvancedUpload) {
                    var adding = self.addFiles(e.target.files);
                    self.resetFileInput();
                    if (adding === true && self.autoupload) {
                        self.$form.submit();
                    }
                }
                self.$input.removeClass('has-focus');
                self.showFiles();
            }
        })
            .on('focus', function(e) {
                e.target.classList.add('has-focus');
            })
            .on('blur', function(e) {
                e.target.classList.remove('has-focus');
            });

        // add a warning about max files size if the translation has been included (?)
        if (this.translations.max_file_size) {
            var warning = document.createElement('p');
            warning.innerHTML = this.translations.max_file_size + ': ' + this.bytesToMB(this.max_file_size) + ' MB';
            this.$label.append(warning);
        }
    }

    /**
     * Form submit
     */
    this.$form.on('submit', function(e) {
        // don't preventdefault here as the legacy ajax support requires submitting the form
        if (self.$form.hasClass('is-uploading')) {
            e.preventDefault();
            return;
        }

        self.$form.removeClass('is-error');
        self.removeError();

        if (self.max_files > 0 && self.countFiles() > self.max_files) {
            self.showError(self.max_files + ' file uploads maximum.');
            e.preventDefault();
            return;
        }

        if (self.validate(self) === false) {
            self.$form.addClass('is-error');
            e.preventDefault();
            return;
        }

        self.$form.addClass('is-uploading');
        self.$submitbutton.prop('disabled', true);

        if (self.isAdvancedUpload) {
            e.preventDefault();
            // setup batch file
            self.batch.current = 1;
            self.batchedFiles = self.batchFiles();
            self.batch.total = self.batchedFiles.length;

            self.$form.find('input[name="batch_total"]').val(self.batch.total);

            //this will iterate as necessary over the batches
            self.ajaxUpload();
        } else {
            // ajax no files for legacy
            e.preventDefault();

            jQuery.ajax({
                url: self.$form.attr('action'),
                type: self.$form.attr('method'),
                data: self.$form.serialize(),
                dataType: 'json',
                complete: function() {
                    self.$form.removeClass('is-uploading');
                    self.$submitbutton.prop('disabled', false);
                },
                success: function(data) {
                    self.callback(data, self);
                }
            }).fail(function(jqxhr) {
                self.error_callback(jqxhr, self);
            });
        }
    });
};

/*
    Example usage:

    You must start with a form with method="POST" and enctype="multipart/form-data"
    the form's action attribute should be set to the url you want to send the form/file data to

    The file area itself should be a div.s-ui-filedrop containing an input[type=file] and a label (in that order). It's also best to include a "clear file" button.s-ui-filedrop-clear

    Example:

    <div class="form-group s-ui-filedrop">
        <input type="file" name="file_uploads[]" id="file_uploads" value="" class="sr-only" multiple />
        <label for="file_uploads" class="btn btn-default"><div><i class="fa fa-upload fa-3x"></i></div><span class="filetext"><strong>Choose a file</strong><span class="s-ui-filedrop-dragtext"> or drag it here</span>.</span></label>
        <div class="s-ui-filedrop-filenames hidden"><strong>Selected Files:</strong><ul></ul></div>
        <button type="button" class="btn btn-default btn-xs s-ui-filedrop-clear">Clear Files</button>
    </div>

    Replace "file_uploads" as appopriate for your processing script.
    The FA icon can be changed or removed.
    The text can be changed but the classes should remain the same.
    The clear button is optional, but allows for clearing the files that have been dropped in or selected via the input.
    If you want the progress to appear elsewhere on your form just add a div.s-ui-filedrop-progress that will get used to show the progress bar. It needs to be inside the form though.

    Instantiate with:

    var fileform = new springSpace.sui.filedrop({
        selector: '#someform', // selector for the form,
        max_files: 5, // total files that can be uploaded at a time
        max_upload_size: 0, // max TOTAL upload size in bytes (usually an nginx/php limitation), if using batch_requests, this is the maximum size of each batch, make sure this is slightly smaller than the nginx/php settings as this code is only comparing to the files not any other content sent with the request
        max_file_size: 0, // max single file size in bytes (usually a php limitation)
        allowedMimeTypes: ['image/jpeg', 'image/gif', 'image/png'], // limit types of uploads. Leave unset to allow any type.
        batch_files: true, // if multiple files go over the max_upload_size (but are individually under the max_File_size) then this will cause a series of ajax upload events to occur. WARNING: if you do this you must make sure your processing scripts and callbacks are accounting for multiple form submissions.
        callback: function(data) {
            // do some processing with the data returned from the script.
            // 'this' will reference the s-ui-filedrop object, unless you pass a bound function in which case the s-ui-filedrop object will be passed as the second argument to the callback.
            // data will be the JSON parsed response from the server
            // s-ui-filedrop object will be passed as the second argument
            // NOTE: If using batch uploads this callback MAY be called multiple times. Use isLastBatch() on the s-ui-filedrop object to know if this is the final request/upload
            //
        },
        error_callback: function(jqxhr) {
            // optional
            // this is called as the argument for jQuery ajax fail event
            // so it's when the server doesnt return a 200 response
            // jqxhr object is first argument
            // s-ui-filedrop object will be passed as the second argument
            // you can call reset() on the s-ui-filedrop object to clear the form and all files.
            // NOTE: If using batch uploads this callback MAY be called multiple times. Use isLastBatch() on the s-ui-filedrop object to know if this is the final request/upload
        },
        validate: function() {
            // optional
            // this is called before the ajax event is started
            // return false from this function to stop the ajax event from starting (i.e. fail validation)
            // the s-ui-filedrop object will be passed as the first argument to the validate function.
            // throw file errors with showError(msg) on the s-ui-filedrop object
            // for batch uploads this is only called before any of the ajax requests start. If you want to validate files in some custom way use the droppedFiles array of File items on the s-ui-filedrop object
        }
    });

    NOTE Batch uploads:
    When batch uploads are enabled the form will POST batch_current and batch_total values along with other form content. You can use this to know if there will be batches of the same form submitted

    NOTE Crossdomain Usage:
    Using CORS you can do crossdomain file uploads, but be aware that the progress bar code will force the a preflight check on the CORS request. The preflight is an OPTIONS request to the url you only need to return a 200 code, your normal headers, and your "Access-Control-Allow-Origin" header. That will let the browser know it is ok to send the real request. (So in dev tools Networking you will see two requests to the submit url.

*/
;
/**
 * UI element: Cookie consent alert.
 * requires: jquery, bootstrap
 */
var springSpace = springSpace || {};
springSpace.cookieConsent = springSpace.cookieConsent || {};

/**
 *  Cookie consent header/footer alert.
 *  @param {Object} config array of configuration parameters
 *
 */
springSpace.cookieConsent.alert = function (config) {
    /**
     * Set configuration properties.
     *
     * @param {Object} config
     * @param {String} config.placement Placement position for alert 'top' or 'bottom'. Default = 'bottom'.
     * @param {String} config.aria_label the aria_label message for accessibility. Default = 'User Privacy Alert'
     * @param {Number} config.cookie_exp_days Number of days after which 'accepted' cookie expires. Default = 180.
     * @param {Function} config.read_more_callback Callback function that gets bound to 's-ui-cc-read-more-link'.
     * @param {String} config.consent_message Text of alert message.
     */
    this.setConfig = function (config) {
        if (typeof(config) == 'undefined') {
            config = {};
        }

        var okayLabel = ((config.okay) ? config.okay : 'OK');

        this.placement_opts = ['bottom', 'top'];

        // Set config.
        this.placement = (this.placement_opts.indexOf(config.placement) !== -1) ? config.placement : 'bottom';
        this.cookie_name = 'springy_cookie_consent';
        this.cookie_notice_accepted = 'ok';
        this.cookie_exp_days = (config.cookie_exp_days) ? config.cookie_exp_days : 180;
        this.read_more_callback = (config.read_more_callback) ? config.read_more_callback : function() {};

        this.aria_label = config.aria_label || 'User Privacy Alert';
        this.fade_in = 500;
        this.fade_out = 200;
        this.container_id = 's-ui-cc-container';
        this.close_button_id = 's-ui-cc-close-btn';

        //Note: this id is highly coupled. Not to mention the other ids.
        // why do the consumer apps (LibCal, LibGuides) need to render the HTML
        //with these hardcoded ids?
        this.read_more_elt_id = 's-ui-cc-read-more-link';
        this.consent_message = ( (config.consent_message) ? config.consent_message : 'By using our website you are consenting to our use of cookies in accordance with our cookie policy.');
        this.content = '<div id="' + this.container_id + '" class="container" style="display: none;">' +
            '    <aside class="navbar navbar-default navbar-fixed-' + this.placement + ' fixed-' + this.placement + '" id="s-ui-cc-navbar" aria-label="' + this.aria_label + '">' +
            '        <div id="s-ui-cc-main" class="container">' +
            '            <div class="navbar-inner navbar-content-center" id="s-ui-cc-msg-container">' +
            '                <div id="s-ui-cc-msg">' + this.consent_message + '<button id="' + this.close_button_id + '" type="button" class="btn btn-sm btn-default btn-light" data-dismiss="alert" aria-label="Close">' + okayLabel + '</button></div>' +
            '            </div>' +
            '        </div>' +
            '    </aside>' +
            '</div>';
    };

    /**
     * Check to see if the consent cookie exists.
     * @returns {boolean}
     */
    this.consentCookieAccepted = function () {
        var consent = this.getCookie(this.cookie_name);

        return (consent === this.cookie_notice_accepted);
    };

    /**
     *  Set cookie value.
     *  @param {string} cookie_name - Cookie name
     *  @param {string} value - Cookie value
     *  @param {number} exdays - Days until expiration
     */
    this.setCookie = function (cookie_name, value, exdays) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + exdays);
        var cookie_value = encodeURI(value) + ((exdays === null) ? '' : '; expires=' + exdate.toUTCString());
        // only set the secure flag if the page was loaded over https
        var secureFlag = (location.protocol === 'https:') ? '; secure' : '';
        document.cookie = cookie_name + '=' + cookie_value + '; path=/; samesite=lax;' + secureFlag;

        jQuery('#' + this.container_id).hide('slow');
    };

    /**
     *  Get cookie
     *  @param {string} cookie_name - Cookie name
     *  @return {string} The cookie value
     */
    this.getCookie = function (cookie_name) {
        var i;
        var index_of_equals;
        var c_name;
        var c_value;
        var cookie_arr = document.cookie.split(";");

        for (i = 0; i < cookie_arr.length; i++) {
            index_of_equals = cookie_arr[i].indexOf("=");
            c_name = cookie_arr[i].substr(0, index_of_equals).replace(/^\s+|\s+$/g, "");

            if (c_name === cookie_name) {
                c_value = cookie_arr[i].substr(index_of_equals + 1);
                return decodeURI(c_value);
            }
        }

        return null;
    };

    /**
     *  Set the accepted cookie and close the alert.
     */
    this.handleClose = function () {
        // Set the 'accepted' cookie.
        this.setCookie(this.cookie_name, this.cookie_notice_accepted, this.cookie_exp_days);

        // Fade out the alert.
        jQuery("#" + this.container_id).fadeOut(this.fade_out);
    };

    /**
     *  Display the cookie consent alert if not already accepted.
     */
    this.handleAlert = function () {
        // If the consent cookie is not set, display the alert.
        if ( this.consentCookieAccepted() ) {
            return;
        }

        // Add the alert html to the body, pre-pended
        jQuery('body').prepend(this.content);

        // Fade in the alert.
        jQuery("#" + this.container_id).fadeIn(this.fade_in);

        // Close button handler.
        jQuery("#" + this.close_button_id).on("click", this.handleClose.bind(this));

        // Read more handler.
        // assign a href in order for the tabbing to work on this
        // do it here in common because we need to make sure the href is #. (and not generate other tickets)
        jQuery("#" + this.read_more_elt_id).attr('href', '#');
        jQuery("#" + this.read_more_elt_id).on("click", this.read_more_callback.bind(this));
    };

    this.setConfig(config);

    jQuery(document).ready(this.handleAlert.bind(this));

};
;
/**
 * JS functions used across the whole system (admin and public)
 */

var springSpace = springSpace || {};
springSpace.la = springSpace.la || {};
springSpace.util = {};
springSpace.ui = {};

//========================================================
// Springshare utility object.
//========================================================
springSpace.util._construct = function() {
    //====================================================
    function Util() {

    }
    /**
     * Replace %1, %2, etc with strings from an array (like php sprint_f)
     */
    Util.prototype.stringFormat = function(str, arr) {
        return str.replace(/%(\d+)/g, function(_,m) {
            return arr[--m];
        });
    };
    /**
     * select some text (for copy/pasting)
     * @param object DOM element to select
     */
    Util.prototype.selectText = function(element) {
        var doc = document
            , text = element
            , range, selection
        ;
        if (doc.body.createTextRange) {
            range = document.body.createTextRange();
            range.moveToElementText(text);
            range.select();
        } else if (window.getSelection) {
            selection = window.getSelection();
            range = document.createRange();
            range.selectNodeContents(text);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    };
    /**
     * Repopulate a form from a serialized query string
     * @param {String} string query string from url
     * @param {String} form id of form
     */
    Util.prototype.rePopForm = function (string, form) {
        string = string.replace(/^\?/, '');
        string = decodeURIComponent(string);
        var parts = string.split('&');
        var $form = jQuery('#'+form);
        for (var i = 0; i < parts.length; i++) {
            var pair = decodeURIComponent(parts[i]).split('=');
            var _name = pair[0];
            var value = pair[1];
            if (typeof value == 'undefined') { continue; }
            value = value.replace(/\+/g, ' ');

            //account for multiselect/array
            //sometimes it comes in as key[0], key[1] rather than just key[]
            if (_name.match(/\[.*?\]/)) {
                var newname = _name.replace(/\[.*?\]/, '[]');
                var $select = $form.find('select[name=\"' + newname + '\"]');
                if (typeof $select.data('multiselect') == 'undefined'){
                    $select.find('option[value='+value+']').prop('selected', true);
                } else {
                    $select.multiselect('select', value);
                }
            } else {
                var $input = $form.find('*[name=\"' + _name + '\"]');
                if (typeof $input.data('multiselect') == 'undefined'){
                    $input.val(value);
                } else {
                    $input.multiselect('select', value);
                }
            }
        }
    };
    //====================================================
    this.Util = Util;
}
//========================================================
springSpace.util._construct();
springSpace.Util = new springSpace.util.Util();

/**
 * Close a Bootstrap modal
 * @param {String} [modal_id] id of modal div, else will default to a displayed element with class modal
 */
function closeModal(modal_id) {
    var $modal = null;
    if (typeof modal_id == 'undefined') {
        jQuery('.modal').each(function(i, el){
            if (jQuery(el).css('display') !== 'none') {
                $modal = jQuery(el);
            }
        });
    } else {
        $modal = jQuery('#'+modal_id);
    }

    if ($modal !== null) {
        //$modal.modal('hide');
        $modal.modal('hide').removeData('bs.modal').find('.modal-content').html('')
    }
}
/**
 * Disables a button
 * @param {String} btnsel selector for button
 */
function disableButton(btnsel) {
    if (!btnsel) { return; }
    if (['#', '.'].indexOf(btnsel.charAt(0)) === -1 ) {
        btnsel = '#'+btnsel;
    }
    jQuery(btnsel).prop('disabled', true);
}
/**
 * reenables a button
 * @param {String} btnsel selector for button
 */
function enableButton(btnsel) {
    if (!btnsel) { return; }
    if (['#', '.'].indexOf(btnsel.charAt(0)) === -1 ) {
        btnsel = '#'+btnsel;
    }
    jQuery(btnsel).prop('disabled', false);
}


/**
 * Notification functions used through the system
 */
// eslint-disable-next-line no-var, no-unused-vars
var errorAlert = function(msg = '') {
    window.suiNotify.hideWorking();
    window.suiNotify.error(msg);
};
// eslint-disable-next-line no-var, no-unused-vars
var successAlert = function(msg = '', ms = 0) {
    window.suiNotify.hideWorking();
    if (msg === '') {
        ms = 5000;
    }
    window.suiNotify.success(msg, null, ms);
};
// eslint-disable-next-line no-var, no-unused-vars
var workingAlert = function(msg = '') {
    window.suiNotify.working(msg);
};
/**
 * Hide working alerts only
 */
// eslint-disable-next-line no-var, no-unused-vars
var stopAlert = function() {
    window.suiNotify.hideWorking();
};

/**
 * Generic get error message from Response class error.
 * @deprecated prefer version in tools/requestUtil.js when possible
 * @param {Object} jqXhr JQuery xhr object.
 * @returns {String}
 */
// eslint-disable-next-line no-var
var jqGetAjaxError = function(jqXhr) {
    let error = '';
    if (jqXhr.responseText) {
        try {
            const response = JSON.parse(jqXhr.responseText);
            if (response.error) {
                error = response.error;
            }
        } catch (e) {
            error = 'Invalid response received';
        }
    }
    return error;
};
/**
 * Generic fail callback for jQuery ajax requests.
 * This handles the object error genered in the php Response class.
 * @param {Object} jqXhr JQuery xhr object.
 */
// eslint-disable-next-line no-var, no-unused-vars
var jqAjaxFailCallback = function(jqXhr) {
    const error = jqGetAjaxError(jqXhr);
    errorAlert(error);
};

/**
 * Create a dismissable error alert for insertion into the DOM.
 * Uses bootstrap.
 * @param {String} message HTML Error message (html)
 * @param {String} id Optional html id for alert.
 * @returns {HTMLElement}
 */
var createDismissableErrorAlert = function(message = '', id = '') {
    if (!message) {
        message = 'Error';
    }
    return createDismissableAlert(message, 'danger', id);
};

/**
 * Create a dismissable success alert for insertion into the DOM.
 * Uses bootstrap.
 * @param {String} message HTML Error message (html)
 * @param {String} id Optional html id for alert.
 * @returns {HTMLElement}
 */
var createDismissableSuccessAlert = function(message = '', id = '') {
    if (!message) {
        message = 'Success';
    }
    return createDismissableAlert(message, 'success', id);
};

/**
 * Create a dismissable error alert for insertion into the DOM.
 * Message generated from jquery ajax error.
 * Uses bootstrap.
 * @param {Object} jqXhr JQuery xhr object.
 * @returns {HTMLElement}
 */
var createDismissableJQAjaxFailAlert = function(jqXhr) {
    const error = jqGetAjaxError(jqXhr);
    return createDismissableErrorAlert(error);
};

/**
 * Create a dismissable alert for insertion into the DOM.
 * Uses bootstrap.
 * @param {String} message HTML Error message (html)
 * @param {String} colorClass Bootstrap based (danger, success, info, etc.)
 * @param {String} id Optional html id for alert.
 * @returns {HTMLElement}
 */
var createDismissableAlert= function(message, colorClass, id = '') {
    var alert = document.createElement('div');
    if (id !== '') {
        alert.id = id;
    }
    alert.classList.add('alert', 'alert-' + colorClass, 'alert-dismissable', 'mg-top');
    alert.setAttribute('role', 'alert');
    alert.setAttribute('aria-atomic', 'true');
    var button = document.createElement('button');
    button.type = 'button';
    button.classList.add('close');
    button.setAttribute('aria-label', 'close');
    button.setAttribute('data-dismiss', 'alert');
    button.innerHTML = '<span aria-hidden="true">&times;</span>';
    alert.appendChild(button);
    alert.insertAdjacentHTML('beforeend', message);
    return alert;
};

/**
 * Wrapper to instantiate bootstrap multi-select so we can set language settings.
 * @param {Object} $el jQuery object of a SELECT element.
 * @param {Object} config Config object passed to boostrap-multiselect. See docs for valid properties.
 */
var enableMultiSelect = function($el, config) {
    if ($el.length === 0) {
        return;
    }
    // set up some base configs.
    var newConfig = {};
    if (springyText && springyText.bsMultiselect) {
        // Add the custom configs.
        Object.keys(springyText.bsMultiselect).forEach(function(key) {
            newConfig[key] = springyText.bsMultiselect[key];
        });
    }

    // Add the custom configs.
    Object.keys(config).forEach(function(key) {
        newConfig[key] = config[key];
    });

    $el.multiselect(newConfig);
};

/**
 * Reset one of those boostrap multiselect things
 * @param {String} selector For the select
 * @param {String|Number} value Value to reset to.
 */
const resetMultiSelect = function(selector, value) {
    const $select = jQuery(selector);
    $select.multiselect('deselectAll');
    $select.multiselect('select', value);
    $select.multiselect('refresh');
};
;
/**
 * Reusable regular expressions for through LA code
 */
var springSpace = springSpace || {};

springSpace.regex = {
    /**
	 * decent email check without being insane
	 * this will not cover full international addresses which at some point will probably start to be an issue
	 */
    email: /^<?(['a-zA-Z0-9_=\.\-\+&!#\$%\*\?\^\|\{\}\~])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,6})+>?$/i,
    /**
	 * URL check, not perfect
	 */
    url: /^((mailto|https?):)*\/\/.+/i,
    /**
	 * Phone number / sms numbers, no spaces or punctuation
	 * except optional starting +
	 */
    phone: /^\+?[0-9]{10,}$/,
    /**
	 * Date in the format yyyy-mm-dd
	 */
    date: /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/,
    /**
	 * Date time in format yyyy-mm-dd hh:mm with optional :ss
	 */
    datetime: /^[0-9]{4}-[0-9]{2}-[0-9]{2}\s[0-9]{1,2}:[0-9]{2}(:[0-9]{2})?$/,
    /**
	 * HTML hex color
	 */
    color: /^#([a-f0-9A-F]{6}|[a-f0-9A-F]{3})$/
};
;

(function(root) {
    root.springSpace = root.springSpace || {};
    root.springSpace.la = root.springSpace.la || {};

    // see QueueConstants
    const AUTOREPLY_TYPE_INACTIVE = 0;
    const AUTOREPLY_TYPE_ALWAYS = 1;
    const AUTOREPLY_TYPE_OFFHOURS = 2;
    const AUTOREPLY_TYPE_SCHEDULED = 3;

    /**
     * Auto reply settings for deciding if captcha should be shown
     * @deprecated prefer usage in js/public/QuestionForm.js for import
     */
    class FormAutoReply {
        /**
         * @prop {Number} type Type of autoreply (see constants)
         * @prop {Number|null} start schedule start date in unix seconds
         * @prop {Number|null} end schedule end date in unix seconds
         * @prop {Boolean} libauth_enabled Is Libauth on for the form
         */
        constructor({
            type = 0,
            start = null,
            end = null,
            offhours = null,
            captchaAlwaysOn = false,
            libauth_enabled = false
        }) {
            this.type = type;
            this.start = start;
            this.end = end;
            this.offhours = offhours;
            this.captchaAlwaysOn = captchaAlwaysOn;
            this.libauth_enabled = libauth_enabled;
        }
        /**
         * Should we enable the captcha because of the autoreply.
         * @returns {Boolean}
         */
        isCaptchaEnabled() {
            if (this.libauth_enabled) {
                return false;
            }
            if (this.captchaAlwaysOn) {
                return true;
            }
            return this.isAutoReplyEnabled();
        }
        /**
         * Is auto-reply enabled.
         * @returns {Boolean}
         */
        isAutoReplyEnabled() {
            if (this.type === AUTOREPLY_TYPE_INACTIVE) {
                return false;
            }
            if (this.type === AUTOREPLY_TYPE_ALWAYS) {
                return true;
            }
            if (this.type === AUTOREPLY_TYPE_SCHEDULED) {
                return this._isBetweenDates();
            }
            if (this.type === AUTOREPLY_TYPE_OFFHOURS) {
                return this._isNowOffHours();
            }
            return false;
        }

        /**
         * Get auto reply type
         * @returns {Number}
         */
        getAutoReplyType() {
            return this.type;
        }
        /**
         * Is now between the start/end timestamps.
         * @returns {Boolean}
         */
        _isBetweenDates() {
            if (!this.end || !this.start) {
                return false;
            }
            // calculate now compared to start/end.
            // milliseconds to unix seconds
            const unixTime = Math.floor(Date.now() / 1000);
            return (unixTime >= this.start
                && unixTime <= this.end);
        }

        _isNowOffHours() {
            // calculate day and hour compared to off hours.
            // @todo refactor offhours so we can get them in UTC
            // for now we'll just calc this in the captcha request endpoint
            return true;
        }
    }

    root.springSpace.la.FormAutoReply = FormAutoReply;
})(window);
;

(function(root) {
    root.springSpace = root.springSpace || {};
    root.springSpace.la = root.springSpace.la || {};

    // see QuestionFormConstants
    const ruleConstants = Object.freeze({
        RULE_OPERATOR_EQUALS: 0,
        RULE_OPERATOR_NOTEQUALS: 1,
        RULE_OPERATOR_INCLUDES: 2,
        RULE_OPERATOR_INCLUDES_ALL: 3,
        RULE_ACTION_SHOW: 0,
        RULE_ACTION_HIDE: 1,
        RULE_ACTION_NONE: -1
    });

    /**
     * Field Rules
     * @deprecated prefer usage in js/public/QuestionForm.js for import
     */
    class FormFieldRule {
        /**
         * @prop {Number} field1 Field which can trigger changes
         * @prop {Number} operator Constant for = !=
         * @prop {Array<Number>} value Field 1's value that triggers change
         * @prop {Number} field2 Field that is effected
         * @prop {Number} action Constant for show/hide
         */
        constructor({
            field1 = 0,
            operator = ruleConstants.RULE_OPERATOR_EQUALS,
            value = [],
            field2 = 0,
            action = ruleConstants.RULE_ACTION_SHOW
        }) {
            this.field1 = field1;
            this.operator = operator;
            this.value = Array.isArray(value) ? value : [];
            this.field2 = field2;
            this.action = action;
        }

        get oppositeAction() {
            return this.action === ruleConstants.RULE_ACTION_SHOW
                ? ruleConstants.RULE_ACTION_HIDE
                : ruleConstants.RULE_ACTION_SHOW;
        }
        /**
         * Based on value of field do we hide/show/nothing.
         * @param {Number|Array<Number>} field2value Current field value.
         * @returns {Number}
         */
        getFieldAction(field2value) {
            // if field is reset to no answer then hide
            if (field2value === 0 || field2value.length === 0) {
                return ruleConstants.RULE_ACTION_HIDE;
            }
            switch (this.operator) {
                case ruleConstants.RULE_OPERATOR_EQUALS:
                    return this.value.includes(field2value)
                        ? this.action
                        : this.oppositeAction;
                case ruleConstants.RULE_OPERATOR_NOTEQUALS:
                    return !this.value.includes(field2value)
                        ? this.action
                        : this.oppositeAction;
                case ruleConstants.RULE_OPERATOR_INCLUDES:
                    if (!Array.isArray(field2value)) {
                        return ruleConstants.RULE_ACTION_NONE;
                    }
                    // At least one must match
                    return field2value.filter((el) => {
                        return this.value.includes(el);
                    }).length > 0
                        ? this.action
                        : this.oppositeAction;
                case ruleConstants.RULE_OPERATOR_INCLUDES_ALL:
                    if (!Array.isArray(field2value)) {
                        return ruleConstants.RULE_ACTION_NONE;
                    }
                    // All must match
                    return field2value.filter((el) => {
                        return this.value.includes(el);
                    }).length === this.value.length
                        ? this.action
                        : this.oppositeAction;
            }
            return ruleConstants.RULE_ACTION_NONE;
        }
    }

    root.springSpace.la.FormFieldRule = FormFieldRule;
})(window);
;
/**
 * JS functions for public pages
 */

//!Idea Form
springSpace.la.ideaform = function(config) {

    this.$form = jQuery('#ideaform');
    this.errormsg = config.errormsg;

    var that = this;
    this.$form.on('submit', function(e){
        e.preventDefault();

        that.$form.find('label .error-message').remove();
        that.$form.find('.form-group').removeClass('has-error');
        that.$form.find('.form-control').attr('aria-invalid', false);
        var error_msg = '';

        var $titlefield = that.$form.find('input[name=title]');
        if ($titlefield.val() == ""){
            that.markError($titlefield, that.errormsg.reqfields);
        }
        var $bodyfield = that.$form.find('textarea[name=body]');
        if ($bodyfield.val() == ""){
            that.markError($bodyfield, that.errormsg.reqfields);
        }

        var $emailfield = that.$form.find('input[name=email]');
        var emailask = $emailfield.val().trim();

        if (!emailask.match(springSpace.regex.email)) {
            that.markError($emailfield, that.errormsg.emailaddress);
        }

        if ( that.$form.find('.has-error').length > 0 ) {
            errorAlert();
            that.$form.find('*[aria-invalid=true]:first').focus();
            return false;
        }

        jQuery.ajax({
            url: that.$form.attr('action'),
            method: that.$form.attr('method'),
            data: that.$form.serialize()
        }).done(function(){
            successAlert();
        }).fail(
            jqAjaxFailCallback
        ).always(function() {
            closeModal();
        });
    });

    //set an error (msg) for the input (id)
    this.markError = function($input, msg) {
        var msg_div = jQuery('<div class="error-message"></div>').html(msg);
        $input.attr('aria-invalid', true).parent().addClass('has-error').find('label').append(msg_div);
    }

} //end ideaform
//========================================================
//!Idea Comment Form
springSpace.la.ideacommentform = function(config) {

    this.$form = jQuery('#ideacommentform');
    this.errormsg = config.errormsg;

    var that = this;
    this.$form.on('submit', function(e){
        e.preventDefault();

        that.$form.find('label .error-message').remove();
        that.$form.find('.form-group').removeClass('has-error');
        that.$form.find('.form-control').attr('aria-invalid', false);
        var error_msg = '';

        var $emailfield = that.$form.find('input[name=email]');
        var emailask = jQuery.trim( $emailfield.val() );
        if (!emailask.match(springSpace.regex.email)) {
            that.markError($emailfield, that.errormsg.emailaddress);
        }

        if ( that.$form.find('.has-error').length > 0 ) {
            errorAlert();
            that.$form.find('*[aria-invalid=true]:first').focus();
            return false;
        }

        jQuery.ajax({
            url: that.$form.attr('action'),
            data: that.$form.serialize(),
            method: that.$form.attr('method')
        }).done(function(d){
            successAlert();
            if (d.upvote == 1) {
                var $votediv = jQuery('#product_idea_'+d.idea_id+' .s-la-idea-upvotes');
                var vote = parseInt($votediv.text(), 10) + 1;
                $votediv.text(vote);
            } else if (d.downvote == 1) {
                var $votediv = jQuery('#product_idea_'+d.idea_id+' .s-la-idea-downvotes');
                var vote = parseInt($votediv.text(), 10) + 1;
                $votediv.text(vote);
            }
            closeModal();
        }).fail(jqAjaxFailCallback);

    });

    //set an error (msg) for the input (id)
    this.markError = function($input, msg) {
        var msg_div = jQuery('<div class="error-message"></div>').html(msg);
        $input.attr('aria-invalid', true).parent().addClass('has-error').find('label').append(msg_div);
    }

    this.$form.find('.btn-cancel').on('click', function(e){
        closeModal();
    });

} //end ideacommentform


////////////////////////////////
//Public FAQ page

/**
 * Records a hit/view for an FAQ.
 * @param {Number} faqId FAQ id.
 * @param {Number} instId Site instid.
 * @param {Number} hitType Type of view/share (ses FAQStatConstants).
 */
const faqHit = function(faqId, instId, hitType) {
    // Fire and forget, we don't need to tell the patron if the stat failed.
    jQuery.ajax({
        method: 'POST',
        url: `/faq/${faqId}/view`,
        data: {
            type: hitType
        },
        dataType: 'json'
    });
};

/**
 * Vote on an FAQ.
 * @param {Number} faqId FAQ id to vote on.
 * @param {Number} v The yes (1) or no (0).
 */
const faqVote = function(faqId, v) {
    if (!faqId) {
        return;
    }

    jQuery.ajax({
        method: 'POST',
        url: `/faq/${faqId}/vote`,
        data: {
            v: v
        },
        dataType: 'json'
    })
        .done((d) => {
            if (!d.success) {
                return;
            }
            let counter = null;
            if (d.vote === 1) {
                counter = jQuery('#s-la-vote-yes-ct');
                counter.html( parseInt(counter.text()) + 1 );
                jQuery('#s-la-vote-yes').addClass('voted');
            } else if (d.vote === 0) {
                counter = jQuery('#s-la-vote-no-ct');
                counter.html( parseInt(counter.text()) + 1 );
                jQuery('s-la-vote-no').addClass('voted');
            }
            jQuery('#s-la-vote button').attr('disabled', 'true');
        })
        .fail(jqAjaxFailCallback);
};

/**
 * Get related FAQs.
 * @param {Number} faqid Current faqid.
 */
const loadRelatedFAQs = function(faqid) {
    const relatedFAQList = document.getElementById('s-la-faq-relatedfaqs');
    if (!relatedFAQList) {
        return;
    }
    $.ajax({
        method: 'GET',
        url: `/faq/${faqid}/related`,
        dataType: 'json'
    })
        .done((data) => {
            if (data.content) {
                relatedFAQList.innerHTML = data.content;
            }
        })
        .fail(() => {
            // Ignore
        });
};

/**
 * FAQ Page
 * Zindex fix for videos in iframes (is this still necessary?)
 */
const fixMediaZindex = function() {
    document.querySelectorAll('.s-la-faq-media-wrapper iframe').forEach((el) => {
        const src = el.getAttribute('src');
        const wmode = 'wmode=transparent';
        if (src.indexOf('?') !== -1) {
            el.setAttribute('src', `${src}&${wmode}`);
        } else {
            el.setAttribute('src', `${src}?${wmode}`);
        }
    });
};

/**
 * FAQ Page vote button handlers.
 * @param {Number} faqid Current faqid.
 */
const faqVoteButtons = function(faqid) {
    document.querySelectorAll('#s-la-vote-no, #s-la-vote-yes').forEach((el) => {
        el.addEventListener('click', (ev) => {
            ev.preventDefault();
            const btn = ev.currentTarget;
            const warn = btn.dataset.warn;
            if (warn !== '') {
                alert(warn);
                return;
            }
            const type = parseInt(btn.dataset.vote, 10);
            faqVote(faqid, type);
        });
    });
};

/**
 * Setup handlers/actions on FAQ Answer page.
 * @param {Number} faqid Current faq id
 * @param {Number} instId Current site instid
 * @param {Boolean} isPreview Is user previewing FAQ.
 * @param {String} redirectUrl the URL to redirect this page to, if any
 */
const setUpAnswerPage = function(faqid, instId, isPreview, redirectUrl) {
    if (faqid <= 0) {
        return;
    }
    if (!isPreview) {
        // FAQStatConstants::VIEW_TYPE_FAQPAGE
        faqHit(faqid, instId, 1);
    }
    if (redirectUrl && redirectUrl !== document.referrer) {
        window.location.href = redirectUrl;
    }
    loadRelatedFAQs(faqid);
    fixMediaZindex();
    faqVoteButtons(faqid);
};

/**
 * Actions for all public pages.
 */
const setUpPublicPage = function() {
    // Clear any libauth token from the url bar so reloads don't re-use it.
    const url = new URL(window.location);
    if (url.searchParams.has('token')) {
        url.searchParams.delete('token');
        history.replaceState({}, '', url.toString());
    }

    // Event delegation for clicks.
    document.body.addEventListener('click', (ev) => {
        const tags = ['A', 'I', 'SPAN', 'B', 'STRONG'];
        const tag = ev.target.tagName;
        //links and possible children of links
        if (tags.indexOf(tag) === -1) {
            return;
        }
        const link = ev.target.closest('a');
        if (!link) {
            return;
        }
        let modal = null;
        if (link.classList.contains('imagepreviewlink')) {
            // image previews in FAQs
            ev.preventDefault();
            modal = new springSpace.sui.modal({ url: link.getAttribute('href'), size: 'large' });
        } else if (link.classList.contains('modallink')) {
            ev.preventDefault();
            modal = new springSpace.sui.modal({ url: link.getAttribute('href') });
        }
    });
};

/**
 * Calculates document height.
 * Used by Question Form in search page modal to make sure the iframe it's embedded in is big enough.
 * When we refactor search JS we should be able to put the form in the page without the frame.
 * @returns {Number}
 */
const getDocHeight = function() {
    return Math.max(
        Math.max(document.body.scrollHeight, document.documentElement.scrollHeight),
        Math.max(document.body.offsetHeight, document.documentElement.offsetHeight),
        Math.max(document.body.clientHeight, document.documentElement.clientHeight)
    );
};
;
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

;// ./js/datepicker/src/base.js
class BaseElement extends HTMLElement {
    static get props() {
        return {};
    }

    static get observedAttributes() {
        return Object.keys(this.props).map((propName) => {
            return this.attributeName(propName);
        });
    }

    static attributeName(propName) {
        return propName.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase();
    }

    constructor() {
        super();

        // property is element id, value is the element
        // for any element with an id in the shadowroot
        this.$ = {};
        // two objects mapping property name to attribute name (and the reverse)
        this.attrToProp = {};
        this.propToAttr = {};
        Object.keys(this.constructor.props).forEach((name) => {
            const attrName = this.constructor.attributeName(name);
            this.attrToProp[attrName] = name;
            this.propToAttr[name] = attrName;
        });

        this.attachShadow({ mode: 'open' });

        this._renderPromise = null;
        this._isConnected = false;

        // regular reset object of props that changed
        // and triggered a rerender
        this._triggers = {};
        // storing prop name and values
        // seems to proxy them through getters/setters
        this._props = {};
    }

    connectedCallback() {
        if (this._isConnected) {
            return;
        }
        const initialProps = Object.keys(this.constructor.props).reduce(
            (all, propName) => {
                return {
                    ...all,
                    [propName]: this[propName]
                };
            },
            {}
        );

        Object.keys(this.constructor.props).forEach((propName) => {
            const propertyInfo = this.constructor.props[propName];
            const attrName = this.propToAttr[propName];

            let initialValue = this[propName];

            if (this.hasAttribute(attrName)) {
                initialValue = this.getAttribute(attrName);
                if ([Array, Object].includes(propertyInfo.type)) {
                    try {
                        initialValue = JSON.parse(initialValue);
                    } catch (err) {
                        // ignore
                    }
                }
            } else if (initialProps[propName] !== undefined) {
                initialValue = initialProps[propName];
            }

            Object.defineProperty(this, propName, {
                set: this.setter(propName),
                get: this.getter(propName)
            });

            this[propName] = initialValue;
        });

        this._isConnected = true;

        this._render(true, true);
    }

    disconnectedCallback() {
        this._isConnected = false;
    }

    _requestRender() {
        if (!this._renderPromise) {
            this._renderPromise = Promise.resolve().then(() => {
                this._render();
            });
        }
    }

    _render(force = false, first = false) {
        if (
            !force &&
            !Object.keys(this._triggers).length
        ) {
            return;
        }

        this._renderPromise = Promise.resolve().then(() => {
            if (first) {
                this.firstRender(this.shadowRoot, this._triggers);

                this.$ = [...this.shadowRoot.querySelectorAll('[id]')].reduce((all, el) => {
                    return {
                        ...all,
                        [el.id]: el
                    };
                }, {});

                this.firstRendered(this.shadowRoot, this._triggers);
            }

            this.render(this.shadowRoot, this._triggers);
            this.rendered(this.shadowRoot, this._triggers);

            this._renderPromise = null;
            this._triggers = {};
        });
    }

    forceRender() {
        this._render(true);
    }

    firstRender() {}

    render() {}

    firstRendered() {}

    rendered() {}

    setter(propName) {
        const attrName = this.propToAttr[propName];

        return (value) => {
            if (this._props[propName] === value) return;

            if (!(propName in this._triggers)) {
                this._triggers[propName] = this._props[propName];
            }

            this._props[propName] = value;

            const propertyInfo = this.constructor.props[propName];

            if (this._isConnected && this.constructor.observedAttributes.includes(attrName)) {
                let attributeValue = value;

                if (propertyInfo.type === Boolean) {
                    attributeValue = attributeValue || attributeValue === '';
                    if (attributeValue) {
                        this.setAttribute(attrName, '');
                    } else {
                        this.removeAttribute(attrName);
                    }
                } else {
                    if ([Array, Object].includes(propertyInfo.type)) {
                        attributeValue = JSON.stringify(attributeValue);
                    }

                    if (this.getAttribute(attrName) !== attributeValue) {
                        if ([null, undefined].includes(attributeValue)) {
                            this.removeAttribute(attrName);
                        } else {
                            this.setAttribute(attrName, attributeValue);
                        }
                    }
                }
            }

            if (this._isConnected) {
                this._requestRender();
            }
        };
    }

    getter(propName) {
        return () => this._props[propName];
    }

    attributeChangedCallback(attrName, oldValue, newValue) {
        const propName = this.attrToProp[attrName];

        const propertyInfo = this.constructor.props[propName];

        let propertyValue = newValue;

        switch (propertyInfo.type) {
            case Boolean:
                propertyValue = propertyValue === '';
                break;
            case Number:
                propertyValue = Number(propertyValue);
                break;
            case Array:
            case Object:
                try {
                    propertyValue = JSON.parse(propertyValue);
                } catch (err) {
                    // ignore
                }
                break;
            case String:
                break;
        }

        if (this[propName] !== propertyValue) {
            this[propName] = propertyValue;
        }
    }
}

/* harmony default export */ const base = (BaseElement);

;// ./js/datepicker/src/date-picker.js
/* eslint-disable no-unused-expressions */


class DatePicker extends base {
    static get props() {
        return {
            date: {
                type: String
            },
            time: {
                type: String
            },
            value: {
                type: Object
            },
            showTime: {
                type: Boolean
            },
            confirmOnDate: {
                type: Boolean
            },
            locale: {
                type: String
            },
            dateStyle: {
                type: Object
            },
            startYear: {
                type: Number
            },
            endYear: {
                type: Number
            },
            startDay: {
                type: Number
            },
            defaultDate: {
                type: String
            },
            defaultTime: {
                type: String
            },
            hasNative: {
                type: Boolean
            },
            useNative: {
                type: Boolean
            },
            alignTop: {
                type: Boolean
            },
            alignRight: {
                type: Boolean
            }
        };
    }

    constructor() {
        super();

        const now = new Date();

        this.showTime = false;
        this.confirmOnDate = false;
        this.alignTop = false;
        this.alignRight = false;
        this.dateStyle = {};
        this.startYear = now.getFullYear() - 100;
        this.endYear = now.getFullYear() + 5;
        this.startDay = 1;

        try {
            const input = document.createElement('input');
            input.type = 'date';
            this.hasNative = input.type === 'date';
        } catch (error) {
            this.hasNative = false;
        }

        this.onLabelClick = this.onLabelClick.bind(this);
        this.onClickOutside = this.onClickOutside.bind(this);
    }

    connectedCallback() {
        super.connectedCallback();

        document.addEventListener('click', this.onClickOutside);
    }

    disconnectedCallback() {
        super.disconnectedCallback();

        if (this._dateInput) {
            [...(this._dateInput.labels || [])].forEach((labelEl) => {
                labelEl.removeEventListener('click', this.onLabelClick);
            });
        }
        document.removeEventListener('click', this.onClickOutside);
    }

    firstRender(_) {
        const template = document.createElement('template');
        template.innerHTML = `
      <style>
        :host {
          position: relative;

          --rgb: var(--aeon-rgb, 0, 0, 0);
          --bgRgb: var(--aeon-bgRgb, 255, 255, 255);
          --color: rgb(var(--rgb));
          --hintColor: rgba(var(--rgb), 0.2);
          --bgColor: rgb(var(--bgRgb));

          color: var(--color);
        }

        ::slotted(input[type=date]),
        ::slotted(input[type=time]) {
          display: none;
        }

        :host([has-native][use-native]) ::slotted(input[type=date]),
        :host([has-native][use-native]) ::slotted(input[type=time]) {
          display: inline-flex;
        }

        :host([has-native][use-native]) slot[name=output] {
          display: none;
        }

        aeon-calendar {
            position: absolute;
            top: 100%;
            left: 0;
            box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
            border: 1px solid rgba(0, 0, 0, 0.15);
            border-radius: 4px;
            background-clip: padding-box;
            padding: 12px;
        }

        :host([align-top]) aeon-calendar {
          top: auto;
          bottom: 100%;
        }

        :host([align-right]) aeon-calendar {
          left: auto;
          right: 0;
        }

        @media (max-width: 640px) {
          aeon-calendar,
          :host([align-top]) aeon-calendar,
          :host([align-right]) aeon-calendar {
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
          }
        }
      </style>

      <slot></slot>
      <slot name="output"></slot>

      <aeon-calendar id="calendar"></aeon-calendar>
    `;

        _.appendChild(template.content.cloneNode(true));
    }

    firstRendered(_) {
        const slot = _.querySelector('slot');
        slot.addEventListener('slotchange', () => {
            const elements = slot
                .assignedNodes()
                .filter((el) => el.nodeType !== Node.TEXT_NODE);
            this._dateInput = elements.find((el) => el.getAttribute('type') === 'date');

            if (this._dateInput) {
                this._output.placeholder = this._dateInput.placeholder;
                (this._dateInput.labels || []).forEach((labelEl) => {
                    labelEl.addEventListener('click', this.onLabelClick);
                });
                this.date = this._dateInput.value;
            }

            this._timeInput = elements.find((el) => el.getAttribute('type') === 'time');

            if (this._timeInput) {
                this.showTime = true;
                this.time = this._timeInput.value;
            }
        });

        this._output = document.createElement('input');
        this._output.slot = 'output';
        this._output.readOnly = true;
        this._output.addEventListener('click', () => {
            this.openCalendar();
        });
        this.appendChild(this._output);

        this.addEventListener('keyup', (event) => {
            event.stopPropagation();
            switch (event.key) {
                case 'Enter':
                    if (!this.$.calendar.open) {
                        this.openCalendar();
                    }
                    break;
            }
        });

        this.$.calendar.addEventListener('change', (event) => {
            this.date = event.target.value.date;
            this.time = event.target.value.time;
            this.closeCalendar();
        });

        this.$.calendar.addEventListener('clear', () => {
            this.date = '';
        });

        this.$.calendar.addEventListener('close', () => {
            if (!this._dontFocus) {
                this._output.focus();
            }

            this._dontFocus = false;
        });
    }

    render(_, triggers) {
        if ('date' in triggers || 'time' in triggers) {
            this.value = {
                date: this.date,
                time: this.time
            };

            this.updateFromString(this.date, this.time);

            this.dispatchEvent(
                new Event('change', {
                    bubbles: true
                })
            );
        }

        if (
            'locale' in triggers ||
      'startYear' in triggers ||
      'endYear' in triggers ||
      'startDay' in triggers ||
      'showTime' in triggers ||
      'confirmOnDate' in triggers
        ) {
            this.updateFromString(this.date, this.time);
        }
    }

    update(date = null) {
        const validDate = date && !isNaN(date);
        let showDate = date;

        if (!validDate) {
            date = this.defaultDate;
            const time = this.defaultTime;
            showDate = this.parseDate(date, time);
        }

        const cal = this.$.calendar;
        cal.year = showDate.getFullYear();
        cal.month = showDate.getMonth();
        cal.day = showDate.getDate();
        cal.hours = showDate.getHours();
        cal.minutes = showDate.getMinutes();
        cal.locale = this.locale;
        cal.startYear = this.startYear;
        cal.endYear = this.endYear;
        cal.startDay = this.startDay;
        cal.showTime = this.showTime;
        cal.confirmOnDate = this.confirmOnDate;

        if (validDate) {
            const dateString = new Intl.DateTimeFormat(this.locale || undefined, {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                ...(this.showTime
                    ? {
                        hour: 'numeric',
                        minute: 'numeric'
                    }
                    : {}),
                ...this.dateStyle
            }).format(date);

            this._output.value = dateString;
            if (this._dateInput) {
                this._dateInput.value = this.date;
            }
            if (this._timeInput) {
                this._timeInput.value = this.time;
            }
        } else {
            this._output.value = '';
            if (this._dateInput) {
                this._dateInput.value = '';
            }
            if (this._timeInput) {
                this._timeInput.value = '';
            }
        }
    }

    openCalendar() {
        const rect = this.getBoundingClientRect();
        const fromTop = rect.top;
        const fromBottom = window.innerHeight - rect.bottom;

        this.alignTop = fromBottom < fromTop;

        this.$.calendar.open = true;
    }

    closeCalendar(dontFocus = false) {
        this.$.calendar.open = false;

        this._dontFocus = dontFocus;
    }

    parseDate(date, time) {
        try {
            const dateParts = date.split('-');
            const timeParts = (time || this.defaultTime || '00:00').split(':');

            return new Date(
                dateParts[0],
                parseInt(dateParts[1], 10) - 1,
                dateParts[2],
                timeParts[0],
                timeParts[1]
            );
        } catch (error) {
            return new Date();
        }
    }

    updateFromString(date, time) {
        this.update(this.parseDate(date, time));
    }

    onLabelClick(event) {
        if (!this.useNative || !this.hasNative) {
            event.preventDefault();
            this._output.focus();
        }
    }

    onClickOutside(event) {
        if (this.$.calendar.open) {
            const outsideComponent = !event
                .composedPath()
                .some((element) => element === this);

            if (outsideComponent) {
                this.closeCalendar(true);
            }
        }
    }
}

/* harmony default export */ const date_picker = (DatePicker);

;// ./js/datepicker/src/select.js


class Select extends base {
    static get props() {
        return {
            value: {
                type: Number
            },
            items: {
                type: Array
            }
        };
    }

    constructor() {
        super();

        this.items = [];
    }

    firstRender(_) {
        const template = document.createElement('template');
        template.innerHTML = `
      <style>
        select {
          -webkit-appearance: none;
          -moz-appearance: none;
          padding: 0.5rem;
          padding-right: 1.5rem;
          font-family: inherit;
          font-size: inherit;
          border-radius: 0;
          border: 1px solid var(--hintColor);
          background-color: transparent;
          color: var(--color);
          width: 100%;
        }

        select::-ms-expand {
          display: none;
        }

        .select {
          position: relative;
        }

        .select .indicator {
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0.2rem;
          pointer-events: none;
          display: flex;
          align-items: center;
        }
      </style>

      <div class="select">
        <select id="select">
        </select>
        <span class="indicator">
          <svg width="24" height="24">
            <g><path fill="currentColor" d="M7 10l5 5 5-5z"></path></g>
          </svg>
        </span>
      </div>
    `;

        _.appendChild(template.content.cloneNode(true));
    }

    // simulate focus event which doesn't exist as `this` doesn't have (not do
    // we want it to have) a tabIndex
    focus() {
        this.$.select.focus();
    }

    firstRendered() {
        this.$.select.addEventListener('change', (event) => {
            this.value = event.target.value;
        });
    }

    render(_, triggers) {
        if ('value' in triggers) {
            this.dispatchEvent(
                new Event('change', {
                    bubbles: true
                })
            );
        }

        this.$.select.innerHTML = this.items
            .map((item) => `<option value="${item.value}">${item.name}</option>`)
            .join('');

        this.$.select.value = this.value;
    }
}

/* harmony default export */ const src_select = (Select);

;// ./js/datepicker/src/calendar.js
/* eslint-disable no-unused-expressions */


class Calendar extends base {
    static get props() {
        return {
            date: {
                type: String
            },
            time: {
                type: String
            },
            value: {
                type: Object
            },
            showTime: {
                type: Boolean
            },
            confirmOnDate: {
                type: Boolean
            },
            locale: {
                type: String
            },
            startYear: {
                type: Number
            },
            endYear: {
                type: Number
            },
            startDay: {
                type: Number
            },
            year: {
                type: Number
            },
            month: {
                type: Number
            },
            day: {
                type: Number
            },
            hours: {
                type: Number
            },
            minutes: {
                type: Number
            },
            open: {
                type: Boolean
            }
        };
    }

    constructor() {
        super();

        this.showTime = false;
        this.confirmOnDate = false;
        this.open = false;
    }

    connectedCallback() {
        super.connectedCallback();

        this.addEventListener('keydown', this.onKeyDown.bind(this));
    }

    firstRender(_) {
        const template = document.createElement('template');
        template.innerHTML = `
      <style>
        :host {
          display: none;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          position: relative;
          z-index: 3;
          padding: 0.2rem;
          background-color: var(--bgColor);
        }

        :host([open]) {
          display: flex;
        }

        .week {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .day, .date, button {
          color: var(--color);
          background-color: transparent;
          border: 0;
          box-sizing: border-box;
          width: 33px;
          height: 33px;
          padding: 0;
          font-family: inherit;
          font-size: calc(2.8em / 3);

          text-transform: uppercase;

          flex-grow: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }

        .date {
          border: 1px solid var(--hintColor);
          border-width: 0 0 1px 1px;
        }

        .date:last-child {
          border-right-width: 1px;
        }

        .date.last + .spacer {
          border-left-width: 1px;
        }

        .week:nth-child(2) .date:not(.spacer) {
          border-top-width: 1px;
        }

        .week:last-child .spacer {
          border-right-width: 0;
          border-bottom-width: 0;
        }

        .date.today {
            font-weight: bold;
            background-image: linear-gradient(to bottom, #0088cc, #0044cc);
            background-repeat: repeat-x;
            border-color: #0044cc #0044cc #002a80;
            color: #fff;
            font-size: 1.3rem;
        }

        .date.spacer {
          border-left-width: 0;
          pointer-events: none;
        }

        #buttons {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin-top: 0.5em;
          padding-top: 0.5em;
          border-top: 1px solid var(--hintColor);
        }

        #year-month, #hours-minutes {
          display: flex;
          width: 100%;
        }

        #year-month aeon-select {
          width: 50%;
        }

        #year-month aeon-select + aeon-select {
          margin-left: 0.5em;
        }

        #hours-minutes {
          padding-top: 0.5em;
          margin-top: 0.5em;
          border-top: 1px solid var(--hintColor);
          display: none;
          justify-content: center;
          align-items: center;
        }

        #hours-minutes aeon-select {
          width: 3.5em;
        }

        #hours-minutes aeon-select#hours {
          margin-right: 0.2em;
        }

        #hours-minutes aeon-select#minutes {
          margin-left: 0.2em;
        }

        :host([show-time]) #hours-minutes {
          display: flex;
        }
      </style>

      <div id="container">
        <div id="year-month">
          <aeon-select id="month"></aeon-select>
          <aeon-select id="year"></aeon-select>
        </div>
        <div id="calendar"></div>
        <div id="hours-minutes">
          <aeon-select id="hours"></aeon-select>:<aeon-select id="minutes"></aeon-select>
        </div>
        <div id="buttons">
          <button id="confirm" title="Confirm">
            <svg width="24" height="24">
              <g><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path></g>
            </svg>
          </button>
          <button id="clear" title='Clear'>
            Clear
          </button>
          <button id="cancel" title="Cancel">
            <svg width="24" height="24">
              <g><path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></g>
            </svg>
          </button>
        </div>
      </div>
    `;

        _.appendChild(template.content.cloneNode(true));
    }

    firstRendered() {
        this.addEventListener('keyup', (event) => {
            event.stopPropagation();
            switch (event.key) {
                case 'Escape':
                    this.open = false;
                    break;
            }
        });

        this.$.year.addEventListener('change', (event) => {
            this.year = event.target.value;
        });

        this.$.month.addEventListener('change', (event) => {
            this.month = event.target.value;
        });

        this.$.hours.items = [];
        for (let i = 0; i < 24; i++) {
            this.$.hours.items.push({
                name: `${i}`.padStart(2, '0'),
                value: i
            });
        }

        this.$.hours.addEventListener('change', (event) => {
            this.hours = event.target.value;
        });

        this.$.minutes.items = [];
        for (let i = 0; i < 60; i++) {
            this.$.minutes.items.push({
                name: `${i}`.padStart(2, '0'),
                value: i
            });
        }

        this.$.minutes.addEventListener('change', (event) => {
            this.minutes = event.target.value;
        });

        this.$.calendar.addEventListener('click', this.onDateClick.bind(this));

        this.$.cancel.addEventListener('click', () => {
            this.open = false;
        });

        this.$.confirm.addEventListener('click', () => {
            this.confirm();
        });

        this.$.clear.addEventListener('click', () => {
            this.dispatchEvent(
                new Event('clear', {
                    bubbles: true
                })
            );
            this.open = false;
        });
    }

    render(_, triggers) {
        if ('open' in triggers && this.open === false && triggers.open === true) {
            this.dispatchEvent(
                new Event('close', {
                    bubbles: true
                })
            );
        }

        if ('year' in triggers || 'month' in triggers || 'day' in triggers) {
            this.date = this.formatAsDate(this.year, this.month, this.day);
        }

        if ('hours' in triggers || 'minutes' in triggers) {
            this.time = this.formatAsTime(this.hours, this.minutes);
        }

        const now = new Date();
        now.setMonth(0); // not now.setMonth(0, 1) as this can cause issues - see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setMonth#Description
        now.setDate(1);

        this.$.year.value = this.year;
        this.$.year.items = [];
        for (let i = this.startYear; i <= this.endYear; i++) {
            this.$.year.items.push({ value: i, name: i });
        }

        this.$.month.value = this.month;
        this.$.month.items = [];
        for (let i = 0; i < 12; i++) {
            const monthNum = now.getMonth();
            this.$.month.items.push({
                value: monthNum,
                name: now.toLocaleString(this.locale || undefined, { month: 'short' })
            });
            now.setMonth(i + 1);
        }
        this.$.month.items.sort((a, b) => a.num - b.num);

        now.setMonth(0);
        now.setDate(1);
        const days = [];
        for (let i = 0; i < 7; i++) {
            const dayNum = now.getDay();
            days.push({
                num: dayNum,
                name: now.toLocaleString(this.locale || undefined, { weekday: 'short' })
            });
            now.setDate(i + 2);
        }
        const startDayOffset = 7 - this.startDay;
        days.sort(
            (a, b) => ((a.num + startDayOffset) % 7) - ((b.num + startDayOffset) % 7)
        );

        this.$.hours.value = this.hours;
        this.$.minutes.value = this.minutes;

        ////

        let workingDate = new Date(this.year, this.month, 1, 12);
        const monthStartDay = workingDate.getDay();

        workingDate.setMonth(workingDate.getMonth() + 1);
        workingDate.setDate(0);
        const daysInMonth = workingDate.getDate();

        workingDate = new Date(this.year, this.month, 1, 12);

        let started = false;
        let finished = false;
        let count = 0;

        this.$.calendar.innerHTML = `
      <div class="week">
        ${days.map((day) => `<div class="day">${day.name}</div>`).join('')}
      </div>

      ${[0, 1, 2, 3, 4, 5]
        .map(() => {
            if (count >= daysInMonth) return null;

            return `
          <div class="week">
            ${days
        .map((day) => {
            const dayNum = day.num % 7;
            if (dayNum === monthStartDay) {
                started = true;
            }

            let date = '';
            if (started) {
                count += 1;
                if (count <= daysInMonth) {
                    date = count;
                    workingDate.setDate(date);
                } else {
                    finished = true;
                }
            }

            const isToday = count === this.day;

            return `
                  <button class="date ${isToday ? 'today' : ''} ${
    !started || finished ? 'spacer' : ''
} ${count === daysInMonth ? 'last' : ''}" data-day="${count}" ${
    !started || finished ? 'tabindex="-1" disabled' : ''
}>${date}</button>
              `;
        })
        .join('')}
          </div>
         `;
        })
        .join('')}
    `;

        const focusableEls = _.querySelectorAll(
            'button:not([disabled]), aeon-select'
        );
        this._firstFocusableEl = focusableEls[0];
        this._lastFocusableEl = focusableEls[focusableEls.length - 1];
    }

    rendered(_, triggers) {
        if (this.open === true) {
            if (
                ('open' in triggers && triggers.open === false) ||
        'day' in triggers
            ) {
                _.querySelector('.today').focus();
            }
        }
    }

    confirm() {
        this.date = this.formatAsDate(this.year, this.month, this.day);
        this.time = this.formatAsTime(this.hours, this.minutes);

        this.value = {
            date: this.date,
            time: this.time
        };

        this.dispatchEvent(
            new Event('change', {
                bubbles: true
            })
        );
    }

    handleTabKey(event) {
        const activeElement = this.shadowRoot.activeElement;

        if (event.shiftKey && activeElement === this._firstFocusableEl) {
            this._lastFocusableEl.focus();
            event.preventDefault();
        } else if (!event.shiftKey && activeElement === this._lastFocusableEl) {
            this._firstFocusableEl.focus();
            event.preventDefault();
        }
    }

    handleArrowKeys(event) {
        let diff = 0;
        switch (event.key) {
            case 'ArrowUp':
                diff = -7;
                break;
            case 'ArrowRight':
                diff = 1;
                break;
            case 'ArrowLeft':
                diff = -1;
                break;
            case 'ArrowDown':
                diff = 7;
                break;
        }

        const date = new Date(this.year, this.month, this.day);
        date.setDate(this.day + diff);
        this.year = date.getFullYear();
        this.month = date.getMonth();
        this.day = date.getDate();
    }

    onKeyDown(event) {
        if (event.key === 'Enter') {
            this.confirm();
        } else if (event.key === 'Tab') {
            this.handleTabKey(event);
        } else if (
            ['ArrowUp', 'ArrowRight', 'ArrowDown', 'ArrowLeft'].includes(event.key)
        ) {
            this.handleArrowKeys(event);
        }
    }

    onDateClick(event) {
        if (event.target.classList.contains('date')) {
            const button = event.target;
            this.day = parseInt(button.dataset.day, 10);

            if (this.confirmOnDate && !this.showTime) {
                this.confirm();
            }
        }
    }

    formatAsDate(year, month, day) {
        return `${year}-${`${month + 1}`.padStart(2, '0')}-${`${day}`.padStart(
            2,
            '0'
        )}`;
    }

    formatAsTime(hours, minutes) {
        return `${`${hours}`.padStart(2, '0')}:${`${minutes}`.padStart(2, '0')}`;
    }
}

/* harmony default export */ const calendar = (Calendar);

;// ./js/datepicker/src/aeon.js




if (!customElements.get('aeon-select')) {
    customElements.define('aeon-select', src_select);
}
if (!customElements.get('aeon-calendar')) {
    customElements.define('aeon-calendar', calendar);
}
if (!customElements.get('aeon-datepicker')) {
    customElements.define('aeon-datepicker', date_picker);
}

/******/ })()
;
//# sourceMappingURL=aeon-es5.js.map;
/**
 * LA Question Form
 * Requires jQuery and s.ui.filedrop
 * @deprecated js/public/QuestionForm.js is preferred but we have to keep both in sync until we switch over.
 */

(function(root) {
    root.springSpace = root.springSpace || {};
    root.springSpace.la = root.springSpace.la || {};
    const AUTOREPLY_TYPE_OFFHOURS = 2;

    /**
     * Question form js
     * @param {Object} config configuration data
     * @param {String} config.form_action Action attribute for the form, set it in js to help with spam??
     * @param {String} config.content_id box_content.id value
     * @param {Number} config.queue_id Form's Queue ID
     * @param {Object} config.errormsg Error message translation object
     * @param {Object} config.translations Translations for the filedrop widget.
     * @param {Boolean} config.libauth_enabled Is Libauth Turned on for this form.
     * @param {Boolean} config.libauth_authed Is the requester validated for libauth.
     * @param {Object} config.autoReplySettings Queue auto reply type, etc.
     * @param {Object[]} config.rules Field rules
     */
    const askform = function(config) {
        this.id = config.content_id;
        this.queue_id = config.queue_id;
        this.errormsg = config.errormsg;
        this.divselector = `#s-la-askform-${this.id}`;
        this.$form = jQuery(`${this.divselector} form`);
        this.translations = config.translations;
        this.form_action = config.form_action;
        this.libauth_enabled = config.libauth_enabled || false;
        this.libauth_authed = config.libauth_authed || false;
        this.autoReplySettings = new root.springSpace.la.FormAutoReply(config.autoReplySettings || {});
        this.captcha_enabled = this.autoReplySettings.isCaptchaEnabled();
        this.autoreply_enabled = this.autoReplySettings.isAutoReplyEnabled();
        this.captchaDiv = this.$form[0].querySelector('.formlibcpt');
        this.confirmEmailDiv = this.$form[0].querySelector('.confem_wrap');
        this.autoreply_type = this.autoReplySettings.getAutoReplyType();
        if (this.captcha_enabled) {
            this.captchaDiv.classList.remove('hidden');
        }
        if (Array.isArray(config.rules)) {
            this.rules = config.rules.map((r) => {
                return new root.springSpace.la.FormFieldRule(r);
            });
        } else {
            this.rules = [];
        }

        /**
         * When a required checkbox is changed we have to adjust the required attribute
         * on all of them else the browser will not validate
         * @param {Event} ev Checkbox input change.
         */
        this.handleRequiredCheckBoxes = function(ev) {
            const fieldName = ev.target.name;
            const isChecked = (ev.target.checked === true);
            // if checked remove required from related inputs.
            if (isChecked) {
                const relatedChecks = this.$form[0].querySelectorAll(`input[type=checkbox][name="${fieldName}"]`);
                if (relatedChecks.length > 0) {
                    Array.prototype.forEach.call(relatedChecks, (el) => {
                        el.removeAttribute('required');
                    }, this);
                }
                return;
            }
            // if unchecked confirm if others are checked.
            const fieldSet = ev.target.closest('fieldset');
            if (fieldSet === null) {
                return;
            }
            // Get checked boxes (if any)
            const checkedBoxes = fieldSet.querySelectorAll('input[type=checkbox]:checked');
            if (checkedBoxes.length > 0) {
                // Others are checked so all good.
                return;
            }
            Array.prototype.forEach.call(fieldSet.querySelectorAll('input[type=checkbox]'), (el) => {
                el.setAttribute('required', '');
            }, this);
        };
        /**
         * Add error on the form
         * @param {HTMLElement} input Element for input/select
         * @param {String} msg Error message
         */
        this.markError = function(input, msg) {
            if (!input) {
                return;
            }
            const msg_div = document.createElement('div');
            msg_div.classList.add('error-message');
            msg_div.innerHTML = msg;
            const parent = input.closest('div.form-group');
            if (parent === null) {
                return;
            }
            input.setAttribute('aria-invalid', 'true');
            parent.classList.add('has-error');
            const label = parent.querySelector('label');
            if (label) {
                label.appendChild(msg_div);
            }
        };
        this.loadCaptcha = function() {
            const url = new URL(this.form_action);
            jQuery.ajax({
                context: this,
                type: 'GET',
                url: `https://${url.hostname}/form/libcpt`,
                data: {
                    queue_id: this.queue_id,
                    auto_type: this.autoReplySettings.type
                },
                dataType: 'json'
            }).done(({ html = '', isNowOffHours = false, isCaptchaAlwaysOn = false }) => {
                if (this.autoreply_type === AUTOREPLY_TYPE_OFFHOURS) {
                    if (!isNowOffHours) {
                        this.autoreply_enabled = false;
                        if (this.confirmEmailDiv) {
                            this.confirmEmailDiv.querySelector('input[type="checkbox"]').disabled = false;
                            this.confirmEmailDiv.classList.remove('hidden');
                        }
                    }
                    if (!html || (!isCaptchaAlwaysOn && !this.autoreply_enabled)) {
                        this.captchaDiv.classList.add('hidden');
                        return;
                    }
                }

                this.captchaDiv.innerHTML = html;
                this.captchaDiv.classList.add('active');
                this.captchaDiv.classList.remove('hidden');
                const captchaReset = this.captchaDiv.querySelector('.btn-cptreload');
                if (captchaReset) {
                    captchaReset.addEventListener('click', this.loadCaptcha.bind(this));
                }
            }).fail(() => {
                this.captchaDiv.classList.add('hidden');
            });
        };
        /**
         * Validate a single field for if it is set.
         * @param {Object} el DOMElement fields we are validating.
         */
        this.validateField = function(el) {
            if (!el || el.disabled) {
                return;
            }
            if (el.tagName === 'SELECT') {
                const option = el.options[el.selectedIndex] || null;
                if (!option) {
                    return;
                }
                const value = option.value;
                if (value === '' || value === '0') {
                    this.markError(el, this.errormsg.reqfields);
                }
                return;
            }
            if (el.tagName === 'TEXTAREA') {
                if (el.value.trim() === '') {
                    this.markError(el, this.errormsg.reqfields);
                }
                return;
            }
            if (el.tagName !== 'INPUT') {
                return;
            }
            // Ok just INPUT tags now.
            const inputType = el.type;
            // Radio and checkbox are handled as groups
            if (inputType === 'radio' || inputType === 'checkbox') {
                return;
            }
            if (inputType === 'email') {
                if (!el.checkValidity()) {
                    this.markError(el, this.errormsg.emailaddress);
                }
                if (el.name === 'confirm_pemail') {
                    const emailElem = this.$form[0].querySelector('input[name="pemail"]');
                    if (el.value.trim() !== emailElem.value.trim()) {
                        this.markError(el, this.errormsg.emailnotmatch);
                    }
                }
                return;
            }
            // The rest... text mostly.
            if (el.value.trim() === '') {
                this.markError(el, this.errormsg.reqfields);
            }
        };
        /**
         * Validate checkbox and radio groups.
         * @param {HTMLElement} fieldset A fieldset element.
         */
        this.validateFieldSet = function(fieldset) {
            const inputs = fieldset.querySelectorAll('input');
            let isValid = true;
            inputs.forEach((input) => {
                if (!input.checkValidity()) {
                    isValid = false;
                    input.setAttribute('aria-invalid', 'true');
                }
            });
            if (isValid) {
                return;
            }

            const msg_div = document.createElement('div');
            msg_div.classList.add('error-message');
            msg_div.innerHTML = this.errormsg.reqfields;

            fieldset.classList.add('has-error');
            const legend = fieldset.querySelector('legend');
            if (legend) {
                legend.appendChild(msg_div);
                return;
            }
        };
        /**
         * Validate the form before submitting.
         * @return {Boolean}
         */
        this.validate = function() {
            if (this.libauth_enabled && !this.libauth_authed) {
                return false;
            }
            this.$form.attr('action', this.form_action);
            this.$form.find('label .error-message, legend .error-message').remove();
            this.$form.find('.form-group').removeClass('has-error');
            this.$form.find('.form-control, input[type=radio], input[type=checkbox]').attr('aria-invalid', false);

            //check "required fields" for validity
            Array.from(this.$form[0].querySelectorAll('[required]')).forEach((el) => {
                this.validateField(el);
            });
            //check required radio/checkbox groups
            Array.from(this.$form[0].querySelectorAll('fieldset[data-required]')).forEach((el) => {
                this.validateFieldSet(el);
            });

            if (this.$form.find('.has-error').length > 0) {
                this.$form.find('*[aria-invalid=true]:first').trigger('focus');
                return false;
            }
            let qlog_id = 0;
            if (root.springSpace.queryAnalyzer) {
                qlog_id = root.springSpace.queryAnalyzer.qlog_id || 0;
            } else if (root.springSpace.la.Page && root.springSpace.la.Page.qlog_id) {
                qlog_id = root.springSpace.la.Page.qlog_id;
            }
            if (qlog_id > 0) {
                this.$form.find('input[name=qlog]').val(qlog_id);
            }

            root.suiNotify.working();
            return true;
        };

        /**
         * Create a dismissable alert for insertion into the DOM.
         * Uses bootstrap alert classes.
         * @param {String} message HTML Error message (html)
         * @param {String} colorClass Bootstrap based (danger, success, info, etc.)
         * @returns {HTMLElement}
         */
        this.createDismissableAlert = function(message, colorClass) {
            const alert = document.createElement('div');
            alert.classList.add('alert', `alert-${colorClass}`, 'alert-dismissable');
            alert.setAttribute('role', 'alert');
            alert.setAttribute('aria-atomic', 'true');
            const button = document.createElement('button');
            button.type = 'button';
            button.classList.add('close');
            button.setAttribute('aria-label', 'close');
            button.innerHTML = '<span aria-hidden="true">&times;</span>';
            alert.appendChild(button);
            alert.insertAdjacentHTML('beforeend', message);
            button.addEventListener('click', (ev) => {
                ev.preventDefault();
                alert.remove();
            });
            return alert;
        };

        /**
         * Trigger change event on rule fields to reset visibility
         */
        this.resetRules = function() {
            this.rules.forEach((rule) => {
                this.$form[0].querySelectorAll(`*[name="${rule.field1}"], *[name="${rule.field1}[]"]`).forEach((el) => {
                    el.dispatchEvent(new Event('change'));
                });
            });
        };

        /**
         * Instantiate filedrop object to handle validation, submit, error, etc.
         */
        this.questionform = new root.springSpace.sui.filedrop({
            selector: `${this.divselector} form`,
            max_files: 5,
            max_upload_size: 20971520,
            max_file_size: 20971520,
            batch_files: false,
            autoupload: false,
            supportie9: false,
            translations: this.translations,
            callback: (data) => {
                // Insert an alert above the submit button.
                root.suiNotify.hide();
                const alert = this.createDismissableAlert(data.message, 'success');
                const buttonDiv = this.$form[0].querySelector('#s-la-askform-buttons');
                buttonDiv.insertAdjacentElement('beforebegin', alert);
                this.questionform.reset();
                this.resetRules();
                if (this.captcha_enabled) {
                    this.loadCaptcha();
                }
                if (this.autoreply_enabled && this.confirmEmailDiv) {
                    // remove confirmation field when auto reply is enabled
                    this.confirmEmailDiv.querySelector('input[type="checkbox"]').disabled = true;
                    this.confirmEmailDiv.classList.add('hidden');
                }
            },
            error_callback: (jqXhr) => {
                let error = 'Error';
                const isCaptcha = jqXhr.status === 449;
                if (jqXhr.responseText) {
                    try {
                        const response = JSON.parse(jqXhr.responseText);
                        if (response.error) {
                            error = response.error;
                        }
                    } catch (e) {
                        error = 'Invalid response received';
                    }
                }
                root.suiNotify.hide();
                const alert = this.createDismissableAlert(error, 'danger');
                let errorContain = null;
                let location = 'beforebegin';
                if (isCaptcha) {
                    errorContain = this.$form[0].querySelector('.formlibcpt');
                    if (errorContain) {
                        location = 'afterbegin';
                    }
                }
                if (!errorContain) {
                    errorContain = this.$form[0].querySelector('#s-la-askform-buttons');
                }
                errorContain.insertAdjacentElement(location, alert);
            },
            validate: this.validate.bind(this)
        });

        this.showField = function(field) {
            field.classList.remove('hidden');
            field.querySelectorAll('select, input, textarea').forEach((input) => {
                input.disabled = false;
            });
        };

        this.hideField = function(field) {
            field.classList.add('hidden');
            field.querySelectorAll('select, input, textarea').forEach((input) => {
                if (['checkbox', 'radio'].includes(input.type)) {
                    input.checked = false;
                } else {
                    input.value = '';
                }
                // trigger change event to hide/show fields...
                input.dispatchEvent(new Event('change'));
                input.disabled = true;
            });
        };

        this.getMultiCheckValue = function(fieldname) {
            // get all checkbox values...
            const data = new FormData(this.$form[0]);
            return Array.from(data.getAll(fieldname)).map((el) => {
                return Number(el);
            });
        };

        this.getRadioValue = function(fieldname) {
            const data = new FormData(this.$form[0]);
            return Number(data.get(fieldname));
        };

        this.setUpRules = function() {
            this.rules.forEach((rule) => {
                this.$form[0].querySelectorAll(`*[name="${rule.field1}"], *[name="${rule.field1}[]"]`).forEach((el) => {
                    const field2 = this.$form[0].querySelector(`.${rule.field2}_wrap`);
                    if (!field2) {
                        return;
                    }
                    // then for later...
                    el.addEventListener('change', (ev) => {
                        let fieldValue = Number(ev.target.value);
                        if (ev.target.type === 'checkbox') {
                            // get all checkbox values...
                            fieldValue = this.getMultiCheckValue(ev.target.name);
                        } else if (ev.target.type === 'radio') {
                            fieldValue = this.getRadioValue(ev.target.name);
                        }
                        const action = rule.getFieldAction(fieldValue);
                        if (action === 0) { // show
                            this.showField(field2);
                        } else if (action === 1) { // hide
                            this.hideField(field2);
                        }
                    });
                });
            });
        };

        /**
         * Setup some events on the form.
         * This gets run first.
         */
        this.setUp = function() {
            // LibAuth on but current user not authed
            if (this.libauth_enabled && !this.libauth_authed) {
                // Disable inputs to stop focus
                this.questionform.$form[0].querySelectorAll('input,select,button,textarea').forEach((el) => {
                    el.disabled = true;
                });
                // make tabbable elements and links untabbable.
                this.questionform.$form[0].querySelectorAll('[tabindex="0"],a').forEach((el) => {
                    el.setAttribute('tabindex', '-1');
                });
                // hide form for screenreaders
                this.questionform.$form[0].setAttribute('aria-hidden', 'true');
                // If in iframe set auth link to open in new window.
                if (window !== window.top) {
                    const button = document.querySelector(`${this.divselector} .btn-libauth`);
                    if (button) {
                        button.setAttribute('target', '_blank');
                    }
                }
                return;
            }

            this.setUpRules();

            const reqChecks = this.questionform.$form[0].querySelectorAll('input[type=checkbox][required]');
            if (reqChecks.length > 0) {
                // Add change event for all required checkboxes.
                Array.prototype.forEach.call(reqChecks, function(el) {
                    el.addEventListener('change', this.handleRequiredCheckBoxes.bind(this));
                }, this);
            }
            if (this.captcha_enabled) {
                this.loadCaptcha();
            }
            if (this.autoreply_enabled && this.confirmEmailDiv) {
                // remove confirmation field when auto reply is enabled
                this.confirmEmailDiv.querySelector('input[type="checkbox"]').disabled = true;
                this.confirmEmailDiv.classList.add('hidden');
            }
        };

        this.setUp();
    };

    root.springSpace.la.askform = askform;
})(window);
;
/**
 * Query Logging on Public Pages.
 */
class QueryLog {

    constructor({
        qlog_id = 0,
        group_id = 0,
        query = ''
    }) {
        this.qlog_id = qlog_id;
        this.group_id = group_id;
        this.first_search_saved = this.qlog_id > 0 ? true : false;
        this.query = query;
    }
    /**
     * Record a new entry or update the search.
     * @param {String} query Search text
     * @param {String} refer Optional referrer
     */
    record({
        query = '',
        refer = ''
    }) {
        if (this.first_search_saved) {
            this.first_search_saved = false;
            if (this.query === query) {
                return;
            }
        }
        if (!query || this.query === query) {
            return;
        }
        if (!refer) {
            refer = location.href;
        }

        jQuery.ajax({
            method: 'POST',
            url: '/search/log',
            data: {
                qlog: this.qlog_id,
                refer: refer,
                group_id: this.group_id,
                query: query
            },
            dataType: 'json'
        })
            .done((d) => {
                if (d.qlog_id) {
                    this.qlog_id = d.qlog_id;
                }
            });
    }
    /**
     * Record that user is going to a specific FAQ.
     * @param {Int} data.faqid target FAQ id
     */
    gotoFAQ({
        faqid = 0
    }) {
        if (faqid <= 0) {
            return;
        }
        jQuery.ajax({
            method: 'POST',
            url: '/search/log/clicked',
            data: {
                faqid: faqid,
                qlog: this.qlog_id
            }
        });
        // we don't care about any return.
    }
}
;
/*
    FAQ search form for use in various places
    Added to: public js
    Used in: chat offline js
    Requires: sui-autocomplete
*/

(function(root) {
    var initAutocomplete = root.springSpace.sui.initAutocomplete;

    var faqSearchForm = {
        /**
         * * @prop {Number} id Id of search content item.
         */
        id: 0,
        /**
         * @prop {Number} iid Site instid
         */
        iid: 0,
        /**
         * @prop {String} apiDomain Target for autocomplete queries.
         */
        apiDomain: '',
        /**
         * @prop {Array} groupId Group limiters.
         */
        groupId: 0,
        /**
         * @prop {HTMLElement} form Search form element.
         */
        form: null,
        /**
         * @prop {Number} limit Limit of results to return.
         */
        limit: 10,
        /**
         * @prop {Object} autocomplete SUI Autocomplete object.
         */
        autocomplete: null,
        /**
         * Format the api's returned data into what we need for autocomplete.
         * @param {Object} data Data from the returned API request.
         * @return {Object}
         */
        autcompleteDataFormatCb: function(data) {
            var output = [];
            var results = data.results;
            results.forEach(function(result) {
                result.label = result.question;
                output.push(result);
            });
            return output;
        },
        /**
         * When an autocomplete options is selected
         * @param {HTMLElement} option LI element that was selected.
         */
        autocompleteSelectCb: function(option) {
            // save original input search text before autocomplete selection
            let originalQInput = this.form.querySelector('input[name=originalq]');
            if (originalQInput === null) {
                originalQInput = document.createElement('input');
                originalQInput.setAttribute('type', 'hidden');
                originalQInput.setAttribute('name', 'originalq');
                this.form.insertBefore(originalQInput, this.form.firstChild);
            }
            const searchInput = this.form.querySelector('#s-la-content-search-query-' + this.id);
            originalQInput.value = searchInput.dataset.oldvalue || '';

            var faqInput = this.form.querySelector('input[name=faqid]');
            if (faqInput === null) {
                faqInput = document.createElement('input');
                faqInput.setAttribute('type', 'hidden');
                faqInput.setAttribute('name', 'faqid');
                this.form.insertBefore(faqInput, this.form.firstChild);
            }
            faqInput.value = option.getAttribute('data-faqid');
            this.form.submit();
        },
        /**
         * Instantiate the autocomplete.
         */
        enableAutocomplete: function() {
            try {
                this.autocomplete = initAutocomplete({
                    inputSelector: '#s-la-content-search-query-' + this.id,
                    queryUrl: 'https://' + this.apiDomain + '/faq/searchpublic',
                    dataProcessor: this.autcompleteDataFormatCb.bind(this),
                    selectCallback: this.autocompleteSelectCb.bind(this),
                    queryData: {
                        rows: this.limit,
                        iid: this.iid,
                        group_ids: this.groupId
                    }
                });
            } catch (e) {
                console.log(e.message);
            }
        },
        /**
         * Instantiate the search form.
         * @param {Object} config Config settings.
         * @param {Number} config.contentId Id number of search box.
         * @param {Number} confid.iid Site Instid.
         * @param {String} config.apiDomain Domain to send queries to for autocomplete.
         * @param {Array} config.groupId Group id(s) for search limiter.
         * @param {Number} config.limit Number of autocomplete result to show.
         */
        init: function(config) {
            this.id = config.contentId;
            this.iid = config.iid;
            this.apiDomain = config.apiDomain;
            this.groupId = JSON.stringify(config.groupId); //we use JSON string to pass to API easier
            this.form = document.querySelector('#s-la-content-search-' + this.id + ' form');
            this.limit = (config.limit) ? config.limit : 10;

            this.enableAutocomplete();
        }
    };

    /**
     * Initialize a new autocomplete.
     * @param {Object} config Config object passed to autocomplete.init
     * @return {autocomplete}
     */
    var initFaqSearchForm = function(config) {
        var form = Object.create(faqSearchForm);
        form.init(config);
        return form;
    };

    root.springSpace = this.springSpace || {};
    root.springSpace.la = this.springSpace.la || {};
    root.springSpace.la.initFaqSearchForm = initFaqSearchForm;
})(this);
;
typeof JSON!="object"&&(JSON={}),function(){"use strict";function f(e){return e<10?"0"+e:e}function quote(e){return escapable.lastIndex=0,escapable.test(e)?'"'+e.replace(escapable,function(e){var t=meta[e];return typeof t=="string"?t:"\\u"+("0000"+e.charCodeAt(0).toString(16)).slice(-4)})+'"':'"'+e+'"'}function str(e,t){var n,r,i,s,o=gap,u,a=t[e];a&&typeof a=="object"&&typeof a.toJSON=="function"&&(a=a.toJSON(e)),typeof rep=="function"&&(a=rep.call(t,e,a));switch(typeof a){case"string":return quote(a);case"number":return isFinite(a)?String(a):"null";case"boolean":case"null":return String(a);case"object":if(!a)return"null";gap+=indent,u=[];if(Object.prototype.toString.apply(a)==="[object Array]"){s=a.length;for(n=0;n<s;n+=1)u[n]=str(n,a)||"null";return i=u.length===0?"[]":gap?"[\n"+gap+u.join(",\n"+gap)+"\n"+o+"]":"["+u.join(",")+"]",gap=o,i}if(rep&&typeof rep=="object"){s=rep.length;for(n=0;n<s;n+=1)typeof rep[n]=="string"&&(r=rep[n],i=str(r,a),i&&u.push(quote(r)+(gap?": ":":")+i))}else for(r in a)Object.prototype.hasOwnProperty.call(a,r)&&(i=str(r,a),i&&u.push(quote(r)+(gap?": ":":")+i));return i=u.length===0?"{}":gap?"{\n"+gap+u.join(",\n"+gap)+"\n"+o+"}":"{"+u.join(",")+"}",gap=o,i}}typeof Date.prototype.toJSON!="function"&&(Date.prototype.toJSON=function(e){return isFinite(this.valueOf())?this.getUTCFullYear()+"-"+f(this.getUTCMonth()+1)+"-"+f(this.getUTCDate())+"T"+f(this.getUTCHours())+":"+f(this.getUTCMinutes())+":"+f(this.getUTCSeconds())+"Z":null},String.prototype.toJSON=Number.prototype.toJSON=Boolean.prototype.toJSON=function(e){return this.valueOf()});var cx=/[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,escapable=/[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,gap,indent,meta={"\b":"\\b","	":"\\t","\n":"\\n","\f":"\\f","\r":"\\r",'"':'\\"',"\\":"\\\\"},rep;typeof JSON.stringify!="function"&&(JSON.stringify=function(e,t,n){var r;gap="",indent="";if(typeof n=="number")for(r=0;r<n;r+=1)indent+=" ";else typeof n=="string"&&(indent=n);rep=t;if(!t||typeof t=="function"||typeof t=="object"&&typeof t.length=="number")return str("",{"":e});throw new Error("JSON.stringify")}),typeof JSON.parse!="function"&&(JSON.parse=function(text,reviver){function walk(e,t){var n,r,i=e[t];if(i&&typeof i=="object")for(n in i)Object.prototype.hasOwnProperty.call(i,n)&&(r=walk(i,n),r!==undefined?i[n]=r:delete i[n]);return reviver.call(e,t,i)}var j;text=String(text),cx.lastIndex=0,cx.test(text)&&(text=text.replace(cx,function(e){return"\\u"+("0000"+e.charCodeAt(0).toString(16)).slice(-4)}));if(/^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,"@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,"]").replace(/(?:^|:|,)(?:\s*\[)+/g,"")))return j=eval("("+text+")"),typeof reviver=="function"?walk({"":j},""):j;throw new SyntaxError("JSON.parse")})}(),function(e,t){"use strict";var n=e.History=e.History||{},r=e.jQuery;if(typeof n.Adapter!="undefined")throw new Error("History.js Adapter has already been loaded...");n.Adapter={bind:function(e,t,n){r(e).bind(t,n)},trigger:function(e,t,n){r(e).trigger(t,n)},extractEventData:function(e,n,r){var i=n&&n.originalEvent&&n.originalEvent[e]||r&&r[e]||t;return i},onDomLoad:function(e){r(e)}},typeof n.init!="undefined"&&n.init()}(window),function(e,t){"use strict";var n=e.document,r=e.setTimeout||r,i=e.clearTimeout||i,s=e.setInterval||s,o=e.History=e.History||{};if(typeof o.initHtml4!="undefined")throw new Error("History.js HTML4 Support has already been loaded...");o.initHtml4=function(){if(typeof o.initHtml4.initialized!="undefined")return!1;o.initHtml4.initialized=!0,o.enabled=!0,o.savedHashes=[],o.isLastHash=function(e){var t=o.getHashByIndex(),n;return n=e===t,n},o.isHashEqual=function(e,t){return e=encodeURIComponent(e).replace(/%25/g,"%"),t=encodeURIComponent(t).replace(/%25/g,"%"),e===t},o.saveHash=function(e){return o.isLastHash(e)?!1:(o.savedHashes.push(e),!0)},o.getHashByIndex=function(e){var t=null;return typeof e=="undefined"?t=o.savedHashes[o.savedHashes.length-1]:e<0?t=o.savedHashes[o.savedHashes.length+e]:t=o.savedHashes[e],t},o.discardedHashes={},o.discardedStates={},o.discardState=function(e,t,n){var r=o.getHashByState(e),i;return i={discardedState:e,backState:n,forwardState:t},o.discardedStates[r]=i,!0},o.discardHash=function(e,t,n){var r={discardedHash:e,backState:n,forwardState:t};return o.discardedHashes[e]=r,!0},o.discardedState=function(e){var t=o.getHashByState(e),n;return n=o.discardedStates[t]||!1,n},o.discardedHash=function(e){var t=o.discardedHashes[e]||!1;return t},o.recycleState=function(e){var t=o.getHashByState(e);return o.discardedState(e)&&delete o.discardedStates[t],!0},o.emulated.hashChange&&(o.hashChangeInit=function(){o.checkerFunction=null;var t="",r,i,u,a,f=Boolean(o.getHash());return o.isInternetExplorer()?(r="historyjs-iframe",i=n.createElement("iframe"),i.setAttribute("id",r),i.setAttribute("src","#"),i.style.display="none",n.body.appendChild(i),i.contentWindow.document.open(),i.contentWindow.document.close(),u="",a=!1,o.checkerFunction=function(){if(a)return!1;a=!0;var n=o.getHash(),r=o.getHash(i.contentWindow.document);return n!==t?(t=n,r!==n&&(u=r=n,i.contentWindow.document.open(),i.contentWindow.document.close(),i.contentWindow.document.location.hash=o.escapeHash(n)),o.Adapter.trigger(e,"hashchange")):r!==u&&(u=r,f&&r===""?o.back():o.setHash(r,!1)),a=!1,!0}):o.checkerFunction=function(){var n=o.getHash()||"";return n!==t&&(t=n,o.Adapter.trigger(e,"hashchange")),!0},o.intervalList.push(s(o.checkerFunction,o.options.hashChangeInterval)),!0},o.Adapter.onDomLoad(o.hashChangeInit)),o.emulated.pushState&&(o.onHashChange=function(t){var n=t&&t.newURL||o.getLocationHref(),r=o.getHashByUrl(n),i=null,s=null,u=null,a;return o.isLastHash(r)?(o.busy(!1),!1):(o.doubleCheckComplete(),o.saveHash(r),r&&o.isTraditionalAnchor(r)?(o.Adapter.trigger(e,"anchorchange"),o.busy(!1),!1):(i=o.extractState(o.getFullUrl(r||o.getLocationHref()),!0),o.isLastSavedState(i)?(o.busy(!1),!1):(s=o.getHashByState(i),a=o.discardedState(i),a?(o.getHashByIndex(-2)===o.getHashByState(a.forwardState)?o.back(!1):o.forward(!1),!1):(o.pushState(i.data,i.title,encodeURI(i.url),!1),!0))))},o.Adapter.bind(e,"hashchange",o.onHashChange),o.pushState=function(t,n,r,i){r=encodeURI(r).replace(/%25/g,"%");if(o.getHashByUrl(r))throw new Error("History.js does not support states with fragment-identifiers (hashes/anchors).");if(i!==!1&&o.busy())return o.pushQueue({scope:o,callback:o.pushState,args:arguments,queue:i}),!1;o.busy(!0);var s=o.createStateObject(t,n,r),u=o.getHashByState(s),a=o.getState(!1),f=o.getHashByState(a),l=o.getHash(),c=o.expectedStateId==s.id;return o.storeState(s),o.expectedStateId=s.id,o.recycleState(s),o.setTitle(s),u===f?(o.busy(!1),!1):(o.saveState(s),c||o.Adapter.trigger(e,"statechange"),!o.isHashEqual(u,l)&&!o.isHashEqual(u,o.getShortUrl(o.getLocationHref()))&&o.setHash(u,!1),o.busy(!1),!0)},o.replaceState=function(t,n,r,i){r=encodeURI(r).replace(/%25/g,"%");if(o.getHashByUrl(r))throw new Error("History.js does not support states with fragment-identifiers (hashes/anchors).");if(i!==!1&&o.busy())return o.pushQueue({scope:o,callback:o.replaceState,args:arguments,queue:i}),!1;o.busy(!0);var s=o.createStateObject(t,n,r),u=o.getHashByState(s),a=o.getState(!1),f=o.getHashByState(a),l=o.getStateByIndex(-2);return o.discardState(a,s,l),u===f?(o.storeState(s),o.expectedStateId=s.id,o.recycleState(s),o.setTitle(s),o.saveState(s),o.Adapter.trigger(e,"statechange"),o.busy(!1)):o.pushState(s.data,s.title,s.url,!1),!0}),o.emulated.pushState&&o.getHash()&&!o.emulated.hashChange&&o.Adapter.onDomLoad(function(){o.Adapter.trigger(e,"hashchange")})},typeof o.init!="undefined"&&o.init()}(window),function(e,t){"use strict";var n=e.console||t,r=e.document,i=e.navigator,s=e.sessionStorage||!1,o=e.setTimeout,u=e.clearTimeout,a=e.setInterval,f=e.clearInterval,l=e.JSON,c=e.alert,h=e.History=e.History||{},p=e.history;try{s.setItem("TEST","1"),s.removeItem("TEST")}catch(d){s=!1}l.stringify=l.stringify||l.encode,l.parse=l.parse||l.decode;if(typeof h.init!="undefined")throw new Error("History.js Core has already been loaded...");h.init=function(e){return typeof h.Adapter=="undefined"?!1:(typeof h.initCore!="undefined"&&h.initCore(),typeof h.initHtml4!="undefined"&&h.initHtml4(),!0)},h.initCore=function(d){if(typeof h.initCore.initialized!="undefined")return!1;h.initCore.initialized=!0,h.options=h.options||{},h.options.hashChangeInterval=h.options.hashChangeInterval||100,h.options.safariPollInterval=h.options.safariPollInterval||500,h.options.doubleCheckInterval=h.options.doubleCheckInterval||500,h.options.disableSuid=h.options.disableSuid||!1,h.options.storeInterval=h.options.storeInterval||1e3,h.options.busyDelay=h.options.busyDelay||250,h.options.debug=h.options.debug||!1,h.options.initialTitle=h.options.initialTitle||r.title,h.options.html4Mode=h.options.html4Mode||!1,h.options.delayInit=h.options.delayInit||!1,h.intervalList=[],h.clearAllIntervals=function(){var e,t=h.intervalList;if(typeof t!="undefined"&&t!==null){for(e=0;e<t.length;e++)f(t[e]);h.intervalList=null}},h.debug=function(){(h.options.debug||!1)&&h.log.apply(h,arguments)},h.log=function(){var e=typeof n!="undefined"&&typeof n.log!="undefined"&&typeof n.log.apply!="undefined",t=r.getElementById("log"),i,s,o,u,a;e?(u=Array.prototype.slice.call(arguments),i=u.shift(),typeof n.debug!="undefined"?n.debug.apply(n,[i,u]):n.log.apply(n,[i,u])):i="\n"+arguments[0]+"\n";for(s=1,o=arguments.length;s<o;++s){a=arguments[s];if(typeof a=="object"&&typeof l!="undefined")try{a=l.stringify(a)}catch(f){}i+="\n"+a+"\n"}return t?(t.value+=i+"\n-----\n",t.scrollTop=t.scrollHeight-t.clientHeight):e||c(i),!0},h.getInternetExplorerMajorVersion=function(){var e=h.getInternetExplorerMajorVersion.cached=typeof h.getInternetExplorerMajorVersion.cached!="undefined"?h.getInternetExplorerMajorVersion.cached:function(){var e=3,t=r.createElement("div"),n=t.getElementsByTagName("i");while((t.innerHTML="<!--[if gt IE "+ ++e+"]><i></i><![endif]-->")&&n[0]);return e>4?e:!1}();return e},h.isInternetExplorer=function(){var e=h.isInternetExplorer.cached=typeof h.isInternetExplorer.cached!="undefined"?h.isInternetExplorer.cached:Boolean(h.getInternetExplorerMajorVersion());return e},h.options.html4Mode?h.emulated={pushState:!0,hashChange:!0}:h.emulated={pushState:!Boolean(e.history&&e.history.pushState&&e.history.replaceState&&!/ Mobile\/([1-7][a-z]|(8([abcde]|f(1[0-8]))))/i.test(i.userAgent)&&!/AppleWebKit\/5([0-2]|3[0-2])/i.test(i.userAgent)),hashChange:Boolean(!("onhashchange"in e||"onhashchange"in r)||h.isInternetExplorer()&&h.getInternetExplorerMajorVersion()<8)},h.enabled=!h.emulated.pushState,h.bugs={setHash:Boolean(!h.emulated.pushState&&i.vendor==="Apple Computer, Inc."&&/AppleWebKit\/5([0-2]|3[0-3])/.test(i.userAgent)),safariPoll:Boolean(!h.emulated.pushState&&i.vendor==="Apple Computer, Inc."&&/AppleWebKit\/5([0-2]|3[0-3])/.test(i.userAgent)),ieDoubleCheck:Boolean(h.isInternetExplorer()&&h.getInternetExplorerMajorVersion()<8),hashEscape:Boolean(h.isInternetExplorer()&&h.getInternetExplorerMajorVersion()<7)},h.isEmptyObject=function(e){for(var t in e)if(e.hasOwnProperty(t))return!1;return!0},h.cloneObject=function(e){var t,n;return e?(t=l.stringify(e),n=l.parse(t)):n={},n},h.getRootUrl=function(){var e=r.location.protocol+"//"+(r.location.hostname||r.location.host);if(r.location.port||!1)e+=":"+r.location.port;return e+="/",e},h.getBaseHref=function(){var e=r.getElementsByTagName("base"),t=null,n="";return e.length===1&&(t=e[0],n=t.href.replace(/[^\/]+$/,"")),n=n.replace(/\/+$/,""),n&&(n+="/"),n},h.getBaseUrl=function(){var e=h.getBaseHref()||h.getBasePageUrl()||h.getRootUrl();return e},h.getPageUrl=function(){var e=h.getState(!1,!1),t=(e||{}).url||h.getLocationHref(),n;return n=t.replace(/\/+$/,"").replace(/[^\/]+$/,function(e,t,n){return/\./.test(e)?e:e+"/"}),n},h.getBasePageUrl=function(){var e=h.getLocationHref().replace(/[#\?].*/,"").replace(/[^\/]+$/,function(e,t,n){return/[^\/]$/.test(e)?"":e}).replace(/\/+$/,"")+"/";return e},h.getFullUrl=function(e,t){var n=e,r=e.substring(0,1);return t=typeof t=="undefined"?!0:t,/[a-z]+\:\/\//.test(e)||(r==="/"?n=h.getRootUrl()+e.replace(/^\/+/,""):r==="#"?n=h.getPageUrl().replace(/#.*/,"")+e:r==="?"?n=h.getPageUrl().replace(/[\?#].*/,"")+e:t?n=h.getBaseUrl()+e.replace(/^(\.\/)+/,""):n=h.getBasePageUrl()+e.replace(/^(\.\/)+/,"")),n.replace(/\#$/,"")},h.getShortUrl=function(e){var t=e,n=h.getBaseUrl(),r=h.getRootUrl();return h.emulated.pushState&&(t=t.replace(n,"")),t=t.replace(r,"/"),h.isTraditionalAnchor(t)&&(t="./"+t),t=t.replace(/^(\.\/)+/g,"./").replace(/\#$/,""),t},h.getLocationHref=function(e){return e=e||r,e.URL===e.location.href?e.location.href:e.location.href===decodeURIComponent(e.URL)?e.URL:e.location.hash&&decodeURIComponent(e.location.href.replace(/^[^#]+/,""))===e.location.hash?e.location.href:e.URL.indexOf("#")==-1&&e.location.href.indexOf("#")!=-1?e.location.href:e.URL||e.location.href},h.store={},h.idToState=h.idToState||{},h.stateToId=h.stateToId||{},h.urlToId=h.urlToId||{},h.storedStates=h.storedStates||[],h.savedStates=h.savedStates||[],h.normalizeStore=function(){h.store.idToState=h.store.idToState||{},h.store.urlToId=h.store.urlToId||{},h.store.stateToId=h.store.stateToId||{}},h.getState=function(e,t){typeof e=="undefined"&&(e=!0),typeof t=="undefined"&&(t=!0);var n=h.getLastSavedState();return!n&&t&&(n=h.createStateObject()),e&&(n=h.cloneObject(n),n.url=n.cleanUrl||n.url),n},h.getIdByState=function(e){var t=h.extractId(e.url),n;if(!t){n=h.getStateString(e);if(typeof h.stateToId[n]!="undefined")t=h.stateToId[n];else if(typeof h.store.stateToId[n]!="undefined")t=h.store.stateToId[n];else{for(;;){t=(new Date).getTime()+String(Math.random()).replace(/\D/g,"");if(typeof h.idToState[t]=="undefined"&&typeof h.store.idToState[t]=="undefined")break}h.stateToId[n]=t,h.idToState[t]=e}}return t},h.normalizeState=function(e){var t,n;if(!e||typeof e!="object")e={};if(typeof e.normalized!="undefined")return e;if(!e.data||typeof e.data!="object")e.data={};return t={},t.normalized=!0,t.title=e.title||"",t.url=h.getFullUrl(e.url?e.url:h.getLocationHref()),t.hash=h.getShortUrl(t.url),t.data=h.cloneObject(e.data),t.id=h.getIdByState(t),t.cleanUrl=t.url.replace(/\??\&_suid.*/,""),t.url=t.cleanUrl,n=!h.isEmptyObject(t.data),(t.title||n)&&h.options.disableSuid!==!0&&(t.hash=h.getShortUrl(t.url).replace(/\??\&_suid.*/,""),/\?/.test(t.hash)||(t.hash+="?"),t.hash+="&_suid="+t.id),t.hashedUrl=h.getFullUrl(t.hash),(h.emulated.pushState||h.bugs.safariPoll)&&h.hasUrlDuplicate(t)&&(t.url=t.hashedUrl),t},h.createStateObject=function(e,t,n){var r={data:e,title:t,url:n};return r=h.normalizeState(r),r},h.getStateById=function(e){e=String(e);var n=h.idToState[e]||h.store.idToState[e]||t;return n},h.getStateString=function(e){var t,n,r;return t=h.normalizeState(e),n={data:t.data,title:e.title,url:e.url},r=l.stringify(n),r},h.getStateId=function(e){var t,n;return t=h.normalizeState(e),n=t.id,n},h.getHashByState=function(e){var t,n;return t=h.normalizeState(e),n=t.hash,n},h.extractId=function(e){var t,n,r,i;return e.indexOf("#")!=-1?i=e.split("#")[0]:i=e,n=/(.*)\&_suid=([0-9]+)$/.exec(i),r=n?n[1]||e:e,t=n?String(n[2]||""):"",t||!1},h.isTraditionalAnchor=function(e){var t=!/[\/\?\.]/.test(e);return t},h.extractState=function(e,t){var n=null,r,i;return t=t||!1,r=h.extractId(e),r&&(n=h.getStateById(r)),n||(i=h.getFullUrl(e),r=h.getIdByUrl(i)||!1,r&&(n=h.getStateById(r)),!n&&t&&!h.isTraditionalAnchor(e)&&(n=h.createStateObject(null,null,i))),n},h.getIdByUrl=function(e){var n=h.urlToId[e]||h.store.urlToId[e]||t;return n},h.getLastSavedState=function(){return h.savedStates[h.savedStates.length-1]||t},h.getLastStoredState=function(){return h.storedStates[h.storedStates.length-1]||t},h.hasUrlDuplicate=function(e){var t=!1,n;return n=h.extractState(e.url),t=n&&n.id!==e.id,t},h.storeState=function(e){return h.urlToId[e.url]=e.id,h.storedStates.push(h.cloneObject(e)),e},h.isLastSavedState=function(e){var t=!1,n,r,i;return h.savedStates.length&&(n=e.id,r=h.getLastSavedState(),i=r.id,t=n===i),t},h.saveState=function(e){return h.isLastSavedState(e)?!1:(h.savedStates.push(h.cloneObject(e)),!0)},h.getStateByIndex=function(e){var t=null;return typeof e=="undefined"?t=h.savedStates[h.savedStates.length-1]:e<0?t=h.savedStates[h.savedStates.length+e]:t=h.savedStates[e],t},h.getCurrentIndex=function(){var e=null;return h.savedStates.length<1?e=0:e=h.savedStates.length-1,e},h.getHash=function(e){var t=h.getLocationHref(e),n;return n=h.getHashByUrl(t),n},h.unescapeHash=function(e){var t=h.normalizeHash(e);return t=decodeURIComponent(t),t},h.normalizeHash=function(e){var t=e.replace(/[^#]*#/,"").replace(/#.*/,"");return t},h.setHash=function(e,t){var n,i;return t!==!1&&h.busy()?(h.pushQueue({scope:h,callback:h.setHash,args:arguments,queue:t}),!1):(h.busy(!0),n=h.extractState(e,!0),n&&!h.emulated.pushState?h.pushState(n.data,n.title,n.url,!1):h.getHash()!==e&&(h.bugs.setHash?(i=h.getPageUrl(),h.pushState(null,null,i+"#"+e,!1)):r.location.hash=e),h)},h.escapeHash=function(t){var n=h.normalizeHash(t);return n=e.encodeURIComponent(n),h.bugs.hashEscape||(n=n.replace(/\%21/g,"!").replace(/\%26/g,"&").replace(/\%3D/g,"=").replace(/\%3F/g,"?")),n},h.getHashByUrl=function(e){var t=String(e).replace(/([^#]*)#?([^#]*)#?(.*)/,"$2");return t=h.unescapeHash(t),t},h.setTitle=function(e){var t=e.title,n;t||(n=h.getStateByIndex(0),n&&n.url===e.url&&(t=n.title||h.options.initialTitle));try{r.getElementsByTagName("title")[0].innerHTML=t.replace("<","&lt;").replace(">","&gt;").replace(" & "," &amp; ")}catch(i){}return r.title=t,h},h.queues=[],h.busy=function(e){typeof e!="undefined"?h.busy.flag=e:typeof h.busy.flag=="undefined"&&(h.busy.flag=!1);if(!h.busy.flag){u(h.busy.timeout);var t=function(){var e,n,r;if(h.busy.flag)return;for(e=h.queues.length-1;e>=0;--e){n=h.queues[e];if(n.length===0)continue;r=n.shift(),h.fireQueueItem(r),h.busy.timeout=o(t,h.options.busyDelay)}};h.busy.timeout=o(t,h.options.busyDelay)}return h.busy.flag},h.busy.flag=!1,h.fireQueueItem=function(e){return e.callback.apply(e.scope||h,e.args||[])},h.pushQueue=function(e){return h.queues[e.queue||0]=h.queues[e.queue||0]||[],h.queues[e.queue||0].push(e),h},h.queue=function(e,t){return typeof e=="function"&&(e={callback:e}),typeof t!="undefined"&&(e.queue=t),h.busy()?h.pushQueue(e):h.fireQueueItem(e),h},h.clearQueue=function(){return h.busy.flag=!1,h.queues=[],h},h.stateChanged=!1,h.doubleChecker=!1,h.doubleCheckComplete=function(){return h.stateChanged=!0,h.doubleCheckClear(),h},h.doubleCheckClear=function(){return h.doubleChecker&&(u(h.doubleChecker),h.doubleChecker=!1),h},h.doubleCheck=function(e){return h.stateChanged=!1,h.doubleCheckClear(),h.bugs.ieDoubleCheck&&(h.doubleChecker=o(function(){return h.doubleCheckClear(),h.stateChanged||e(),!0},h.options.doubleCheckInterval)),h},h.safariStatePoll=function(){var t=h.extractState(h.getLocationHref()),n;if(!h.isLastSavedState(t))return n=t,n||(n=h.createStateObject()),h.Adapter.trigger(e,"popstate"),h;return},h.back=function(e){return e!==!1&&h.busy()?(h.pushQueue({scope:h,callback:h.back,args:arguments,queue:e}),!1):(h.busy(!0),h.doubleCheck(function(){h.back(!1)}),p.go(-1),!0)},h.forward=function(e){return e!==!1&&h.busy()?(h.pushQueue({scope:h,callback:h.forward,args:arguments,queue:e}),!1):(h.busy(!0),h.doubleCheck(function(){h.forward(!1)}),p.go(1),!0)},h.go=function(e,t){var n;if(e>0)for(n=1;n<=e;++n)h.forward(t);else{if(!(e<0))throw new Error("History.go: History.go requires a positive or negative integer passed.");for(n=-1;n>=e;--n)h.back(t)}return h};if(h.emulated.pushState){var v=function(){};h.pushState=h.pushState||v,h.replaceState=h.replaceState||v}else h.onPopState=function(t,n){var r=!1,i=!1,s,o;return h.doubleCheckComplete(),s=h.getHash(),s?(o=h.extractState(s||h.getLocationHref(),!0),o?h.replaceState(o.data,o.title,o.url,!1):(h.Adapter.trigger(e,"anchorchange"),h.busy(!1)),h.expectedStateId=!1,!1):(r=h.Adapter.extractEventData("state",t,n)||!1,r?i=h.getStateById(r):h.expectedStateId?i=h.getStateById(h.expectedStateId):i=h.extractState(h.getLocationHref()),i||(i=h.createStateObject(null,null,h.getLocationHref())),h.expectedStateId=!1,h.isLastSavedState(i)?(h.busy(!1),!1):(h.storeState(i),h.saveState(i),h.setTitle(i),h.Adapter.trigger(e,"statechange"),h.busy(!1),!0))},h.Adapter.bind(e,"popstate",h.onPopState),h.pushState=function(t,n,r,i){if(h.getHashByUrl(r)&&h.emulated.pushState)throw new Error("History.js does not support states with fragement-identifiers (hashes/anchors).");if(i!==!1&&h.busy())return h.pushQueue({scope:h,callback:h.pushState,args:arguments,queue:i}),!1;h.busy(!0);var s=h.createStateObject(t,n,r);return h.isLastSavedState(s)?h.busy(!1):(h.storeState(s),h.expectedStateId=s.id,p.pushState(s.id,s.title,s.url),h.Adapter.trigger(e,"popstate")),!0},h.replaceState=function(t,n,r,i){if(h.getHashByUrl(r)&&h.emulated.pushState)throw new Error("History.js does not support states with fragement-identifiers (hashes/anchors).");if(i!==!1&&h.busy())return h.pushQueue({scope:h,callback:h.replaceState,args:arguments,queue:i}),!1;h.busy(!0);var s=h.createStateObject(t,n,r);return h.isLastSavedState(s)?h.busy(!1):(h.storeState(s),h.expectedStateId=s.id,p.replaceState(s.id,s.title,s.url),h.Adapter.trigger(e,"popstate")),!0};if(s){try{h.store=l.parse(s.getItem("History.store"))||{}}catch(m){h.store={}}h.normalizeStore()}else h.store={},h.normalizeStore();h.Adapter.bind(e,"unload",h.clearAllIntervals),h.saveState(h.storeState(h.extractState(h.getLocationHref(),!0))),s&&(h.onUnload=function(){var e,t,n;try{e=l.parse(s.getItem("History.store"))||{}}catch(r){e={}}e.idToState=e.idToState||{},e.urlToId=e.urlToId||{},e.stateToId=e.stateToId||{};for(t in h.idToState){if(!h.idToState.hasOwnProperty(t))continue;e.idToState[t]=h.idToState[t]}for(t in h.urlToId){if(!h.urlToId.hasOwnProperty(t))continue;e.urlToId[t]=h.urlToId[t]}for(t in h.stateToId){if(!h.stateToId.hasOwnProperty(t))continue;e.stateToId[t]=h.stateToId[t]}h.store=e,h.normalizeStore(),n=l.stringify(e);try{s.setItem("History.store",n)}catch(i){if(i.code!==DOMException.QUOTA_EXCEEDED_ERR)throw i;s.length&&(s.removeItem("History.store"),s.setItem("History.store",n))}},h.intervalList.push(a(h.onUnload,h.options.storeInterval)),h.Adapter.bind(e,"beforeunload",h.onUnload),h.Adapter.bind(e,"unload",h.onUnload));if(!h.emulated.pushState){h.bugs.safariPoll&&h.intervalList.push(a(h.safariStatePoll,h.options.safariPollInterval));if(i.vendor==="Apple Computer, Inc."||(i.appCodeName||"")==="Mozilla")h.Adapter.bind(e,"hashchange",function(){h.Adapter.trigger(e,"popstate")}),h.getHash()&&h.Adapter.onDomLoad(function(){h.Adapter.trigger(e,"hashchange")})}},(!h.options||!h.options.delayInit)&&h.init()}(window);
/**
 * UI element: Accessible tooltips for font awesome icons
 * requires: jquery, bootstrap tooltip, font-awesome
 */
var springSpace = springSpace || {};
springSpace.sui = springSpace.sui || {};

/**
 * font-awesome icon accessible tooltip, works on fa icons
 * Requires an element with class icon-label that contains the text. That element should also be .sr-only so it is hidden to browsers but accessible to screen readers.
 * The .icon-label must be the next sibling of the .fa
 * @param {Object} [opts] options object...
 * @param {String} [opts.parent=body] Enable tooltips within this selector
 * @param {String} [opts.placement=top] bootstrap tooltip placement setting (top, bottom, left, right)
 */
springSpace.sui.icontip = function (opts) {
	//Options:
	if (typeof opts == 'undefined') { opts = {}; }
	//are we checking the whole page or just the children of a parent element
	if (!opts.parent) {
		var $parent = $('body');
	} else {
		var $parent = $(opts.parent);
	}
	opts.placement = (opts.placement) ? opts.placement : 'top';
	
	$parent.find('.fa + .icon-label').each(function(i,el){
		//el is the icon-label
		var $label = $(el);
		var title = $label.html();
		if (title !== '') {
			//Is there a parent button/a element, if so we'll put the tooltip on that.
			$parent = $label.parent('button, a');
			if ($parent.length == 0) {
				//it no a/button we'll just use the .fa itself
				var $parent = $label.prev('.fa');	
			}
			if ($parent.length == 1) {
				if ($parent.data && $parent.data('bs.tooltip')) {
					//it already has a tooltip, so stop here
					return;
				}
				//initialize the tooltip
				$parent.tooltip({
					title: title,
					html: true,
					placement: opts.placement
				});
			}
		}
	});	
	
}



/*
	HTML:
	
	<button type="button"><i class="fa fa-info"></i><span class="sr-only icon-label">Information</span></button>
	<a href="#"><i class="fa fa-info"></i><span class="sr-only icon-label">Information</span></a>
	
	The .icon-label must be the next sibling of the i.fa
	.icon-label doesn't have to be .sr-only but it makes things less redundant for visual users
	
	JS:
	springSpace.sui.icontip(); //activate all on page
	springSpace.sui.icontip({ parent: '#loaded' }); //activate all tooltips inside the element with id=loaded
	springSpace.sui.icontip({ parent: '#loaded', placement: 'right' }); //activate all tooltips inside the element with id=loaded and make them open to the right
	
	
*/
;
/*
  Accessibility changes for public and admin pages
*/


/**
 *
 */
function accessibleIcons(parent, opts) {
  if (typeof opts == 'undefined') { opts = {}; }
  if (typeof parent !== 'undefined') {
    opts.parent = parent;
  }
  springSpace.sui.icontip(opts);
}


jQuery(document).ready(function(){


  // Taken from https://github.com/paypal/bootstrap-accessibility-plugin/blob/master/plugins/js/bootstrap-accessibility.js
  // DB added aria-hidden changes
  // DROPDOWN Extension
  // ===============================

  var toggle   = '[data-toggle=dropdown]'
    , $par
    , firstItem
    , focusDelay = 200
    , menus = $(toggle).parent().find('ul').attr('role','menu')
    , lis = menus.find('li').attr('role','presentation')

  lis.find('a').attr({'role':'menuitem', 'tabIndex':'-1'})
  $(toggle).attr({ 'aria-haspopup':'true', 'aria-expanded': 'false'})

  $(toggle).parent().on('shown.bs.dropdown',function(e){
    $par = $(this);
    var $toggle = $par.find(toggle)
    $toggle.attr('aria-expanded','true');

    $par.children('ul').attr('aria-hidden', false);

/*
    setTimeout(function(){
          firstItem = $('.dropdown-menu [role=menuitem]:visible', $par)[0]
          try{ firstItem.focus()} catch(ex) {}
    }, focusDelay)
*/
  })

  $(toggle).parent().on('hidden.bs.dropdown',function(e){
    $par = $(this)
    var $toggle = $par.find(toggle);
    $toggle.attr('aria-expanded','false');
    $par.children('ul').attr('aria-hidden', true);
  })

  //Adding Space Key Behaviour, opens on spacebar
  $.fn.dropdown.Constructor.prototype.keydown = function (e) {
    var  $par
      , firstItem
    if (!/(32)/.test(e.keyCode)) return
      $par = $(this).parent()
      $(this).trigger ("click")
      e.preventDefault() && e.stopPropagation()
  }

  $(document)
    .on('focusout.dropdown.data-api', '.dropdown-menu', function(e){
      var $this = $(this)
                  , that = this
      if ($this.hasClass('multiselect-container')) { return; } //dont want the following action on the multiselect
      setTimeout(function() {
       if(!$.contains(that, document.activeElement)){
        $this.parent().removeClass('open')
        $this.parent().find('[data-toggle=dropdown]').attr('aria-expanded','false')
       }
      }, 150)
     })
    .on('keydown.bs.dropdown.data-api', toggle + ', [role=menu]' , $.fn.dropdown.Constructor.prototype.keydown);

  //end DROPDOWN

  // Tab Extension
  // Taken from https://github.com/paypal/bootstrap-accessibility-plugin/blob/master/plugins/js/bootstrap-accessibility.js
  // ===============================
  var uniqueId = function(prefix) {
        return (prefix || 'ui-id') + '-' + Math.floor((Math.random()*1000)+1)
  }

    var $tablist = $('.nav-tabs')
        , $lis = $tablist.children('li')
        , $tabs = $tablist.find('[data-toggle="tab"], [data-toggle="pill"]');

    if ($tabs.length > 0) {
        $tablist.attr('role', 'tablist')
        $lis.attr('role', 'presentation')
        $tabs.attr('role', 'tab')
    }

    $tabs.each(function( index ) {
      var tabHref = $(this).attr('href')
      var tabpanel = (tabHref === '#') ? null : $(tabHref)
        , tab = $(this)
        , tabid = tab.attr('id') || uniqueId('ui-tab')

        tab.attr('id', tabid)

      if(tab.parent().hasClass('active')){
        tab.attr( { 'tabIndex' : '0', 'aria-selected' : 'true', 'aria-controls': tab.attr('href').substring(1) } )
        if (tabpanel !== null) {
          tabpanel.attr({ 'role' : 'tabpanel', 'tabIndex' : '0', 'aria-hidden' : 'false', 'aria-labelledby':tabid })
        }
      }else{
        tab.attr( { 'tabIndex' : '-1', 'aria-selected' : 'false', 'aria-controls': tab.attr('href').substring(1) } )
        if (tabpanel !== null) {
          tabpanel.attr( { 'role' : 'tabpanel', 'tabIndex' : '-1', 'aria-hidden' : 'true', 'aria-labelledby':tabid } )
        }
      }
    })

    $.fn.tab.Constructor.prototype.keydown = function (e) {
      var $this = $(this)
      , $items
      , $ul = $this.closest('ul[role=tablist] ')
      , index
      , k = e.which || e.keyCode

      $this = $(this)
      if (!/(37|38|39|40)/.test(k)) return

      $items = $ul.find('[role=tab]:visible')
      index = $items.index($items.filter(':focus'))

      if (k == 38 || k == 37) index--                         // up & left
      if (k == 39 || k == 40) index++                        // down & right


      if(index < 0) index = $items.length -1
      if(index == $items.length) index = 0

      var nextTab = $items.eq(index)
      if(nextTab.attr('role') ==='tab'){

        nextTab.tab('show')      //Comment this line for dynamically loaded tabPabels, to save Ajax requests on arrow key navigation
        .focus()
      }
      // nextTab.focus()

      e.preventDefault()
      e.stopPropagation()
    }

    $(document).on('keydown.tab.data-api','[data-toggle="tab"], [data-toggle="pill"]' , $.fn.tab.Constructor.prototype.keydown)

   var tabactivate =    $.fn.tab.Constructor.prototype.activate;
   $.fn.tab.Constructor.prototype.activate = function (element, container, callback) {
      var $active = container.find('> .active')
      $active.find('[data-toggle=tab]').attr({ 'tabIndex' : '-1','aria-selected' : false })
      $active.filter('.tab-pane').attr({ 'aria-hidden' : true,'tabIndex' : '-1' })

      tabactivate.apply(this, arguments)

      element.addClass('active')
      element.find('[data-toggle=tab]').attr({ 'tabIndex' : '0','aria-selected' : true })
      element.filter('.tab-pane').attr({ 'aria-hidden' : false,'tabIndex' : '0' })
   }

   //END TABS


   springSpace.sui.icontip();


   //skip links
  // If there is a '#' in the URL (someone linking directly to a page with an anchor), highlight that section and set focus to it.
  // The tabindex attribute is removed AFTER the user navigates away from the element to help address a nasty VoiceOver bug.

  if (document.location.hash) {
    var myAnchor = document.location.hash;
    try {
      $(myAnchor).attr('tabindex', -1).on('blur focusout', function () {
        $(this).removeAttr('tabindex');
      }).focus();
    } catch(e) { }
  }

  /* This function looks for a change in the hash (activation of an in-page link) and sets focus to and
  highlights the target element. This is necessary because webkit does not set focus as it should. If
  the hash is empty (the user hit the back button after activating an in-page link) focus is set to body.
  */
  $(window).bind('hashchange', function() {
    var hash = "#"+window.location.hash.replace(/^#/,'');
    if (hash!="#") {
      $(hash).attr('tabindex', -1).on('blur focusout', function () {
        $(this).removeAttr('tabindex');
      }).focus();
    } else {
      $("body").attr('tabindex', -1).on('blur focusout', function () {
        $(this).removeAttr('tabindex');
      }).focus();
    }
  });



  // bootstrap-ckeditor-fix.js
  // hack to fix ckeditor/bootstrap compatiability bug when ckeditor appears in a bootstrap modal dialog
  //
  // Include this file AFTER both jQuery and bootstrap are loaded.
  //
  // Found here: http://stackoverflow.com/questions/31678662/ckeditor-issue-with-bootstrap-modal

  $.fn.modal.Constructor.prototype.enforceFocus = function() {
    modal_this = this
    $(document)
      .off('focusin.bs.modal')
      .on('focusin.bs.modal', function (e) {
      if (modal_this.$element[0] !== e.target && !modal_this.$element.has(e.target).length
      && !$( e.target ).closest( '.cke_dialog, .cke' ).length
      ) {
        modal_this.$element.focus()
      }
    })
  };

}); //end document ready
